// src/widgets/apiErrorHandler/apiErrorHandlerProvider.tsx
import { OpenAPI } from "@acme/api/shared";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Fragment, jsx } from "react/jsx-runtime";
var DEFAULT_ERROR_ROUTES = {
  401: "/error/401",
  403: "/error/403",
  500: "/error/500"
};
var ApiErrorHandlerProvider = ({
  children,
  routes = DEFAULT_ERROR_ROUTES
}) => {
  const navigate = useNavigate();
  useEffect(() => {
    OpenAPI.ERROR_ROUTES = routes;
    OpenAPI.ON_ERROR = (errorCode) => {
      const route = routes[errorCode];
      if (route) {
        navigate(route, { replace: true });
      }
    };
  }, [routes, navigate]);
  return /* @__PURE__ */ jsx(Fragment, { children });
};

// src/widgets/application/ui/commission.tsx
import { Separator, renderFieldIfText } from "@acme/foundation";
import { Fragment as Fragment2, jsx as jsx2, jsxs } from "react/jsx-runtime";
var Commission = ({
  fee,
  separateCommissions
}) => {
  if (!fee)
    return null;
  return /* @__PURE__ */ jsxs(Fragment2, { children: [
    /* @__PURE__ */ jsx2(Separator, { className: "-mx-6" }),
    /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-4", children: [
      /* @__PURE__ */ jsx2("div", { className: "text-xl font-semibold text-gray-900", children: "\u041A\u043E\u043C\u0438\u0441\u0441\u0438\u0438" }),
      /* @__PURE__ */ jsx2("div", { className: "grid grid-cols-3 gap-6", children: separateCommissions ? /* @__PURE__ */ jsxs(Fragment2, { children: [
        renderFieldIfText(
          "\u041A\u043E\u043C\u0438\u0441\u0441\u0438\u044F \u0423\u041E, \u0440\u0443\u0431",
          fee.fee != null ? String(fee.fee) : null
        ),
        renderFieldIfText(
          "\u041A\u043E\u043C\u0438\u0441\u0441\u0438\u044F \u0430\u0433\u0435\u043D\u0442\u0430, \u0440\u0443\u0431",
          fee.agentFee != null ? String(fee.agentFee) : null
        )
      ] }) : /* @__PURE__ */ jsx2(Fragment2, { children: renderFieldIfText(
        "\u041A\u043E\u043C\u0438\u0441\u0441\u0438\u044F, \u0440\u0443\u0431",
        fee.fee != null ? String(fee.fee) : null
      ) }) })
    ] })
  ] });
};

// src/widgets/application/ui/agentRequisites.tsx
import { CopyableText, Separator as Separator2, renderFieldIfText as renderFieldIfText2 } from "@acme/foundation";
import { Fragment as Fragment3, jsx as jsx3, jsxs as jsxs2 } from "react/jsx-runtime";
var AgentRequisites = ({
  agentContract
}) => {
  if (!agentContract)
    return null;
  return /* @__PURE__ */ jsxs2(Fragment3, { children: [
    /* @__PURE__ */ jsx3(Separator2, { className: "-mx-6" }),
    /* @__PURE__ */ jsxs2("div", { className: "flex flex-col gap-4", children: [
      /* @__PURE__ */ jsx3("div", { className: "text-xl font-semibold text-gray-900", children: "\u0420\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u044B \u0430\u0433\u0435\u043D\u0442\u0430" }),
      /* @__PURE__ */ jsxs2("div", { className: "grid grid-cols-3 gap-6", children: [
        renderFieldIfText2("\u0421\u0435\u0442\u044C", agentContract.agentWalletNet?.name),
        /* @__PURE__ */ jsxs2("div", { className: "flex flex-col gap-1 flex-1 min-w-0 col-span-2", children: [
          /* @__PURE__ */ jsx3("p", { className: "text-sm text-gray-500", children: "\u041A\u0440\u0438\u043F\u0442\u043E\u0430\u0434\u0440\u0435\u0441 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430 \u0430\u0433\u0435\u043D\u0442\u0430" }),
          /* @__PURE__ */ jsx3(
            CopyableText,
            {
              value: agentContract.agentWallet,
              className: "items-center text-gray-900 text-base font-medium"
            }
          )
        ] })
      ] })
    ] })
  ] });
};

// src/widgets/application/ui/agentContractMainInfo.tsx
import { Separator as Separator3, renderFieldIfText as renderFieldIfText3 } from "@acme/foundation";
import { Fragment as Fragment4, jsx as jsx4, jsxs as jsxs3 } from "react/jsx-runtime";
var AgentContractMainInfo = ({
  agentContract
}) => {
  if (!agentContract)
    return null;
  return /* @__PURE__ */ jsxs3(Fragment4, { children: [
    /* @__PURE__ */ jsx4(Separator3, { className: "-mx-6" }),
    /* @__PURE__ */ jsxs3("div", { className: "flex flex-col gap-4", children: [
      /* @__PURE__ */ jsx4("div", { className: "text-xl font-semibold text-gray-900", children: "\u0414\u0430\u043D\u043D\u044B\u0435 \u043E \u043F\u043B\u0430\u0442\u0435\u043B\u044C\u0449\u0438\u043A\u0435 \u0430\u0433\u0435\u043D\u0442\u0430" }),
      /* @__PURE__ */ jsxs3("div", { className: "grid grid-cols-3 gap-6", children: [
        renderFieldIfText3(
          "\u041D\u0430\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0435 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438",
          agentContract.agentPayerName
        ),
        renderFieldIfText3(
          "\u0421\u0442\u0440\u0430\u043D\u0430 \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u0435\u043B\u044F",
          agentContract.agentPayerCountry?.name
        )
      ] }),
      renderFieldIfText3(
        "\u041D\u0430\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0435 \u0431\u0430\u043D\u043A\u0430",
        agentContract.agentPayerBankName
      )
    ] })
  ] });
};

// src/widgets/application/ui/participants.tsx
import { Field, renderFieldIfText as renderFieldIfText4 } from "@acme/foundation";
import { jsx as jsx5, jsxs as jsxs4 } from "react/jsx-runtime";
var ApplicationParticipants = ({
  participants,
  applicationId
}) => {
  if (!participants?.client)
    return null;
  const org = participants.client.organization;
  const clientPageLink = applicationId != null && applicationId !== "" ? `/application/${applicationId}/client` : void 0;
  const contact = participants.client.contactUser;
  const contactPageLink = applicationId != null && applicationId !== "" ? `/application/${applicationId}/client` : void 0;
  return /* @__PURE__ */ jsxs4("div", { className: "grid grid-cols-3 gap-6", children: [
    clientPageLink && org?.name ? /* @__PURE__ */ jsx5(Field, { label: "\u041A\u043B\u0438\u0435\u043D\u0442", value: org.name, link: clientPageLink }) : renderFieldIfText4("\u041A\u043B\u0438\u0435\u043D\u0442", org?.name),
    contactPageLink && contact?.name ? /* @__PURE__ */ jsx5(
      Field,
      {
        label: "\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u043D\u043E\u0435 \u043B\u0438\u0446\u043E \u043A\u043B\u0438\u0435\u043D\u0442\u0430",
        value: contact.name,
        link: contactPageLink
      }
    ) : renderFieldIfText4("\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u043D\u043E\u0435 \u043B\u0438\u0446\u043E \u043A\u043B\u0438\u0435\u043D\u0442\u0430", contact?.name)
  ] });
};

// src/widgets/application/ui/baseInfo.tsx
import {
  ProcessTypeEnum
} from "@acme/api";
import { Field as Field2 } from "@acme/foundation";
import { Fragment as Fragment5, jsx as jsx6, jsxs as jsxs5 } from "react/jsx-runtime";
var ApplicationBaseInfo = ({
  application,
  contract
}) => {
  return /* @__PURE__ */ jsx6(Fragment5, { children: /* @__PURE__ */ jsxs5("div", { className: "grid grid-cols-3 gap-6", children: [
    /* @__PURE__ */ jsx6(
      Field2,
      {
        label: "\u0422\u0438\u043F \u0437\u0430\u044F\u0432\u043A\u0438",
        value: application?.processType?.id === ProcessTypeEnum.Incoming ? "\u0412\u0445\u043E\u0434\u044F\u0449\u0430\u044F" : "\u0418\u0441\u0445\u043E\u0434\u044F\u0449\u0430\u044F"
      }
    ),
    /* @__PURE__ */ jsx6(Field2, { label: "\u041A\u043E\u043D\u0442\u0440\u0430\u0433\u0435\u043D\u0442", value: contract?.counterparty ?? "-" }),
    /* @__PURE__ */ jsx6(
      Field2,
      {
        label: "\u041F\u0440\u0435\u0434\u043C\u0435\u0442 \u0441\u0434\u0435\u043B\u043A\u0438",
        value: contract?.subjectTransaction ?? "-"
      }
    )
  ] }) });
};

// src/widgets/application/ui/completedBanner.tsx
import { Image } from "@acme/assets";
import { Field as Field3, Separator as Separator4, formatDateTime as formatDateTime2 } from "@acme/foundation";
import { Button } from "flowbite-react";
import { Fragment as Fragment6, jsx as jsx7, jsxs as jsxs6 } from "react/jsx-runtime";
var ApplicationCompletedBanner = ({
  currencySymbol,
  amount,
  amountInRubles,
  completedAt,
  onGoToDocuments
}) => {
  return /* @__PURE__ */ jsxs6(Fragment6, { children: [
    /* @__PURE__ */ jsxs6("div", { className: "flex flex-wrap items-center justify-between gap-4", children: [
      /* @__PURE__ */ jsxs6("div", { className: "flex items-center gap-8", children: [
        /* @__PURE__ */ jsx7("div", { children: /* @__PURE__ */ jsx7(Image, { name: "application-end", width: 160, height: 160 }) }),
        /* @__PURE__ */ jsxs6("div", { children: [
          /* @__PURE__ */ jsx7("p", { className: "text-sm text-gray-600", children: "\u0417\u0430\u044F\u0432\u043A\u0430 \u0438\u0441\u043F\u043E\u043B\u043D\u0435\u043D\u0430" }),
          /* @__PURE__ */ jsx7("div", { className: "text-gray-900", children: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B \u0434\u043B\u044F \u0441\u043A\u0430\u0447\u0438\u0432\u0430\u043D\u0438\u044F" })
        ] })
      ] }),
      onGoToDocuments && /* @__PURE__ */ jsx7(Button, { color: "primary", onClick: onGoToDocuments, children: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043A \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u043C" })
    ] }),
    /* @__PURE__ */ jsx7(Separator4, { className: "-mx-6 my-6" }),
    /* @__PURE__ */ jsxs6("div", { className: "grid grid-cols-4 gap-x-6 gap-y-1", children: [
      /* @__PURE__ */ jsx7(Field3, { label: "\u0412\u0430\u043B\u044E\u0442\u0430 \u0441\u0434\u0435\u043B\u043A\u0438", value: currencySymbol ?? "-" }),
      /* @__PURE__ */ jsx7(
        Field3,
        {
          label: "\u0421\u0443\u043C\u043C\u0430 \u0441\u0434\u0435\u043B\u043A\u0438",
          value: amount != null ? amount.toLocaleString("ru-RU") : "-"
        }
      ),
      /* @__PURE__ */ jsx7(
        Field3,
        {
          label: "\u0421\u0443\u043C\u043C\u0430 \u0441\u0434\u0435\u043B\u043A\u0438 \u0432 \u0440\u0443\u0431\u043B\u044F\u0445",
          value: amountInRubles != null ? amountInRubles.toLocaleString("ru-RU") : "-"
        }
      ),
      /* @__PURE__ */ jsx7(
        Field3,
        {
          label: "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0430",
          value: completedAt ? formatDateTime2(completedAt) : "-"
        }
      )
    ] })
  ] });
};

// src/widgets/application/ui/mainInfo.tsx
import { CopyableText as CopyableText2, renderFieldIfText as renderFieldIfText5 } from "@acme/foundation";
import { jsx as jsx8, jsxs as jsxs7 } from "react/jsx-runtime";
var ApplicationMainInfo = ({
  application,
  contract
}) => {
  return /* @__PURE__ */ jsxs7("div", { className: "flex flex-col gap-6", children: [
    contract?.isCryptoPayment ? /* @__PURE__ */ jsxs7("div", { className: "flex flex-col gap-1 flex-1 min-w-0", children: [
      /* @__PURE__ */ jsx8("p", { className: "text-sm text-gray-500", children: "\u0410\u0434\u0440\u0435\u0441 \u043A\u0440\u0438\u043F\u0442\u043E\u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430" }),
      /* @__PURE__ */ jsx8(
        CopyableText2,
        {
          value: contract?.counterpartyAddress,
          className: "items-center text-gray-900 text-base font-medium"
        }
      )
    ] }) : /* @__PURE__ */ jsxs7("div", { className: "grid grid-cols-3 gap-6", children: [
      renderFieldIfText5("\u0421\u0442\u0440\u0430\u043D\u0430 \u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F", contract?.country?.name),
      renderFieldIfText5("\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0431\u0430\u043D\u043A\u0430", contract?.bankName),
      renderFieldIfText5("\u0410\u0434\u0440\u0435\u0441 \u0431\u0430\u043D\u043A\u0430", contract?.bankAddress),
      renderFieldIfText5("IBAN", contract?.iban),
      renderFieldIfText5("SWIFT/BIC", contract?.swifT_BIC)
    ] }),
    /* @__PURE__ */ jsxs7("div", { className: "grid grid-cols-3 gap-6", children: [
      renderFieldIfText5(
        "\u0421\u0443\u043C\u043C\u0430 \u043A\u0440\u0438\u043F\u0442\u043E\u0432\u0430\u043B\u044E\u0442\u044B",
        contract?.cryptoAmount?.toString()
      ),
      renderFieldIfText5("\u041A\u0440\u0438\u043F\u0442\u043E\u0432\u0430\u043B\u044E\u0442\u0430", contract?.cryptocurrency?.name)
    ] })
  ] });
};

// src/widgets/application/ui/contractInfo.tsx
import { Separator as Separator5, renderFieldIfText as renderFieldIfText6 } from "@acme/foundation";
import { Fragment as Fragment7, jsx as jsx9, jsxs as jsxs8 } from "react/jsx-runtime";
var ContractInfo = ({
  contract
}) => {
  if (!contract)
    return null;
  return /* @__PURE__ */ jsxs8(Fragment7, { children: [
    /* @__PURE__ */ jsx9(Separator5, { className: "-mx-6" }),
    /* @__PURE__ */ jsxs8("div", { className: "flex flex-col gap-6", children: [
      /* @__PURE__ */ jsx9("div", { className: "text-xl font-semibold text-gray-900", children: "\u0414\u0430\u043D\u043D\u044B\u0435 \u043F\u043E \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0443" }),
      /* @__PURE__ */ jsxs8("div", { className: "grid grid-cols-3 gap-6 items-center", children: [
        renderFieldIfText6(
          "\u0423\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u043A\u043E\u043D\u0442\u0440\u0430\u043A\u0442\u0430",
          contract.uniqueContractNumber
        ),
        renderFieldIfText6(
          "\u041D\u043E\u043C\u0435\u0440 \u0432\u043D\u0435\u0448\u043D\u0435\u0442\u043E\u0440\u0433\u043E\u0432\u043E\u0433\u043E \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430",
          contract.foreignTradeAgreementNumber
        )
      ] })
    ] })
  ] });
};

// src/widgets/application/ui/title.tsx
import { Fragment as Fragment8, jsx as jsx10, jsxs as jsxs9 } from "react/jsx-runtime";
var ApplicationTitle = ({
  title,
  currency,
  amount
}) => {
  const currencySymbol = currency?.symbol ?? "";
  return /* @__PURE__ */ jsx10(Fragment8, { children: /* @__PURE__ */ jsxs9("div", { className: "flex items-center justify-between gap-6", children: [
    /* @__PURE__ */ jsx10("div", { className: "flex flex-col", children: /* @__PURE__ */ jsx10("h2", { className: "text-xl font-semibold", children: title }) }),
    /* @__PURE__ */ jsx10("div", { className: "text-right", children: amount != null ? /* @__PURE__ */ jsxs9("div", { className: "text-xl font-semibold text-gray-900", children: [
      amount.toLocaleString("ru-RU"),
      /* @__PURE__ */ jsx10("span", { className: "ml-2  text-gray-500", children: currencySymbol || currency?.name })
    ] }) : /* @__PURE__ */ jsx10("div", { className: "text-xl font-semibold text-gray-900", children: "-" }) })
  ] }) });
};

// src/features/actions/lib/findActions.ts
function findAction(actions, kind, subKind) {
  if (!actions?.length)
    return null;
  if (subKind == null) {
    return actions.find((a) => a.kind === kind) ?? null;
  }
  return actions.find((a) => a.kind === kind && a.subKind === subKind) ?? null;
}

// src/features/actions/lib/isShow.ts
function isShow(actions, kind, subKind) {
  if (!actions?.length)
    return false;
  if (subKind == null) {
    return actions.some((a) => a.kind === kind);
  }
  return actions.some((a) => a.kind === kind && a.subKind === subKind);
}

// src/widgets/applicationActions/ui/index.tsx
import {
  DefinitionActionKindEnum,
  DefinitionActionSubKindEnum
} from "@acme/api";
import { useModal } from "@acme/foundation";
import { Button as Button2 } from "flowbite-react";

// src/widgets/applicationActions/ui/confirmModalByType.ts
var CONFIRM_TYPE_MODALS = {
  Application_AuthorizedOrganizationFromDraft: {
    title: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C \u0437\u0430\u044F\u0432\u043A\u0443",
    content: "\u041F\u043E\u0441\u043B\u0435 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u0437\u0430\u044F\u0432\u043A\u0438, \u0432\u044B \u043F\u0435\u0440\u0435\u0439\u0434\u0435\u0442\u0435 \u043A \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044E \u0434\u0430\u043D\u043D\u044B\u0445 \u043E \u043A\u043E\u043C\u0438\u0441\u0441\u0438\u0438"
  }
};
function getConfirmModalFromAction(action) {
  const confirmType = action?.arguments?.confirmType;
  if (typeof confirmType === "string" && CONFIRM_TYPE_MODALS[confirmType]) {
    return CONFIRM_TYPE_MODALS[confirmType];
  }
  return null;
}

// src/widgets/applicationActions/ui/index.tsx
import { jsx as jsx11, jsxs as jsxs10 } from "react/jsx-runtime";
var DEFAULT_CONFIRM_TITLE = "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435?";
var DEFAULT_CONFIRM_CONTENT = "\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B?";
function useRunWithConfirm() {
  const { openConfirmModal } = useModal();
  return async (action, run, actionResponse) => {
    if (!action?.handler)
      return;
    const customModal = actionResponse ? getConfirmModalFromAction(actionResponse) : null;
    const needConfirm = action.confirmModal ?? customModal;
    if (needConfirm) {
      const title = customModal?.title ?? action.confirmModal?.title ?? DEFAULT_CONFIRM_TITLE;
      const content = customModal?.content ?? action.confirmModal?.content ?? DEFAULT_CONFIRM_CONTENT;
      const ok = await openConfirmModal({ title, content });
      if (!ok)
        return;
    }
    run();
  };
}
function ActionButton({ visible, label, color, onClick }) {
  if (!visible || label == null)
    return null;
  return /* @__PURE__ */ jsx11(Button2, { color, className: "whitespace-nowrap", onClick, children: label });
}
var ApplicationActions = ({
  actions,
  confirm,
  upload,
  sign,
  reject,
  rework,
  delete: deleteAction,
  form,
  confirmDealUpload
}) => {
  const runWithConfirm = useRunWithConfirm();
  const uploadConfirmDealAction = actions?.find(
    (a) => a.kind === DefinitionActionKindEnum.Upload && (a.subKind === null || a.subKind === void 0)
  ) ?? null;
  const confirmAction = findAction(actions, DefinitionActionKindEnum.Confirm);
  const signContractAction = actions?.find(
    (a) => a.kind === DefinitionActionKindEnum.Sign && (a.subKind === null || a.subKind === void 0)
  ) ?? null;
  return /* @__PURE__ */ jsxs10("div", { className: "flex justify-end gap-4", children: [
    /* @__PURE__ */ jsxs10("div", { className: "flex gap-4", children: [
      isShow(
        actions,
        DefinitionActionKindEnum.Form,
        DefinitionActionSubKindEnum.FormEditDraft
      ) && rework?.editDraft?.handler && /* @__PURE__ */ jsx11(
        ActionButton,
        {
          visible: true,
          label: findAction(
            actions,
            DefinitionActionKindEnum.Form,
            DefinitionActionSubKindEnum.FormEditDraft
          )?.name,
          color: "alternative",
          onClick: () => runWithConfirm(
            rework?.editDraft,
            () => rework?.editDraft?.handler()
          )
        }
      ),
      isShow(actions, DefinitionActionKindEnum.Rework) && rework?.handler && /* @__PURE__ */ jsx11(
        ActionButton,
        {
          visible: true,
          label: findAction(actions, DefinitionActionKindEnum.Rework)?.name,
          color: "alternative",
          onClick: () => rework.handler()
        }
      )
    ] }),
    /* @__PURE__ */ jsxs10("div", { className: "flex justify-end gap-4", children: [
      isShow(actions, DefinitionActionKindEnum.Delete) && deleteAction?.handler && /* @__PURE__ */ jsx11(
        ActionButton,
        {
          visible: true,
          label: findAction(actions, DefinitionActionKindEnum.Delete)?.name,
          color: "red",
          onClick: () => runWithConfirm(deleteAction, () => deleteAction?.handler())
        }
      ),
      isShow(actions, DefinitionActionKindEnum.Reject) && reject?.handler && /* @__PURE__ */ jsx11(
        ActionButton,
        {
          visible: true,
          label: findAction(actions, DefinitionActionKindEnum.Reject)?.name,
          color: "red",
          onClick: () => runWithConfirm(reject, () => reject?.handler())
        }
      ),
      uploadConfirmDealAction && confirmDealUpload?.handler && /* @__PURE__ */ jsx11(
        ActionButton,
        {
          visible: true,
          label: uploadConfirmDealAction.name,
          color: "primary",
          onClick: () => runWithConfirm(
            confirmDealUpload,
            () => confirmDealUpload.handler(uploadConfirmDealAction.id)
          )
        }
      ),
      isShow(
        actions,
        DefinitionActionKindEnum.Upload,
        DefinitionActionSubKindEnum.UploadClientPaymentDoc
      ) && upload?.uploadClientPaymentDoc?.handler && /* @__PURE__ */ jsx11(
        ActionButton,
        {
          visible: true,
          label: findAction(
            actions,
            DefinitionActionKindEnum.Upload,
            DefinitionActionSubKindEnum.UploadClientPaymentDoc
          )?.name,
          color: "primary",
          onClick: () => runWithConfirm(
            upload?.uploadClientPaymentDoc,
            () => upload?.uploadClientPaymentDoc?.handler()
          )
        }
      ),
      isShow(
        actions,
        DefinitionActionKindEnum.Upload,
        DefinitionActionSubKindEnum.UploadAdminToProviderDoc
      ) && upload?.uploadAdminToProviderDoc?.handler && /* @__PURE__ */ jsx11(
        ActionButton,
        {
          visible: true,
          label: findAction(
            actions,
            DefinitionActionKindEnum.Upload,
            DefinitionActionSubKindEnum.UploadAdminToProviderDoc
          )?.name,
          color: "primary",
          onClick: () => runWithConfirm(
            upload?.uploadAdminToProviderDoc,
            () => upload?.uploadAdminToProviderDoc?.handler()
          )
        }
      ),
      isShow(
        actions,
        DefinitionActionKindEnum.Upload,
        DefinitionActionSubKindEnum.UploadTransferCommessionRecepotDoc
      ) && upload?.uploadTransferCommessionRecepotDoc?.handler && /* @__PURE__ */ jsx11(
        ActionButton,
        {
          visible: true,
          label: findAction(
            actions,
            DefinitionActionKindEnum.Upload,
            DefinitionActionSubKindEnum.UploadTransferCommessionRecepotDoc
          )?.name,
          color: "primary",
          onClick: () => runWithConfirm(
            upload?.uploadTransferCommessionRecepotDoc,
            () => upload?.uploadTransferCommessionRecepotDoc?.handler()
          )
        }
      ),
      isShow(
        actions,
        DefinitionActionKindEnum.Upload,
        DefinitionActionSubKindEnum.UploadTransferRecepotDoc
      ) && upload?.uploadTransferRecepotDoc?.handler && /* @__PURE__ */ jsx11(
        ActionButton,
        {
          visible: true,
          label: findAction(
            actions,
            DefinitionActionKindEnum.Upload,
            DefinitionActionSubKindEnum.UploadTransferRecepotDoc
          )?.name,
          color: "primary",
          onClick: () => runWithConfirm(
            upload?.uploadTransferRecepotDoc,
            () => upload?.uploadTransferRecepotDoc?.handler()
          )
        }
      ),
      signContractAction && sign?.signContract?.handler && /* @__PURE__ */ jsx11(
        ActionButton,
        {
          visible: true,
          label: signContractAction.name,
          color: "primary",
          onClick: () => runWithConfirm(
            sign?.signContract,
            () => sign?.signContract?.handler()
          )
        }
      ),
      isShow(
        actions,
        DefinitionActionKindEnum.Sign,
        DefinitionActionSubKindEnum.SignExchangeContract
      ) && sign?.signExchangeContract?.handler && /* @__PURE__ */ jsx11(
        ActionButton,
        {
          visible: true,
          label: findAction(
            actions,
            DefinitionActionKindEnum.Sign,
            DefinitionActionSubKindEnum.SignExchangeContract
          )?.name,
          color: "primary",
          onClick: () => runWithConfirm(
            sign?.signExchangeContract,
            () => sign?.signExchangeContract?.handler(
              findAction(
                actions,
                DefinitionActionKindEnum.Sign,
                DefinitionActionSubKindEnum.SignExchangeContract
              )?.id
            )
          )
        }
      ),
      isShow(
        actions,
        DefinitionActionKindEnum.Sign,
        DefinitionActionSubKindEnum.SignExchangeAct
      ) && sign?.signExchangeAct?.handler && /* @__PURE__ */ jsx11(
        ActionButton,
        {
          visible: true,
          label: findAction(
            actions,
            DefinitionActionKindEnum.Sign,
            DefinitionActionSubKindEnum.SignExchangeAct
          )?.name,
          color: "primary",
          onClick: () => runWithConfirm(
            sign?.signExchangeAct,
            () => sign?.signExchangeAct?.handler(
              findAction(
                actions,
                DefinitionActionKindEnum.Sign,
                DefinitionActionSubKindEnum.SignExchangeAct
              )?.id
            )
          )
        }
      ),
      isShow(
        actions,
        DefinitionActionKindEnum.Sign,
        DefinitionActionSubKindEnum.SignTransferContract
      ) && sign?.signTransferContract?.handler && /* @__PURE__ */ jsx11(
        ActionButton,
        {
          visible: true,
          label: findAction(
            actions,
            DefinitionActionKindEnum.Sign,
            DefinitionActionSubKindEnum.SignTransferContract
          )?.name,
          color: "primary",
          onClick: () => runWithConfirm(
            sign?.signTransferContract,
            () => sign?.signTransferContract?.handler(
              findAction(
                actions,
                DefinitionActionKindEnum.Sign,
                DefinitionActionSubKindEnum.SignTransferContract
              )?.id
            )
          )
        }
      ),
      isShow(
        actions,
        DefinitionActionKindEnum.Sign,
        DefinitionActionSubKindEnum.SignTransferAct
      ) && sign?.signTransferAct?.handler && /* @__PURE__ */ jsx11(
        ActionButton,
        {
          visible: true,
          label: findAction(
            actions,
            DefinitionActionKindEnum.Sign,
            DefinitionActionSubKindEnum.SignTransferAct
          )?.name,
          color: "primary",
          onClick: () => runWithConfirm(
            sign?.signTransferAct,
            () => sign?.signTransferAct?.handler(
              findAction(
                actions,
                DefinitionActionKindEnum.Sign,
                DefinitionActionSubKindEnum.SignTransferAct
              )?.id
            )
          )
        }
      ),
      isShow(
        actions,
        DefinitionActionKindEnum.Form,
        DefinitionActionSubKindEnum.FormEditApplication
      ) && form?.formEditApplication?.handler && /* @__PURE__ */ jsx11(
        ActionButton,
        {
          visible: true,
          label: findAction(
            actions,
            DefinitionActionKindEnum.Form,
            DefinitionActionSubKindEnum.FormEditApplication
          )?.name,
          color: "primary",
          onClick: () => runWithConfirm(
            form?.formEditApplication,
            () => form?.formEditApplication?.handler()
          )
        }
      ),
      isShow(
        actions,
        DefinitionActionKindEnum.Form,
        DefinitionActionSubKindEnum.FormAgentInfo
      ) && form?.formAgentInfo?.handler && /* @__PURE__ */ jsx11(
        ActionButton,
        {
          visible: true,
          label: findAction(
            actions,
            DefinitionActionKindEnum.Form,
            DefinitionActionSubKindEnum.FormAgentInfo
          )?.name,
          color: "primary",
          onClick: () => runWithConfirm(
            form?.formAgentInfo,
            () => form?.formAgentInfo?.handler()
          )
        }
      ),
      isShow(
        actions,
        DefinitionActionKindEnum.Form,
        DefinitionActionSubKindEnum.FormCounterpartyInfo
      ) && form?.formCounterpartyInfo?.handler && /* @__PURE__ */ jsx11(
        ActionButton,
        {
          visible: true,
          label: findAction(
            actions,
            DefinitionActionKindEnum.Form,
            DefinitionActionSubKindEnum.FormCounterpartyInfo
          )?.name,
          color: "primary",
          onClick: () => runWithConfirm(
            form?.formCounterpartyInfo,
            () => form?.formCounterpartyInfo?.handler()
          )
        }
      ),
      isShow(
        actions,
        DefinitionActionKindEnum.Form,
        DefinitionActionSubKindEnum.FormExchangeRates
      ) && form?.formExchangeRates?.handler && /* @__PURE__ */ jsx11(
        ActionButton,
        {
          visible: true,
          label: findAction(
            actions,
            DefinitionActionKindEnum.Form,
            DefinitionActionSubKindEnum.FormExchangeRates
          )?.name,
          color: "primary",
          onClick: () => runWithConfirm(
            form?.formExchangeRates,
            () => form?.formExchangeRates?.handler()
          )
        }
      ),
      isShow(
        actions,
        DefinitionActionKindEnum.Form,
        DefinitionActionSubKindEnum.FormWalletsWhichTransfer
      ) && form?.formWalletsWhichTransfer?.handler && /* @__PURE__ */ jsx11(
        ActionButton,
        {
          visible: true,
          label: findAction(
            actions,
            DefinitionActionKindEnum.Form,
            DefinitionActionSubKindEnum.FormWalletsWhichTransfer
          )?.name,
          color: "primary",
          onClick: () => runWithConfirm(
            form?.formWalletsWhichTransfer,
            () => form?.formWalletsWhichTransfer?.handler()
          )
        }
      ),
      isShow(
        actions,
        DefinitionActionKindEnum.Form,
        DefinitionActionSubKindEnum.FormProvideWallets
      ) && form?.formProvideWallets?.handler && /* @__PURE__ */ jsx11(
        ActionButton,
        {
          visible: true,
          label: findAction(
            actions,
            DefinitionActionKindEnum.Form,
            DefinitionActionSubKindEnum.FormProvideWallets
          )?.name,
          color: "primary",
          onClick: () => runWithConfirm(
            form?.formProvideWallets,
            () => form?.formProvideWallets?.handler()
          )
        }
      ),
      isShow(
        actions,
        DefinitionActionKindEnum.Form,
        DefinitionActionSubKindEnum.FormTransferProvideWallets
      ) && form?.formTransferProvideWallets?.handler && /* @__PURE__ */ jsx11(
        ActionButton,
        {
          visible: true,
          label: findAction(
            actions,
            DefinitionActionKindEnum.Form,
            DefinitionActionSubKindEnum.FormTransferProvideWallets
          )?.name,
          color: "primary",
          onClick: () => runWithConfirm(
            form?.formTransferProvideWallets,
            () => form?.formTransferProvideWallets?.handler()
          )
        }
      ),
      isShow(
        actions,
        DefinitionActionKindEnum.Form,
        DefinitionActionSubKindEnum.FormTransferFiat
      ) && form?.formTransferFiat?.handler && /* @__PURE__ */ jsx11(
        ActionButton,
        {
          visible: true,
          label: findAction(
            actions,
            DefinitionActionKindEnum.Form,
            DefinitionActionSubKindEnum.FormTransferFiat
          )?.name,
          color: "primary",
          onClick: () => runWithConfirm(
            form?.formTransferFiat,
            () => form?.formTransferFiat?.handler()
          )
        }
      ),
      isShow(
        actions,
        DefinitionActionKindEnum.Form,
        DefinitionActionSubKindEnum.FormTransactionId
      ) && form?.formTransactionId?.handler && /* @__PURE__ */ jsx11(
        ActionButton,
        {
          visible: true,
          label: findAction(
            actions,
            DefinitionActionKindEnum.Form,
            DefinitionActionSubKindEnum.FormTransactionId
          )?.name,
          color: "primary",
          onClick: () => runWithConfirm(
            form?.formTransactionId,
            () => form?.formTransactionId?.handler()
          )
        }
      ),
      isShow(actions, DefinitionActionKindEnum.Confirm) && confirm?.handler && /* @__PURE__ */ jsx11(
        ActionButton,
        {
          visible: true,
          label: findAction(actions, DefinitionActionKindEnum.Confirm)?.name,
          color: "primary",
          onClick: () => runWithConfirm(
            confirm,
            () => confirm?.handler(confirmAction?.id),
            confirmAction
          )
        }
      )
    ] })
  ] });
};

// src/widgets/applicationActions/ui/actionResultScreen.tsx
import { Icon, Image as Image2 } from "@acme/assets";
import { Card } from "flowbite-react";
import { jsx as jsx12, jsxs as jsxs11 } from "react/jsx-runtime";
var ActionResultScreen = ({
  isError,
  applicationCode,
  actionName,
  customResult,
  onBack
}) => {
  const title = customResult?.title ?? (applicationCode && actionName ? isError ? `\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u0435 \u0434\u043B\u044F \u0437\u0430\u044F\u0432\u043A\u0438 ${applicationCode} \u0437\u0430\u0432\u0435\u0440\u0448\u0438\u043B\u043E\u0441\u044C \u0441 \u043E\u0448\u0438\u0431\u043A\u043E\u0439` : `\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u0435 \u0434\u043B\u044F \u0437\u0430\u044F\u0432\u043A\u0438 ${applicationCode} \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u043E` : isError ? "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430" : "\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u0435 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u043E");
  const content = customResult?.content;
  return /* @__PURE__ */ jsx12("div", { className: "w-full h-full flex items-center justify-center min-w-112", children: /* @__PURE__ */ jsxs11(Card, { className: "p-6 flex flex-col justify-center items-center max-w-xl", children: [
    /* @__PURE__ */ jsx12("div", { className: "flex justify-center items-center", children: isError ? /* @__PURE__ */ jsx12("div", { className: "p-4 rounded-full text-red-600 bg-red-100 flex items-center justify-center", children: /* @__PURE__ */ jsx12(Icon, { size: 24, name: "x-outline" }) }) : /* @__PURE__ */ jsx12(Image2, { name: "application-succes", width: 160, height: 160 }) }),
    /* @__PURE__ */ jsxs11("div", { className: "text-center", children: [
      /* @__PURE__ */ jsx12("div", { className: "font-medium", children: title }),
      content && /* @__PURE__ */ jsx12("div", { className: "text-gray-500", children: content })
    ] }),
    /* @__PURE__ */ jsx12("div", { className: "text-center items-center flex w-full", children: /* @__PURE__ */ jsxs11(
      "div",
      {
        className: "flex justify-center items-center gap-1 cursor-pointer mx-auto",
        onClick: onBack,
        children: [
          /* @__PURE__ */ jsx12(Icon, { name: "arrow-left" }),
          " ",
          customResult?.linkText ?? "\u0412\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u043A \u0437\u0430\u044F\u0432\u043A\u0435"
        ]
      }
    ) })
  ] }) });
};

// src/widgets/applicationActions/ui/provideWalletsModal.tsx
import { Button as Button3, Label, TextInput } from "flowbite-react";
import { useState } from "react";
import { jsx as jsx13, jsxs as jsxs12 } from "react/jsx-runtime";
var ProvideWalletsModal = ({
  onConfirm,
  onCancel
}) => {
  const [walletAddress, setWalletAddress] = useState("");
  const [comment, setComment] = useState("");
  const [error, setError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSubmit = async () => {
    setError(null);
    const trimmed = walletAddress.trim();
    if (!trimmed) {
      setError("\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0430\u0434\u0440\u0435\u0441 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430");
      return;
    }
    setIsSubmitting(true);
    try {
      await onConfirm({
        walletAddress: trimmed,
        comment: comment.trim() || void 0
      });
    } catch (e) {
      setError(e instanceof Error ? e.message : "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0441\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C");
    } finally {
      setIsSubmitting(false);
    }
  };
  return /* @__PURE__ */ jsxs12("div", { className: "space-y-6", children: [
    /* @__PURE__ */ jsxs12("div", { children: [
      /* @__PURE__ */ jsx13(Label, { htmlFor: "provide-wallets-address", className: "mb-2 block", children: "\u041A\u0440\u0438\u043F\u0442\u043E\u043A\u043E\u0448\u0435\u043B\u0451\u043A, \u043A\u0443\u0434\u0430 \u043F\u043B\u0430\u043D\u0438\u0440\u0443\u0435\u0442\u0441\u044F \u043F\u0435\u0440\u0435\u0432\u043E\u0434" }),
      /* @__PURE__ */ jsx13(
        TextInput,
        {
          id: "provide-wallets-address",
          type: "text",
          placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0430\u0434\u0440\u0435\u0441 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430",
          value: walletAddress,
          onChange: (e) => setWalletAddress(e.target.value),
          className: "w-full"
        }
      )
    ] }),
    error && /* @__PURE__ */ jsx13("p", { className: "text-sm text-red-600", children: error }),
    /* @__PURE__ */ jsxs12("div", { className: "flex gap-4 border-t border-gray-200 pt-4", children: [
      /* @__PURE__ */ jsx13(Button3, { color: "primary", onClick: handleSubmit, disabled: isSubmitting, children: isSubmitting ? "\u0421\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0435..." : "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C" }),
      /* @__PURE__ */ jsx13(Button3, { color: "light", onClick: onCancel, disabled: isSubmitting, children: "\u041E\u0442\u043C\u0435\u043D\u0430" })
    ] })
  ] });
};

// src/widgets/applicationActions/ui/rejectModal.tsx
import { Button as Button4, Textarea } from "flowbite-react";
import { useState as useState2 } from "react";
import { jsx as jsx14, jsxs as jsxs13 } from "react/jsx-runtime";
var RejectModal = ({ onConfirm, onCancel }) => {
  const [comment, setComment] = useState2("");
  return /* @__PURE__ */ jsxs13("div", { className: "space-y-6", children: [
    /* @__PURE__ */ jsxs13("div", { children: [
      /* @__PURE__ */ jsx14("p", { className: "text-sm font-medium text-gray-900 mb-2", children: "\u041D\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u043F\u0440\u0438\u0447\u0438\u043D\u0443 \u043E\u0442\u043A\u043B\u043E\u043D\u0435\u043D\u0438\u044F" }),
      /* @__PURE__ */ jsx14(
        Textarea,
        {
          value: comment,
          onChange: (e) => setComment(e.target.value),
          placeholder: "\u041A\u043E\u043D\u0442\u0440\u0430\u0433\u0435\u043D\u0442 Global Finance Inc \u043F\u043E\u043F\u0430\u043B \u0432 \u0441\u0430\u043D\u043A\u0446\u0438\u043E\u043D\u043D\u044B\u0435 \u0441\u043F\u0438\u0441\u043A\u0438",
          rows: 4,
          className: "w-full"
        }
      )
    ] }),
    /* @__PURE__ */ jsxs13("div", { className: "flex gap-4 border-t border-gray-200 pt-4", children: [
      /* @__PURE__ */ jsx14(Button4, { color: "red", onClick: () => onConfirm(comment), children: "\u041E\u0442\u043A\u043B\u043E\u043D\u0438\u0442\u044C" }),
      /* @__PURE__ */ jsx14(Button4, { color: "light", onClick: onCancel, children: "\u041E\u0442\u043C\u0435\u043D\u0430" })
    ] })
  ] });
};

// src/widgets/applicationActions/ui/reworkModal.tsx
import { Button as Button5, Textarea as Textarea2 } from "flowbite-react";
import { useState as useState3 } from "react";
import { jsx as jsx15, jsxs as jsxs14 } from "react/jsx-runtime";
var ReworkModal = ({ onConfirm, onCancel }) => {
  const [comment, setComment] = useState3("");
  return /* @__PURE__ */ jsxs14("div", { className: "space-y-6", children: [
    /* @__PURE__ */ jsxs14("div", { children: [
      /* @__PURE__ */ jsx15("p", { className: "text-sm font-medium text-gray-900 mb-2", children: "\u0422\u0440\u0435\u0431\u0443\u044E\u0442\u0441\u044F \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F" }),
      /* @__PURE__ */ jsx15(
        Textarea2,
        {
          value: comment,
          onChange: (e) => setComment(e.target.value),
          placeholder: "\u041E\u0431\u044A\u044F\u0441\u043D\u0438\u0442\u0435 \u043A\u043B\u0438\u0435\u043D\u0442\u0443 \u043A\u0430\u043A \u043C\u043E\u0436\u043D\u043E \u0440\u0435\u0448\u0438\u0442\u044C \u0432\u043E\u0437\u043D\u0438\u043A\u0448\u0443\u044E \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0443",
          rows: 4,
          className: "w-full"
        }
      )
    ] }),
    /* @__PURE__ */ jsxs14("div", { className: "flex gap-4 border-t border-gray-200 pt-4", children: [
      /* @__PURE__ */ jsx15(Button5, { color: "primary", onClick: () => onConfirm(comment), children: "\u0418\u0441\u043F\u0440\u0430\u0432\u0438\u0442\u044C" }),
      /* @__PURE__ */ jsx15(Button5, { color: "light", onClick: onCancel, children: "\u041E\u0442\u043C\u0435\u043D\u0430" })
    ] })
  ] });
};

// src/widgets/applicationActions/ui/transactionIdModal.tsx
import { Button as Button6, Label as Label2, TextInput as TextInput2, Textarea as Textarea3 } from "flowbite-react";
import { useState as useState4 } from "react";
import { jsx as jsx16, jsxs as jsxs15 } from "react/jsx-runtime";
var TransactionIdModal = ({
  onConfirm,
  onCancel
}) => {
  const [txId, setTxId] = useState4("");
  const [comment, setComment] = useState4("");
  const [error, setError] = useState4(null);
  const handleSubmit = () => {
    setError(null);
    const trimmed = txId.trim();
    if (!trimmed) {
      setError("\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438");
      return;
    }
    onConfirm({ txId: trimmed, comment: comment.trim() || void 0 });
  };
  return /* @__PURE__ */ jsxs15("div", { className: "space-y-6", children: [
    /* @__PURE__ */ jsxs15("div", { children: [
      /* @__PURE__ */ jsx16(Label2, { htmlFor: "transaction-id", className: "mb-2 block", children: "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438" }),
      /* @__PURE__ */ jsx16(
        TextInput2,
        {
          id: "transaction-id",
          type: "text",
          placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 ID \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438",
          value: txId,
          onChange: (e) => setTxId(e.target.value),
          className: "w-full"
        }
      )
    ] }),
    /* @__PURE__ */ jsxs15("div", { children: [
      /* @__PURE__ */ jsx16(Label2, { htmlFor: "transaction-id-comment", className: "mb-2 block", children: "\u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439" }),
      /* @__PURE__ */ jsx16(
        Textarea3,
        {
          id: "transaction-id-comment",
          value: comment,
          onChange: (e) => setComment(e.target.value),
          placeholder: "\u041D\u0435\u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E",
          rows: 3,
          className: "w-full"
        }
      )
    ] }),
    error && /* @__PURE__ */ jsx16("p", { className: "text-sm text-red-600", children: error }),
    /* @__PURE__ */ jsxs15("div", { className: "flex gap-4 border-t border-gray-200 pt-4", children: [
      /* @__PURE__ */ jsx16(Button6, { color: "primary", onClick: handleSubmit, children: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435" }),
      /* @__PURE__ */ jsx16(Button6, { color: "light", onClick: onCancel, children: "\u041E\u0442\u043C\u0435\u043D\u0430" })
    ] })
  ] });
};

// src/widgets/applicationActions/ui/transferFiatModal.tsx
import { Button as Button7, Label as Label3, TextInput as TextInput3, Textarea as Textarea4 } from "flowbite-react";
import { useState as useState5 } from "react";
import { jsx as jsx17, jsxs as jsxs16 } from "react/jsx-runtime";
var TransferFiatModal = ({
  onConfirm,
  onCancel
}) => {
  const [fiatAmount, setFiatAmount] = useState5("");
  const [comment, setComment] = useState5("");
  const [error, setError] = useState5(null);
  const handleSubmit = () => {
    setError(null);
    const amount = fiatAmount.trim() ? Number(fiatAmount.replace(/\s/g, "")) : NaN;
    if (Number.isNaN(amount) || amount <= 0) {
      setError("\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u0443\u044E \u0441\u0443\u043C\u043C\u0443");
      return;
    }
    onConfirm({ fiatAmount: amount, comment: comment.trim() || void 0 });
  };
  return /* @__PURE__ */ jsxs16("div", { className: "space-y-6", children: [
    /* @__PURE__ */ jsxs16("div", { children: [
      /* @__PURE__ */ jsx17(Label3, { htmlFor: "transfer-fiat-amount", className: "mb-2 block", children: "\u0421\u0443\u043C\u043C\u0430 (RUB)" }),
      /* @__PURE__ */ jsx17(
        TextInput3,
        {
          id: "transfer-fiat-amount",
          type: "text",
          placeholder: "0",
          value: fiatAmount,
          onChange: (e) => setFiatAmount(e.target.value),
          className: "w-full"
        }
      )
    ] }),
    /* @__PURE__ */ jsxs16("div", { children: [
      /* @__PURE__ */ jsx17(Label3, { htmlFor: "transfer-fiat-comment", className: "mb-2 block", children: "\u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439" }),
      /* @__PURE__ */ jsx17(
        Textarea4,
        {
          id: "transfer-fiat-comment",
          value: comment,
          onChange: (e) => setComment(e.target.value),
          placeholder: "\u041D\u0435\u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E",
          rows: 3,
          className: "w-full"
        }
      )
    ] }),
    error && /* @__PURE__ */ jsx17("p", { className: "text-sm text-red-600", children: error }),
    /* @__PURE__ */ jsxs16("div", { className: "flex gap-4 border-t border-gray-200 pt-4", children: [
      /* @__PURE__ */ jsx17(Button7, { color: "primary", onClick: handleSubmit, children: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C" }),
      /* @__PURE__ */ jsx17(Button7, { color: "light", onClick: onCancel, children: "\u041E\u0442\u043C\u0435\u043D\u0430" })
    ] })
  ] });
};

// src/widgets/applicationActions/ui/uploadDocumentModal.tsx
import { FileUpload } from "@acme/foundation";
import { Button as Button8, Label as Label4 } from "flowbite-react";
import { useCallback, useMemo, useState as useState6 } from "react";
import { jsx as jsx18, jsxs as jsxs17 } from "react/jsx-runtime";
var MAX_FILE_SIZE_MB = 10;
var UploadDocumentModal = ({
  onConfirm,
  onCancel
}) => {
  const [file, setFile] = useState6(null);
  const [isSubmitting, setIsSubmitting] = useState6(false);
  const [error, setError] = useState6(null);
  const onFileSelect = useCallback((files) => {
    setError(null);
    setFile(files[0] ?? null);
  }, []);
  const onFileRemove = useCallback(() => {
    setFile(null);
  }, []);
  const uploadingFiles = useMemo(
    () => file ? [
      {
        id: "selected",
        file,
        status: "completed",
        progress: 100
      }
    ] : [],
    [file]
  );
  const handleSubmit = useCallback(async () => {
    if (!file) {
      setError("\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0444\u0430\u0439\u043B");
      return;
    }
    setError(null);
    setIsSubmitting(true);
    try {
      await onConfirm(file);
    } catch {
      setError("\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442");
    } finally {
      setIsSubmitting(false);
    }
  }, [file, onConfirm]);
  return /* @__PURE__ */ jsxs17("div", { className: "space-y-6", children: [
    /* @__PURE__ */ jsxs17("div", { children: [
      /* @__PURE__ */ jsx18("div", { className: "text-sm text-gray-500 mb-4", children: "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u0435 \u043F\u043B\u0430\u0442\u0435\u0436\u043D\u043E\u0435 \u043F\u043E\u0440\u0443\u0447\u0435\u043D\u0438\u0435 \u043E\u0442 \u0430\u0433\u0435\u043D\u0442\u0430 \u043E \u0442\u043E\u043C, \u0447\u0442\u043E \u0444\u0438\u0430\u0442 \u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D." }),
      /* @__PURE__ */ jsx18(Label4, { className: "mb-2 block", children: "\u041F\u0440\u0438\u043A\u0440\u0435\u043F\u043B\u0435\u043D\u043D\u044B\u0435 \u0444\u0430\u0439\u043B\u044B" }),
      /* @__PURE__ */ jsx18(
        FileUpload,
        {
          accept: ".pdf,.docx,.png,.jpg,.jpeg",
          maxSize: MAX_FILE_SIZE_MB,
          multiple: false,
          onFileSelect,
          onFileRemove,
          uploadingFiles
        }
      )
    ] }),
    error && /* @__PURE__ */ jsx18("p", { className: "text-sm text-red-600", children: error }),
    /* @__PURE__ */ jsxs17("div", { className: "flex gap-4 border-t border-gray-200 pt-4", children: [
      /* @__PURE__ */ jsx18(
        Button8,
        {
          color: "primary",
          onClick: handleSubmit,
          disabled: !file || isSubmitting,
          children: isSubmitting ? "\u041E\u0442\u043F\u0440\u0430\u0432\u043A\u0430..." : "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C"
        }
      ),
      /* @__PURE__ */ jsx18(Button8, { color: "light", onClick: onCancel, disabled: isSubmitting, children: "\u041E\u0442\u043C\u0435\u043D\u0430" })
    ] })
  ] });
};

// src/widgets/applicationActivity/ui/index.tsx
import { Tabs } from "@acme/foundation";
import { createTheme } from "flowbite-react";

// src/features/applicationComments/ui/applicationcomments.tsx
import { getUserRoleName } from "@acme/domains";
import { Field as Field4, formatDateTime as formatDateTime3 } from "@acme/foundation";
import { useUnit } from "effector-react";
import { useEffect as useEffect2 } from "react";
import { useParams } from "react-router-dom";

// src/features/applicationComments/model/index.ts
import { ApplicationService } from "@acme/api";
import { createEffect, createEvent, createStore, sample } from "effector";
var applicationCommentsOpened = createEvent();
var loadApplicationCommentsFx = createEffect(
  async ({ id }) => {
    const res = await ApplicationService.getApiV1ApplicationComments({ id });
    if (!res.isSuccess) {
      throw new Error(
        res.errorText || "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0435 \u043A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0435\u0432 \u0437\u0430\u044F\u0432\u043A\u0438"
      );
    }
    return res.data ?? [];
  }
);
var $applicationComments = createStore(
  []
).on(loadApplicationCommentsFx.doneData, (_, data) => data);
var $applicationCommentsError = createStore(null).on(applicationCommentsOpened, () => null).on(
  loadApplicationCommentsFx.failData,
  (_, err) => err instanceof Error ? err.message : "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0435 \u043A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0435\u0432 \u0437\u0430\u044F\u0432\u043A\u0438"
);
var $isApplicationCommentsLoading = loadApplicationCommentsFx.pending;
sample({
  clock: applicationCommentsOpened,
  filter: ({ id }) => id.trim().length > 0,
  target: loadApplicationCommentsFx
});

// src/features/applicationComments/ui/applicationcomments.tsx
import { jsx as jsx19, jsxs as jsxs18 } from "react/jsx-runtime";
var ApplicationComments = () => {
  const { id } = useParams();
  const { comments, opened } = useUnit({
    comments: $applicationComments,
    opened: applicationCommentsOpened
  });
  useEffect2(() => {
    if (!id)
      return;
    opened({ id });
  }, [id, opened]);
  if (comments.length === 0) {
    return /* @__PURE__ */ jsx19("div", { className: "text-gray-500 text-sm py-4", children: "\u041D\u0435\u0442 \u043A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0435\u0432" });
  }
  return /* @__PURE__ */ jsx19("div", { className: "flex flex-col gap-3 max-h-64 overflow-y-auto", children: comments.map((item) => /* @__PURE__ */ jsxs18("div", { className: "flex justify-between", children: [
    /* @__PURE__ */ jsx19(
      Field4,
      {
        label: formatDateTime3(item.createdAt) || "-",
        value: item.description
      }
    ),
    /* @__PURE__ */ jsx19(
      Field4,
      {
        align: "left",
        label: getUserRoleName(item.roleId),
        value: item.userName
      }
    )
  ] }, item.createdAt)) });
};

// src/features/applicationHistory/ui/applicationhistory.tsx
import { getUserRoleName as getUserRoleName2 } from "@acme/domains";
import { Field as Field5, formatDateTime as formatDateTime4 } from "@acme/foundation";
import { useUnit as useUnit2 } from "effector-react";
import { useEffect as useEffect3 } from "react";
import { useParams as useParams2 } from "react-router-dom";

// src/features/applicationHistory/model/index.ts
import { ApplicationService as ApplicationService2 } from "@acme/api";
import { createEffect as createEffect2, createEvent as createEvent2, createStore as createStore2, sample as sample2 } from "effector";
var applicationHistoryOpened = createEvent2();
var loadApplicationHistoryFx = createEffect2(
  async ({ id }) => {
    const res = await ApplicationService2.getApiV1ApplicationHistory({ id });
    if (!res.isSuccess) {
      throw new Error(
        res.errorText || "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0435 \u0438\u0441\u0442\u043E\u0440\u0438\u0438 \u0437\u0430\u044F\u0432\u043A\u0438"
      );
    }
    return res.data ?? [];
  }
);
var $applicationHistory = createStore2(
  []
).on(loadApplicationHistoryFx.doneData, (_, data) => data);
var $applicationHistoryError = createStore2(null).on(applicationHistoryOpened, () => null).on(
  loadApplicationHistoryFx.failData,
  (_, err) => err instanceof Error ? err.message : "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0435 \u0438\u0441\u0442\u043E\u0440\u0438\u0438 \u0437\u0430\u044F\u0432\u043A\u0438"
);
var $isApplicationHistoryLoading = loadApplicationHistoryFx.pending;
sample2({
  clock: applicationHistoryOpened,
  filter: ({ id }) => id.trim().length > 0,
  target: loadApplicationHistoryFx
});

// src/features/applicationHistory/ui/applicationhistory.tsx
import { jsx as jsx20, jsxs as jsxs19 } from "react/jsx-runtime";
var ApplicationHistory = () => {
  const { id } = useParams2();
  const { history, opened } = useUnit2({
    history: $applicationHistory,
    opened: applicationHistoryOpened
  });
  useEffect3(() => {
    if (!id)
      return;
    opened({ id });
  }, [id, opened]);
  return /* @__PURE__ */ jsx20("div", { className: "flex flex-col gap-3 max-h-64 overflow-y-auto", children: history.map((item) => /* @__PURE__ */ jsxs19("div", { className: "flex justify-between", children: [
    /* @__PURE__ */ jsx20(
      Field5,
      {
        label: formatDateTime4(item.actionAt) || "-",
        value: item.description
      }
    ),
    /* @__PURE__ */ jsx20(
      Field5,
      {
        align: "left",
        label: getUserRoleName2(item.roleId),
        value: item.userName
      }
    )
  ] }, item.actionAt)) });
};

// src/widgets/applicationActivity/ui/index.tsx
import { jsx as jsx21 } from "react/jsx-runtime";
var ApplicationActivity = () => {
  const tabItems = [
    {
      key: "comments",
      title: "\u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0438",
      content: /* @__PURE__ */ jsx21(ApplicationComments, {})
    },
    {
      key: "history",
      title: "\u0418\u0441\u0442\u043E\u0440\u0438\u044F",
      content: /* @__PURE__ */ jsx21(ApplicationHistory, {})
    }
  ];
  const tabsTheme = createTheme({
    tabs: {
      base: "flex flex-col bg-white p-4 rounded-lg shadow-[0px_1px_3px_0px_rgba(0,0,0,0.1),0px_1px_2px_-1px_rgba(0,0,0,0.1)]",
      tablist: {
        base: "flex gap-4 items-center pb-4",
        tabitem: {
          base: "flex items-center justify-center px-4 py-2 p-0 rounded-lg text-sm font-normal leading-[1.5] first:ml-0 focus:outline-none disabled:cursor-not-allowed disabled:text-gray-400 disabled:dark:text-gray-500",
          variant: {
            default: {
              base: "px-4 py-2",
              active: {
                on: "bg-brand-purple-900 text-white",
                off: "text-gray-500 hover:bg-gray-100 hover:text-gray-700"
              }
            }
          }
        }
      },
      tabpanel: ""
    }
  }).tabs;
  return /* @__PURE__ */ jsx21(Tabs, { items: tabItems, defaultActiveKey: "history", theme: tabsTheme });
};

// src/widgets/applicationCard/index.tsx
import { DefinitionActionSubKindEnum as DefinitionActionSubKindEnum2 } from "@acme/api";
import { Separator as Separator6, formatDate } from "@acme/foundation";
import { useMemo as useMemo2 } from "react";

// src/features/applicationEpoch/index.tsx
import { EpochEnum } from "@acme/api/admin";
import { twMerge } from "tailwind-merge";
import { jsx as jsx22, jsxs as jsxs20 } from "react/jsx-runtime";
var MAX_STEPS = 4;
var epochConfig = {
  [EpochEnum.ChangesRequired]: {
    bg: "bg-red-500",
    text: "text-red-500",
    steps: 1
  },
  [EpochEnum.Confirmed]: {
    bg: "bg-green-900",
    text: "text-green-900",
    steps: 2
  },
  [EpochEnum.ReviewAdmin]: {
    bg: "bg-yellow-400",
    text: "text-yellow-400",
    steps: 3
  },
  [EpochEnum.Review]: {
    bg: "bg-gray-700",
    text: "text-gray-700",
    steps: 3
  },
  [EpochEnum.New]: {
    bg: "bg-gray-700",
    text: "text-gray-700",
    steps: 1
  },
  [EpochEnum.Draft]: {
    bg: "bg-gray-500",
    text: "text-gray-500",
    steps: 1
  },
  [EpochEnum.InProgress]: {
    bg: "bg-primary-500",
    text: "text-primary-500",
    steps: 3
  },
  [EpochEnum.Rejected]: {
    bg: "bg-red-500",
    text: "text-red-500",
    steps: 0
  },
  [EpochEnum.Completed]: {
    bg: "bg-purple-900",
    text: "text-purple-900",
    steps: 4
  },
  [EpochEnum.Accomplished]: {
    bg: "bg-purple-900",
    text: "text-purple-900",
    steps: 4
  }
};
var defaultConfig = {
  bg: "bg-gray-700",
  text: "text-gray-700",
  steps: 3
};
var getEpochConfig = (id) => {
  if (!id)
    return defaultConfig;
  const cfg = epochConfig[id];
  if (!cfg)
    return defaultConfig;
  return {
    ...cfg,
    steps: Math.min(MAX_STEPS, Math.max(0, cfg.steps))
  };
};
var ApplicationEpoch = ({
  epoch,
  hint
}) => {
  const config2 = getEpochConfig(epoch?.id);
  const steps = Array.from({ length: config2.steps }, (_, i) => i);
  return /* @__PURE__ */ jsxs20("div", { className: "flex flex-col gap-2", children: [
    /* @__PURE__ */ jsx22("div", { className: "flex items-start justify-between", children: /* @__PURE__ */ jsxs20("div", { className: "flex flex-col gap-2.5 w-[212px]", children: [
      /* @__PURE__ */ jsxs20("div", { className: "flex items-center gap-1.5", children: [
        /* @__PURE__ */ jsx22(
          "div",
          {
            className: twMerge(
              "w-3 h-3 rounded-full flex-shrink-0",
              config2.bg
            )
          }
        ),
        /* @__PURE__ */ jsx22(
          "span",
          {
            className: twMerge(
              "text-sm font-medium leading-[14px]",
              config2.text
            ),
            children: epoch?.name || "\u041D\u043E\u0432\u0430\u044F \u0437\u0430\u044F\u0432\u043A\u0430"
          }
        )
      ] }),
      /* @__PURE__ */ jsx22("div", { className: "grid grid-cols-4 items-center gap-1 w-full min-h-1", children: config2.steps > 0 ? steps.map((i) => /* @__PURE__ */ jsx22(
        "div",
        {
          className: twMerge(
            "flex-1 h-1 bg-gray-200 rounded-sm",
            config2.bg
          )
        },
        i
      )) : null })
    ] }) }),
    hint ? /* @__PURE__ */ jsx22("div", { className: "flex items-center gap-2 text-sm text-gray-500", children: hint }) : null
  ] });
};

// src/widgets/applicationCard/index.tsx
import { jsx as jsx23, jsxs as jsxs21 } from "react/jsx-runtime";
var hintBySubKind = {
  [DefinitionActionSubKindEnum2.UploadTransferCommessionRecepotDoc]: "\u041E\u0436\u0438\u0434\u0430\u0435\u0442\u0441\u044F \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u0434\u0435\u043D\u0435\u0436\u043D\u043E\u0433\u043E \u043F\u0435\u0440\u0435\u0432\u043E\u0434\u0430"
};
var ApplicationCard = ({
  application,
  onClick,
  amount,
  currency,
  children
}) => {
  const formatAmount = (value) => {
    if (!value)
      return "";
    return new Intl.NumberFormat("ru-RU").format(value);
  };
  const subKind = useMemo2(() => {
    if (application) {
      const action = application.actions?.find((a) => a.subKind);
      return action?.subKind;
    }
    return null;
  }, [application]);
  return /* @__PURE__ */ jsxs21(
    "div",
    {
      className: "bg-white border border-gray-200 border-b-0 rounded-lg shadow-[0px_1px_3px_0px_rgba(0,0,0,0.1),0px_1px_2px_-1px_rgba(0,0,0,0.1)] cursor-pointer hover:shadow-lg transition-shadow w-full max-w-[500px]",
      onClick,
      children: [
        /* @__PURE__ */ jsxs21("div", { className: "px-6 py-4", children: [
          /* @__PURE__ */ jsxs21("div", { className: "flex items-start justify-between gap-3 mb-2", children: [
            /* @__PURE__ */ jsx23("h3", { className: "text-xl font-semibold text-gray-900 leading-[1.5]", children: application.code || "\u2014" }),
            amount && /* @__PURE__ */ jsxs21("div", { className: "flex items-center gap-1.5 text-xl font-semibold leading-[1.5] whitespace-nowrap", children: [
              /* @__PURE__ */ jsx23("span", { className: "text-gray-900", children: formatAmount(amount) }),
              /* @__PURE__ */ jsx23("span", { className: "text-gray-500", children: currency || "USD" })
            ] })
          ] }),
          (application.createdAt || application.updatedAt) && /* @__PURE__ */ jsxs21("div", { className: "flex flex-wrap gap-x-4 gap-y-0 text-sm text-gray-500", children: [
            application.createdAt && /* @__PURE__ */ jsxs21("span", { children: [
              "\u0421\u043E\u0437\u0434\u0430\u043D\u043E: ",
              formatDate(application.createdAt)
            ] }),
            application.updatedAt && /* @__PURE__ */ jsxs21("span", { children: [
              "\u041E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u043E: ",
              formatDate(application.updatedAt)
            ] })
          ] })
        ] }),
        /* @__PURE__ */ jsx23(Separator6, {}),
        children && /* @__PURE__ */ jsx23("div", { className: "px-6 py-4", onClick: (e) => e.stopPropagation(), children }),
        /* @__PURE__ */ jsx23("div", { className: "px-6 py-4 flex flex-col gap-2", children: /* @__PURE__ */ jsx23(
          ApplicationEpoch,
          {
            epoch: application.epoch,
            hint: subKind != null ? hintBySubKind?.[subKind] : null
          }
        ) })
      ]
    }
  );
};

// src/widgets/applicationFormAgentInfo/index.tsx
import { useCountry, useCryptoCurrency, useNet } from "@acme/domains";
import { Form, FormControls, Separator as Separator7, useFormModel } from "@acme/foundation";
import { Button as Button9 } from "flowbite-react";
import { useMemo as useMemo3 } from "react";

// src/widgets/applicationFormAgentInfo/model/index.ts
import {
  applicationOfferFormAddInfoConfig,
  applicationOfferFormMainInfoConfig
} from "@acme/domains";
var requiredAlways = {
  when: () => true,
  set: { required: true }
};
var requiredValidationText = (v) => typeof v === "string" && !v.trim() ? "\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435" : null;
var requiredValidationNumberOrSelect = (v) => v === "" || v === void 0 || v === null ? "\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435" : null;
var requiredValidationFiles = (v) => !Array.isArray(v) || v.length === 0 ? "\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435" : null;
function withRequired(cfg) {
  const base = { ...cfg, rules: [requiredAlways] };
  if (cfg.type === "text") {
    return {
      ...base,
      validation: requiredValidationText
    };
  }
  if (cfg.type === "number" || cfg.type === "select") {
    return {
      ...base,
      validation: requiredValidationNumberOrSelect
    };
  }
  return base;
}
var formAgentInfoFormConfig = (options) => {
  const mainConfig = applicationOfferFormMainInfoConfig(true, {
    nets: options.nets,
    cryptoCurrencies: options.cryptoCurrencies
  });
  const addConfig = applicationOfferFormAddInfoConfig(true, {
    countries: options.countries
  });
  return {
    id: "form-agent-info",
    includeUnchangedFields: true,
    controls: [
      ...mainConfig.controls.map((c) => withRequired(c)),
      ...addConfig.controls.map((c) => withRequired(c)),
      {
        id: "files",
        label: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432",
        type: "fileUpload",
        read: () => [],
        write: {
          path: "files",
          transform: (v) => Array.isArray(v) ? v.map((u) => u.file) : []
        },
        validation: requiredValidationFiles,
        rules: [requiredAlways],
        props: {
          label: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432",
          accept: ".pdf",
          maxSize: 10,
          multiple: true,
          showInfoIcon: true
        }
      }
    ]
  };
};
var MAIN_SECTION_IDS = [
  "commissionAuthorizedOrganizationRUB",
  "commissionAgentRUB",
  "agentCryptoAddress",
  "agentWalletNetId",
  "cryptoCurrencyId",
  "cryptoAmount"
];
var ADD_SECTION_IDS = [
  "organizationName",
  "senderCountryId",
  "bankName"
];

// src/widgets/applicationFormAgentInfo/index.tsx
import { jsx as jsx24, jsxs as jsxs22 } from "react/jsx-runtime";
var initialCtx = {
  commissionAuthorizedOrganizationRUB: "",
  commissionAgentRUB: "",
  agentCryptoAddress: "",
  agentWalletNetId: "",
  cryptoCurrencyId: "",
  cryptoAmount: "",
  organizationName: "",
  senderCountryId: "",
  bankName: "",
  files: []
};
var ApplicationFormAgentInfo = ({
  onConfirm,
  onCancel,
  isSubmitting = false,
  inline = false
}) => {
  const { currencies } = useCryptoCurrency();
  const { nets } = useNet();
  const { countries } = useCountry();
  const config2 = useMemo3(() => {
    return formAgentInfoFormConfig({
      nets: nets.map((i) => ({
        label: i.name ?? "",
        value: String(i.id ?? "")
      })),
      cryptoCurrencies: currencies.map((i) => ({
        label: i.name ?? "",
        value: String(i.id ?? "")
      })),
      countries: countries.map((i) => ({
        label: i.name ?? "",
        value: String(i.id ?? "")
      }))
    });
  }, [currencies, nets, countries]);
  const form = useFormModel({ config: config2, ctx: initialCtx });
  const values = form.state.values;
  const hasFiles = (values.files?.length ?? 0) > 0;
  const canSubmit = !isSubmitting && !form.state.isSubmitting && hasFiles;
  return /* @__PURE__ */ jsxs22(
    Form,
    {
      form,
      onSubmit: onConfirm,
      className: "space-y-6",
      children: [
        /* @__PURE__ */ jsx24("h2", { className: "text-xl font-semibold text-gray-900", children: "\u041F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043E \u0441\u0434\u0435\u043B\u043A\u0435" }),
        /* @__PURE__ */ jsx24("div", { className: "grid grid-cols-1 sm:grid-cols-2 gap-6", children: /* @__PURE__ */ jsx24(
          FormControls,
          {
            form,
            filter: (cfg) => cfg.id != null && MAIN_SECTION_IDS.includes(cfg.id)
          }
        ) }),
        /* @__PURE__ */ jsx24(Separator7, { className: "-mx-6" }),
        /* @__PURE__ */ jsx24("h2", { className: "text-xl font-semibold text-gray-900", children: "\u0414\u0430\u043D\u043D\u044B\u0435 \u043E \u043F\u043B\u0430\u0442\u0435\u043B\u044C\u0449\u0438\u043A\u0435 \u0430\u0433\u0435\u043D\u0442\u0430" }),
        /* @__PURE__ */ jsx24("div", { className: "grid grid-cols-1 sm:grid-cols-2 gap-6", children: /* @__PURE__ */ jsx24(
          FormControls,
          {
            form,
            filter: (cfg) => cfg.id != null && ADD_SECTION_IDS.includes(cfg.id)
          }
        ) }),
        /* @__PURE__ */ jsx24(Separator7, { className: "-mx-6" }),
        /* @__PURE__ */ jsx24("div", { className: "space-y-2", children: /* @__PURE__ */ jsx24(FormControls, { form, filter: (cfg) => cfg.id === "files" }) }),
        /* @__PURE__ */ jsx24(Separator7, { className: "-mx-6" }),
        /* @__PURE__ */ jsxs22("div", { className: "flex justify-end", children: [
          /* @__PURE__ */ jsx24(Button9, { type: "submit", color: "primary", disabled: !canSubmit, children: isSubmitting || form.state.isSubmitting ? "\u041E\u0442\u043F\u0440\u0430\u0432\u043A\u0430..." : "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435" }),
          !inline && onCancel ? /* @__PURE__ */ jsx24(
            Button9,
            {
              type: "button",
              color: "light",
              onClick: onCancel,
              className: "ml-2",
              children: "\u041E\u0442\u043C\u0435\u043D\u0430"
            }
          ) : null
        ] })
      ]
    }
  );
};

// src/widgets/applicationList/ui/applicationListTable.tsx
import { PaginatedContent, Tabs as Tabs2 } from "@acme/foundation";
import { useUnit as useUnit3 } from "effector-react";
import { useCallback as useCallback2, useEffect as useEffect4 } from "react";
import { useNavigate as useNavigate2 } from "react-router-dom";
import { jsx as jsx25 } from "react/jsx-runtime";
var ApplicationListTable = ({
  model,
  tabs,
  getDetailPath,
  getAmount,
  getCurrency,
  renderCardChildren
}) => {
  const navigate = useNavigate2();
  const {
    items,
    totalCount,
    pageNumber,
    pageSize,
    isLoading,
    epochId,
    onListOpened,
    onEpochChanged,
    onPageChanged
  } = useUnit3({
    items: model.$items,
    totalCount: model.$totalCount,
    pageNumber: model.$pageNumber,
    pageSize: model.$pageSize,
    isLoading: model.$isLoading,
    epochId: model.$epochId,
    onListOpened: model.listOpened,
    onEpochChanged: model.epochChanged,
    onPageChanged: model.pageChanged
  });
  useEffect4(() => {
    onListOpened();
  }, [onListOpened]);
  const handleTabChange = useCallback2(
    (key) => {
      const tab = tabs.find((t) => t.key === key);
      if (tab)
        onEpochChanged(tab.epochId);
    },
    [tabs, onEpochChanged]
  );
  const defaultTabKey = tabs[0]?.key ?? "all";
  const activeTabKey = tabs.find((t) => t.epochId === epochId)?.key ?? defaultTabKey;
  const tabItems = tabs.map((tab) => ({
    key: tab.key,
    title: tab.title,
    content: isLoading ? /* @__PURE__ */ jsx25("div", { className: "rounded-lg bg-white p-6 shadow text-center text-gray-500", children: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430\u2026" }) : /* @__PURE__ */ jsx25(
      PaginatedContent,
      {
        pageNumber,
        pageSize,
        totalCount,
        onPageChange: onPageChanged,
        isLoading,
        children: /* @__PURE__ */ jsx25("div", { className: "grid grid-cols-3 gap-4", children: items.map((card) => /* @__PURE__ */ jsx25(
          ApplicationCard,
          {
            application: card,
            amount: getAmount?.(card),
            currency: getCurrency?.(card) ?? "",
            onClick: () => navigate(getDetailPath(card)),
            children: renderCardChildren?.(card)
          },
          card.id
        )) })
      }
    )
  }));
  return /* @__PURE__ */ jsx25(
    Tabs2,
    {
      items: tabItems,
      defaultActiveKey: activeTabKey,
      onTabChange: handleTabChange
    }
  );
};

// src/widgets/applicationCounterpartyOfferForm/index.tsx
import { Form as Form2, FormControls as FormControls2, useFormModel as useFormModel2 } from "@acme/foundation";
import { Button as Button10 } from "flowbite-react";
import { useMemo as useMemo4 } from "react";

// src/widgets/applicationCounterpartyOfferForm/model/index.ts
var requiredAlways2 = {
  when: () => true,
  set: { required: true }
};
var counterpartyOfferFormConfig = () => ({
  id: "counterparty-offer-form",
  includeUnchangedFields: false,
  controls: [
    {
      id: "commissionAuthorizedOrganizationRUB",
      label: "\u041A\u043E\u043C\u0438\u0441\u0441\u0438\u044F \u0443\u043F\u043E\u043B\u043D\u043E\u043C\u043E\u0447\u0435\u043D\u043D\u043E\u0439 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438, \u0440\u0443\u0431",
      type: "number",
      read: (ctx) => ctx?.commissionAuthorizedOrganizationRUB !== void 0 && ctx?.commissionAuthorizedOrganizationRUB !== null ? ctx.commissionAuthorizedOrganizationRUB : "",
      write: { path: "commissionAuthorizedOrganizationRUB" },
      validation: (v) => {
        const n = typeof v === "number" ? v : Number(v);
        if (!Number.isFinite(n) || n <= 0)
          return "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u043A\u043E\u043C\u0438\u0441\u0441\u0438\u044E (\u043F\u043E\u043B\u043E\u0436\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u0447\u0438\u0441\u043B\u043E)";
        return null;
      },
      props: { placeholder: "" },
      rules: [requiredAlways2]
    },
    {
      id: "files",
      label: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432",
      type: "fileUpload",
      read: () => [],
      write: {
        path: "files",
        transform: (v) => Array.isArray(v) ? v.map((u) => u.file) : []
      },
      props: {
        label: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432",
        accept: ".pdf",
        maxSize: 10,
        multiple: true,
        showInfoIcon: true
      }
    }
  ]
});

// src/widgets/applicationCounterpartyOfferForm/index.tsx
import { jsx as jsx26, jsxs as jsxs23 } from "react/jsx-runtime";
var initialCounterpartyOfferCtx = {
  commissionAuthorizedOrganizationRUB: "",
  files: []
};
var ApplicationCounterpartyOfferForm = ({
  onConfirm,
  onCancel,
  isSubmitting = false,
  inline = false
}) => {
  const config2 = useMemo4(() => counterpartyOfferFormConfig(), []);
  const form = useFormModel2({
    config: config2,
    ctx: initialCounterpartyOfferCtx
  });
  const commission = form.state.values.commissionAuthorizedOrganizationRUB;
  const commissionNum = typeof commission === "number" ? commission : commission !== "" ? Number(commission) : NaN;
  const canSubmit = !isSubmitting && !form.state.isSubmitting && Number.isFinite(commissionNum) && commissionNum > 0;
  return /* @__PURE__ */ jsxs23(
    Form2,
    {
      form,
      onSubmit: onConfirm,
      className: "space-y-6",
      children: [
        /* @__PURE__ */ jsx26("h3", { className: "text-xl font-semibold text-gray-900", children: "\u041F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043E \u0441\u0434\u0435\u043B\u043A\u0435" }),
        /* @__PURE__ */ jsx26(
          "div",
          {
            className: inline ? "grid grid-cols-1 sm:grid-cols-2 gap-4" : "space-y-4",
            children: /* @__PURE__ */ jsx26(
              FormControls2,
              {
                form,
                filter: (cfg) => cfg.id === "commissionAuthorizedOrganizationRUB"
              }
            )
          }
        ),
        /* @__PURE__ */ jsxs23("div", { className: "space-y-2", children: [
          /* @__PURE__ */ jsx26("p", { className: "text-sm font-normal text-gray-500", children: "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u0435 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u044B\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B \u0441\u0434\u0435\u043B\u043A\u0438" }),
          /* @__PURE__ */ jsx26(FormControls2, { form, filter: (cfg) => cfg.id === "files" })
        ] }),
        /* @__PURE__ */ jsxs23("div", { className: "flex justify-end border-t border-gray-200 pt-4", children: [
          /* @__PURE__ */ jsx26(Button10, { type: "submit", color: "primary", disabled: !canSubmit, children: isSubmitting || form.state.isSubmitting ? "\u041E\u0442\u043F\u0440\u0430\u0432\u043A\u0430..." : "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435" }),
          !inline && onCancel ? /* @__PURE__ */ jsx26(
            Button10,
            {
              type: "button",
              color: "light",
              onClick: onCancel,
              className: "ml-2",
              children: "\u041E\u0442\u043C\u0435\u043D\u0430"
            }
          ) : null
        ] })
      ]
    }
  );
};

// src/widgets/applicationSendOfferForm/index.tsx
import { Form as Form3, FormControls as FormControls3, useFormModel as useFormModel3 } from "@acme/foundation";
import { Button as Button11 } from "flowbite-react";
import { useMemo as useMemo5 } from "react";

// src/widgets/applicationSendOfferForm/model/index.ts
var requiredAlways3 = {
  when: () => true,
  set: { required: true }
};
var sendOfferFormConfig = () => ({
  id: "send-offer-form",
  includeUnchangedFields: false,
  controls: [
    {
      id: "contractUniqueNumber",
      label: "\u0423\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u043A\u043E\u043D\u0442\u0440\u0430\u043A\u0442\u0430",
      type: "text",
      read: (ctx) => ctx?.contractUniqueNumber ?? "",
      write: { path: "contractUniqueNumber" },
      validation: (v) => typeof v === "string" && !v.trim() ? "\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435" : null,
      props: { placeholder: "123456789012" },
      rules: [requiredAlways3]
    },
    {
      id: "tradeAgreementNumber",
      label: "\u041D\u043E\u043C\u0435\u0440 \u0432\u043D\u0435\u0448\u043D\u0435\u0442\u043E\u0440\u0433\u043E\u0432\u043E\u0433\u043E \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430",
      type: "text",
      read: (ctx) => ctx?.tradeAgreementNumber ?? "",
      write: { path: "tradeAgreementNumber" },
      validation: (v) => typeof v === "string" && !v.trim() ? "\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435" : null,
      props: { placeholder: "123456789012" },
      rules: [requiredAlways3]
    },
    {
      id: "files",
      label: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432",
      type: "fileUpload",
      read: () => [],
      write: {
        path: "files",
        transform: (v) => Array.isArray(v) ? v.map((u) => u.file) : []
      },
      props: {
        label: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432",
        accept: ".pdf",
        maxSize: 10,
        multiple: true,
        showInfoIcon: true
      }
    }
  ]
});

// src/widgets/applicationSendOfferForm/index.tsx
import { jsx as jsx27, jsxs as jsxs24 } from "react/jsx-runtime";
var initialCtx2 = {
  contractUniqueNumber: "",
  tradeAgreementNumber: "",
  files: []
};
var ApplicationSendOfferForm = ({
  onConfirm,
  onCancel,
  isSubmitting = false,
  inline = false
}) => {
  const config2 = useMemo5(() => sendOfferFormConfig(), []);
  const form = useFormModel3({ config: config2, ctx: initialCtx2 });
  const canSubmit = !isSubmitting && !form.state.isSubmitting && String(form.state.values.contractUniqueNumber ?? "").trim() !== "" && String(form.state.values.tradeAgreementNumber ?? "").trim() !== "";
  return /* @__PURE__ */ jsxs24(
    Form3,
    {
      form,
      onSubmit: onConfirm,
      className: "space-y-6",
      children: [
        /* @__PURE__ */ jsx27("h3", { className: "text-xl font-semibold text-gray-900", children: "\u0417\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u0435 \u0434\u0430\u043D\u043D\u044B\u0435" }),
        /* @__PURE__ */ jsx27(
          "div",
          {
            className: inline ? "grid grid-cols-1 sm:grid-cols-2 gap-4" : "space-y-4",
            children: /* @__PURE__ */ jsx27(
              FormControls3,
              {
                form,
                filter: (cfg) => cfg.id === "contractUniqueNumber" || cfg.id === "tradeAgreementNumber"
              }
            )
          }
        ),
        /* @__PURE__ */ jsx27("div", { className: "space-y-2", children: /* @__PURE__ */ jsx27(FormControls3, { form, filter: (cfg) => cfg.id === "files" }) }),
        /* @__PURE__ */ jsxs24("div", { className: "flex justify-end border-t border-gray-200 pt-4", children: [
          /* @__PURE__ */ jsx27(Button11, { type: "submit", color: "primary", disabled: !canSubmit, children: isSubmitting || form.state.isSubmitting ? "\u041E\u0442\u043F\u0440\u0430\u0432\u043A\u0430..." : "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435" }),
          !inline && onCancel ? /* @__PURE__ */ jsx27(
            Button11,
            {
              type: "button",
              color: "light",
              onClick: onCancel,
              className: "ml-2",
              children: "\u041E\u0442\u043C\u0435\u043D\u0430"
            }
          ) : null
        ] })
      ]
    }
  );
};

// src/widgets/auth/ui/authPageLayout.tsx
import { Outlet } from "react-router-dom";
import { jsx as jsx28, jsxs as jsxs25 } from "react/jsx-runtime";
var AuthPageLayout = ({
  title,
  subtitle,
  phone,
  email,
  maxWidth = ""
}) => {
  return /* @__PURE__ */ jsxs25("div", { className: "w-full", children: [
    /* @__PURE__ */ jsx28(
      "div",
      {
        className: `bg-white border-t border-l border-r ${maxWidth} border-gray-200 rounded-t-lg`,
        children: /* @__PURE__ */ jsxs25("div", { className: "p-6 flex flex-col gap-6", children: [
          /* @__PURE__ */ jsxs25("div", { className: "flex flex-col gap-1 text-center", children: [
            /* @__PURE__ */ jsx28("p", { className: "text-base font-medium text-gray-500 leading-6", children: subtitle }),
            /* @__PURE__ */ jsx28("h1", { className: "text-xl font-semibold text-gray-900 leading-6", children: title })
          ] }),
          /* @__PURE__ */ jsx28("div", { className: "flex justify-center", children: /* @__PURE__ */ jsx28(Outlet, {}) }),
          /* @__PURE__ */ jsxs25("div", { className: "flex justify-between items-center text-base font-medium px-4", children: [
            /* @__PURE__ */ jsx28("span", { className: "text-gray-900", children: phone }),
            /* @__PURE__ */ jsx28("span", { className: "text-blue-700", children: email })
          ] })
        ] })
      }
    ),
    /* @__PURE__ */ jsx28("div", { className: "bg-white border border-gray-200 rounded-b-lg", children: /* @__PURE__ */ jsx28("div", { className: "px-6 py-4", children: /* @__PURE__ */ jsx28("div", { className: "flex justify-end pr-4", children: /* @__PURE__ */ jsx28("button", { className: "text-base font-medium text-blue-700 leading-6", children: "\u041E \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0435" }) }) }) })
  ] });
};

// src/widgets/auth/ui/authProvider.tsx
import { UserStoreProvider, useUser } from "@acme/domains";
import { useEffect as useEffect5, useState as useState7 } from "react";
import { Fragment as Fragment9, jsx as jsx29, jsxs as jsxs26 } from "react/jsx-runtime";
var AuthProvider = ({
  children,
  store
}) => {
  return /* @__PURE__ */ jsx29(UserStoreProvider, { store, children: /* @__PURE__ */ jsx29(AuthProviderInner, { children }) });
};
var AuthProviderInner = ({ children }) => {
  const { setToken, tokenInstaled, getAuth, fetch, isLoading } = useUser();
  const [isInitialized, setIsInitialized] = useState7(false);
  useEffect5(() => {
    if (!tokenInstaled) {
      setToken();
      if (getAuth()) {
        fetch();
      }
    }
  }, [tokenInstaled, setToken, getAuth, fetch]);
  useEffect5(() => {
    if (tokenInstaled && (!getAuth() || !isLoading)) {
      setIsInitialized(true);
    }
  }, [tokenInstaled, isLoading, getAuth]);
  if (!isInitialized) {
    return /* @__PURE__ */ jsx29("div", { className: "flex items-center justify-center min-h-screen", children: /* @__PURE__ */ jsxs26("div", { className: "text-center", children: [
      /* @__PURE__ */ jsx29("div", { className: "animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600 mx-auto mb-4" }),
      /* @__PURE__ */ jsx29("p", { className: "text-gray-600", children: "\u0418\u043D\u0438\u0446\u0438\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u044F..." })
    ] }) });
  }
  return /* @__PURE__ */ jsx29(Fragment9, { children });
};

// src/widgets/auth/ui/messageHubProvider.tsx
import { useEffect as useEffect6, useRef } from "react";

// src/shared/messageHub/lib/useMessageHub.ts
import { useUnit as useUnit4 } from "effector-react";

// src/shared/messageHub/model/messageHub.ts
import { createEffect as createEffect3, createEvent as createEvent3, createStore as createStore3, sample as sample3 } from "effector";

// src/shared/messageHub/lib/config.ts
var config = {
  signalR: {
    // hubUrl: process.env.REACT_APP_SIGNALR_HUB_URL || '/chatHub'
    hubUrl: "https://test.transpay.devproxy.ru/messageHub"
  }
};

// src/shared/messageHub/lib/signalRService.ts
import {
  HttpTransportType,
  HubConnectionBuilder,
  HubConnectionState,
  LogLevel
} from "@microsoft/signalr";
var SignalRService = class {
  connection = null;
  messageCallbacks = [];
  connectionCallbacks = [];
  debugCallbacks = [];
  isStarting = false;
  token = null;
  logDebug(message, data) {
    console.log(`[SignalR Debug] ${message}`, data || "");
    this.debugCallbacks.forEach((callback) => callback({ message, data }));
  }
  async connect(hubUrl, token) {
    this.token = token || null;
    if (this.isStarting || this.connection?.state === HubConnectionState.Connected) {
      this.logDebug("Connection already in progress or established");
      return;
    }
    if (this.connection && this.connection.state !== HubConnectionState.Disconnected) {
      await this.cleanupConnection();
    }
    this.isStarting = true;
    try {
      this.logDebug("Creating new connection to", hubUrl);
      this.connection = new HubConnectionBuilder().withUrl(hubUrl, {
        skipNegotiation: true,
        transport: HttpTransportType.WebSockets
        // accessTokenFactory: token ? () => token : undefined,
      }).withAutomaticReconnect([0, 2e3, 5e3, 1e4, 3e4]).configureLogging(LogLevel.Warning).build();
      this.connection.on("ReceiveMessage", (message) => {
        this.logDebug("Received message from server", message);
        this.messageCallbacks.forEach((callback) => callback(message));
        console.log("SignalR: Received message from server", message);
      });
      this.connection.onreconnecting((error) => {
        this.logDebug("Connection reconnecting", error);
        this.connectionCallbacks.forEach((callback) => callback(false));
        console.log("SignalR: Connection reconnecting", error);
      });
      this.connection.onreconnected(async (connectionId) => {
        this.logDebug("Connection reconnected", connectionId);
        if (this.token) {
          try {
            await this.authorizeConnection(this.token);
            this.logDebug("SignalR: Re-authorized after reconnect");
          } catch (error) {
            this.logDebug(
              "SignalR: Failed to re-authorize after reconnect:",
              error
            );
          }
        }
        this.connectionCallbacks.forEach((callback) => callback(true));
      });
      this.connection.onclose((error) => {
        this.logDebug("Connection closed", error);
        this.connectionCallbacks.forEach((callback) => callback(false));
        this.isStarting = false;
      });
      this.logDebug("Starting connection...");
      await this.connection.start();
      if (this.token) {
        await this.authorizeConnection(this.token);
        console.log("SignalR: Connection authorized");
      }
      this.logDebug("Connection established successfully");
      this.connectionCallbacks.forEach((callback) => callback(true));
      this.isStarting = false;
    } catch (error) {
      this.isStarting = false;
      this.logDebug("Connection failed", error);
      await this.cleanupConnection();
      throw error;
    }
  }
  async authorizeConnection(token) {
    if (!this.connection) {
      throw new Error("SignalR connection not established");
    }
    try {
      await this.connection.invoke("AuthorizeConnection", token);
      console.log("SignalR: AuthorizeConnection invoked successfully");
    } catch (error) {
      console.error("SignalR: AuthorizeConnection failed", error);
      throw error;
    }
  }
  // Метод для обновления токена (например, при его обновлении)
  async updateToken(newToken) {
    this.token = newToken;
    if (this.connection && this.connection.state === "Connected") {
      try {
        await this.authorizeConnection(newToken);
        console.log("SignalR: Token updated and re-authorized");
      } catch (error) {
        console.error("SignalR: Failed to re-authorize with new token:", error);
      }
    }
  }
  async disconnect() {
    this.logDebug("Disconnecting...");
    await this.cleanupConnection();
  }
  async cleanupConnection() {
    if (!this.connection)
      return;
    try {
      if (this.connection.state === HubConnectionState.Connected) {
        await this.connection.stop();
      }
      this.connection = null;
      this.logDebug("Connection cleaned up");
    } catch (error) {
      console.error("Error during connection cleanup:", error);
    } finally {
      this.isStarting = false;
      this.connectionCallbacks.forEach((callback) => callback(false));
      this.messageCallbacks = [];
    }
  }
  // Получаем текущее состояние соединения
  getConnectionState() {
    return this.connection?.state || HubConnectionState.Disconnected;
  }
  onMessage(callback) {
    this.messageCallbacks.push(callback);
  }
  onConnectionChange(callback) {
    this.connectionCallbacks.push(callback);
  }
  onDebug(callback) {
    this.debugCallbacks.push(callback);
  }
  removeMessageCallback(callback) {
    this.messageCallbacks = this.messageCallbacks.filter(
      (cb) => cb !== callback
    );
  }
  removeConnectionCallback(callback) {
    this.connectionCallbacks = this.connectionCallbacks.filter(
      (cb) => cb !== callback
    );
  }
  removeDebugCallback(callback) {
    this.debugCallbacks = this.debugCallbacks.filter((cb) => cb !== callback);
  }
};
var signalRService = new SignalRService();

// src/shared/messageHub/model/types.ts
var createChatId = (identifier) => {
  if (identifier.type === "ticket" && identifier.ticketId) {
    return `ticket:${identifier.ticketId}`;
  }
  return "personal";
};
var getChatIdFromMessage = (message) => {
  if (message.ticketId) {
    return `ticket:${message.ticketId}`;
  }
  return "personal";
};

// src/shared/messageHub/model/messageHub.ts
var connect = createEvent3();
var disconnect = createEvent3();
var connectionChanged = createEvent3();
var messageReceived = createEvent3();
var connectFx = createEffect3(async () => {
  const token = JSON.parse(localStorage.getItem("token"));
  await signalRService.connect(config.signalR.hubUrl, token?.accessToken);
});
var disconnectFx = createEffect3(async () => {
  await signalRService.disconnect();
});
var $isConnected = createStore3(false).on(connectionChanged, (_, connected) => connected).reset(disconnectFx.done);
var $isConnecting = connectFx.pending;
sample3({
  clock: connect,
  target: connectFx
});
sample3({
  clock: disconnect,
  target: disconnectFx
});
signalRService.onConnectionChange((connected) => {
  connectionChanged(connected);
});
signalRService.onMessage((message) => {
  messageReceived(message);
});
var $lastMessage = createStore3(null).on(
  messageReceived,
  (_, message) => ({
    ...message,
    chatId: getChatIdFromMessage(message)
  })
);

// src/shared/messageHub/lib/useMessageHub.ts
var useMessageHub = () => {
  const isConnected = useUnit4($isConnected);
  const isConnecting = useUnit4($isConnecting);
  return {
    isConnected,
    isConnecting,
    connect,
    disconnect
  };
};

// src/widgets/auth/ui/messageHubProvider.tsx
import { Fragment as Fragment10, jsx as jsx30 } from "react/jsx-runtime";
var MessageHubProvider = ({
  children
}) => {
  const { disconnect: disconnect2, isConnected, connect: connect2 } = useMessageHub();
  const effectRan = useRef(false);
  useEffect6(() => {
    if (effectRan.current)
      return;
    effectRan.current = true;
    if (!isConnected) {
      connect2();
    }
    return () => {
      if (effectRan.current)
        return;
      disconnect2();
      effectRan.current = false;
    };
  }, []);
  return /* @__PURE__ */ jsx30(Fragment10, { children });
};

// src/widgets/auth/ui/digitalSignature.tsx
import { Image as Image4 } from "@acme/assets";
import { useCertificates } from "@acme/domains";
import { DropdownSelect } from "@acme/foundation";

// src/widgets/auth/lib/certificateMapper.tsx
import { jsxs as jsxs27 } from "react/jsx-runtime";
var formatCertificateDate = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = String(date.getFullYear()).slice(-2);
  return `${day}.${month}.${year}`;
};
var mapCertificatesToOptions = (certificates) => {
  return certificates.map(({ name, thumbprint, validTo }) => {
    const formattedDate = formatCertificateDate(validTo);
    return {
      value: thumbprint,
      label: /* @__PURE__ */ jsxs27("div", { children: [
        /* @__PURE__ */ jsxs27("span", { className: "font-medium", children: [
          name,
          " "
        ] }),
        /* @__PURE__ */ jsxs27("span", { className: "text-xs text-gray-500", children: [
          "\u041A\u042D\u041F \u0434\u043E ",
          formattedDate
        ] })
      ] })
    };
  });
};

// src/widgets/auth/loading/loading.tsx
import { Image as Image3 } from "@acme/assets";
import { jsx as jsx31, jsxs as jsxs28 } from "react/jsx-runtime";
var Loading = ({
  className,
  text
}) => {
  return /* @__PURE__ */ jsxs28(
    "div",
    {
      className: `flex w-full flex-col items-center gap-8 leading-[normal] ${className}`,
      children: [
        /* @__PURE__ */ jsx31(Image3, { name: "spinner", width: 120, height: 120, className: "animate-spin" }),
        /* @__PURE__ */ jsx31("div", { className: "text-text-secondary font-inter self-stretch text-center leading-6", children: text })
      ]
    }
  );
};

// src/widgets/auth/ui/errors.tsx
import { HiX } from "react-icons/hi";
import { jsx as jsx32, jsxs as jsxs29 } from "react/jsx-runtime";
var Errors = ({
  className,
  title,
  text
}) => {
  return /* @__PURE__ */ jsxs29("div", { className: `flex flex-col gap-6 items-center px-0 py-6 ${className}`, children: [
    /* @__PURE__ */ jsx32("div", { className: "bg-red-100 flex items-center justify-center rounded-full w-12 h-12", children: /* @__PURE__ */ jsx32(HiX, { className: "w-6 h-6 text-red-500" }) }),
    /* @__PURE__ */ jsxs29("div", { className: "flex flex-col gap-4 items-center w-full", children: [
      /* @__PURE__ */ jsx32("div", { className: "font-inter font-medium text-base text-center text-gray-900 leading-[1.5] w-full", children: title }),
      /* @__PURE__ */ jsx32("div", { className: "font-inter text-base text-center text-gray-500 leading-[1.5] w-full", children: text })
    ] })
  ] });
};

// src/widgets/auth/ui/digitalSignature.tsx
import { Fragment as Fragment11, jsx as jsx33, jsxs as jsxs30 } from "react/jsx-runtime";
var DigitalSignature = ({
  callback: successCallback,
  title,
  noImage = false
}) => {
  const { certificates, certificatesError, loading, selectCertificate } = useCertificates(successCallback);
  const renderCertificates = () => {
    const options = mapCertificatesToOptions(certificates);
    return /* @__PURE__ */ jsx33(
      DropdownSelect,
      {
        className: "w-72",
        options,
        placeholder: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u041A\u042D\u041F",
        onChange: (thumbprint) => selectCertificate(thumbprint)
      }
    );
  };
  const renderContent = () => {
    if (loading)
      return /* @__PURE__ */ jsx33(Loading, { text: "\u041F\u0440\u043E\u0432\u0435\u0440\u044F\u0435\u043C \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442 \u041A\u042D\u041F..." });
    if (certificatesError) {
      return /* @__PURE__ */ jsx33(
        Errors,
        {
          className: "pt-20",
          title: "\u041F\u0440\u043E\u0431\u043B\u0435\u043C\u0430 \u0441 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u043E\u0439 \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u0430",
          text: certificatesError.message
        }
      );
    }
    return /* @__PURE__ */ jsx33(Fragment11, { children: renderCertificates() });
  };
  return /* @__PURE__ */ jsxs30(Fragment11, { children: [
    title && !loading && /* @__PURE__ */ jsx33("div", { className: "text-xl w-full font-semibold justify-center text-center flex leading-[normal] mb-6", children: title }),
    !loading && !certificatesError && !noImage && /* @__PURE__ */ jsx33("div", { className: "flex items-center justify-center w-40 mb-8", children: /* @__PURE__ */ jsx33(Image4, { name: "acces", width: "100%", className: "flex-grow text-center" }) }),
    /* @__PURE__ */ jsx33("div", { className: "w-full flex flex-col items-center", children: renderContent() })
  ] });
};

// src/widgets/auth/ui/digitalSignatureLogin.tsx
import { useState as useState10 } from "react";

// src/widgets/auth/ui/esia.tsx
import { useState as useState8 } from "react";

// src/widgets/auth/ui/success.tsx
import { Icon as Icon2 } from "@acme/assets";
import { jsx as jsx34, jsxs as jsxs31 } from "react/jsx-runtime";
var Success = ({
  className,
  title,
  text
}) => {
  return /* @__PURE__ */ jsx34("div", { className: `${className}`, children: /* @__PURE__ */ jsxs31(
    "div",
    {
      className: `font-inter flex w-full flex-col items-center gap-2  text-center leading-[normal] ${className}`,
      children: [
        /* @__PURE__ */ jsx34(Icon2, { name: "check", size: 44 }),
        /* @__PURE__ */ jsx34("div", { className: "self-stretch pt-6 font-medium", children: title }),
        /* @__PURE__ */ jsx34("div", { className: "text-text-secondary self-stretch", children: text })
      ]
    }
  ) });
};

// src/widgets/auth/ui/esia.tsx
import { Fragment as Fragment12, jsx as jsx35 } from "react/jsx-runtime";
var Esia = () => {
  const [isSuccess, setIsSuccess] = useState8(false);
  return /* @__PURE__ */ jsx35(Fragment12, { children: isSuccess ? /* @__PURE__ */ jsx35(Success, { text: "\u0410\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u044F \u043F\u0440\u043E\u0448\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E" }) : /* @__PURE__ */ jsx35(Fragment12, { children: /* @__PURE__ */ jsx35("div", { className: "flex items-center justify-center  w-40 mb-8" }) }) });
};

// src/widgets/auth/ui/roleSelection.tsx
import { RoleEnum } from "@acme/api";
import { Image as Image5 } from "@acme/assets";
import { useModal as useModal2 } from "@acme/foundation";
import { Button as Button12 } from "flowbite-react";
import { jsx as jsx36, jsxs as jsxs32 } from "react/jsx-runtime";
var RoleSelection = ({ onSelectRole }) => {
  const { openConfirmModal } = useModal2();
  const getRoleTitle = (role) => {
    switch (role) {
      case RoleEnum.Client:
        return "\u041E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F \u0442\u0438\u043F\u0430: \u041A\u043B\u0438\u0435\u043D\u0442";
      case RoleEnum.Provider:
        return "\u041E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F \u0442\u0438\u043F\u0430: \u041F\u043E\u0441\u0442\u0430\u0432\u0449\u0438\u043A \u043B\u0438\u043A\u0432\u0438\u0434\u043D\u043E\u0441\u0442\u0438";
      default:
        return "\u0412\u044B\u0431\u043E\u0440 \u0440\u043E\u043B\u0438";
    }
  };
  const getRoleDescription = (role) => {
    switch (role) {
      case RoleEnum.Client:
        return "\u0412\u044B \u0441\u043C\u043E\u0436\u0435\u0442\u0435 \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u043D\u0430\u0448\u0435\u0439 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u044B \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u0435\u043D\u043D\u043E \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0442\u044C \u0438\u0441\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435 \u043C\u0435\u0436\u0434\u0443\u043D\u0430\u0440\u043E\u0434\u043D\u044B\u0445 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u043E\u0432";
      case RoleEnum.Provider:
        return "\u0412\u044B \u0441\u043C\u043E\u0436\u0435\u0442\u0435 \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u043D\u0430\u0448\u0435\u0439 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u044B \u0432\u044B\u0433\u043E\u0434\u043D\u043E \u043F\u0440\u043E\u0434\u0430\u0432\u0430\u0442\u044C \u0438 \u043F\u043E\u043A\u0443\u043F\u0430\u0442\u044C \u0444\u0438\u0430\u0442\u043D\u0443\u044E \u0432\u0430\u043B\u044E\u0442\u0443";
      default:
        return "";
    }
  };
  const handleRoleClick = async (role) => {
    const confirmed = await openConfirmModal({
      title: getRoleTitle(role),
      content: getRoleDescription(role),
      okBtn: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C",
      cancelBtn: "\u041E\u0442\u043C\u0435\u043D\u0430",
      opaqueBackground: true
    });
    if (confirmed) {
      onSelectRole(role);
    }
  };
  return /* @__PURE__ */ jsx36("div", { className: "flex flex-col gap-6 w-full items-center", children: /* @__PURE__ */ jsxs32("div", { className: "grid grid-cols-1 md:grid-cols-2 gap-4 w-full", children: [
    /* @__PURE__ */ jsxs32("div", { className: "flex flex-col items-center gap-2 p-6 bg-gray-50 rounded-lg", children: [
      /* @__PURE__ */ jsx36("div", { className: "w-48 h-48 flex items-center justify-center", children: /* @__PURE__ */ jsx36(
        Image5,
        {
          name: "fly",
          width: "100%",
          height: "100%",
          alt: "\u041A\u043B\u0438\u0435\u043D\u0442",
          className: "object-contain"
        }
      ) }),
      /* @__PURE__ */ jsx36(
        Button12,
        {
          color: "primary",
          className: "w-full",
          onClick: () => handleRoleClick(RoleEnum.Client),
          children: "\u041A\u043B\u0438\u0435\u043D\u0442"
        }
      )
    ] }),
    /* @__PURE__ */ jsxs32("div", { className: "flex flex-col items-center gap-2 p-6 bg-gray-50 rounded-lg", children: [
      /* @__PURE__ */ jsx36("div", { className: "w-48 h-48 flex items-center justify-center", children: /* @__PURE__ */ jsx36(
        Image5,
        {
          name: "money",
          width: "100%",
          height: "100%",
          alt: "\u041F\u043E\u0441\u0442\u0430\u0432\u0449\u0438\u043A \u043B\u0438\u043A\u0432\u0438\u0434\u043D\u043E\u0441\u0442\u0438",
          className: "object-contain"
        }
      ) }),
      /* @__PURE__ */ jsx36(
        Button12,
        {
          color: "primary",
          className: "w-full",
          onClick: () => handleRoleClick(RoleEnum.Provider),
          children: "\u041F\u043E\u0441\u0442\u0430\u0432\u0449\u0438\u043A \u043B\u0438\u043A\u0432\u0438\u0434\u043D\u043E\u0441\u0442\u0438"
        }
      )
    ] })
  ] }) });
};

// src/widgets/auth/ui/twoFactorPasswordInput.tsx
import { Image as Image6 } from "@acme/assets";
import { PasswordInput } from "@acme/foundation";
import { Button as Button13 } from "flowbite-react";
import { useState as useState9 } from "react";
import { jsx as jsx37, jsxs as jsxs33 } from "react/jsx-runtime";
var TwoFactorPasswordInput = ({
  onSubmit,
  loading,
  error,
  title,
  noImage,
  className = ""
}) => {
  const [password, setPassword] = useState9("");
  return /* @__PURE__ */ jsxs33("div", { className: `flex flex-col gap-4 w-full items-center ${className}`, children: [
    title && /* @__PURE__ */ jsx37("div", { className: "text-xl w-full font-semibold justify-center text-center flex leading-[normal] mb-6", children: title }),
    !noImage && /* @__PURE__ */ jsx37("div", { className: "flex items-center justify-center w-40 mb-8", children: /* @__PURE__ */ jsx37(
      Image6,
      {
        name: "acces",
        width: "100%",
        className: "flex-grow text-center",
        loading: "lazy"
      }
    ) }),
    /* @__PURE__ */ jsx37(
      PasswordInput,
      {
        name: "twoFactorPassword",
        value: password,
        onChange: setPassword
      }
    ),
    error && /* @__PURE__ */ jsx37("div", { className: "text-sm text-red-600 leading-tight w-full", children: error }),
    /* @__PURE__ */ jsx37(
      Button13,
      {
        className: "w-full mt-2",
        color: "primary",
        onClick: () => onSubmit(password),
        disabled: loading || !password,
        children: "\u0412\u0445\u043E\u0434"
      }
    )
  ] });
};

// src/widgets/auth/ui/digitalSignatureLogin.tsx
import { jsx as jsx38 } from "react/jsx-runtime";
var DigitalSignatureLogin = ({
  onAuth,
  loading = false,
  error,
  remainingCountOfPasswordAttempts = null,
  supportsRoleSelection = false
}) => {
  const [authState, setAuthState] = useState10({ type: "signature" });
  const handleSignatureSuccess = async (selectedCertificate, secret) => {
    if (secret.isTwoFactor) {
      setAuthState({
        type: "twoFactor",
        cert: selectedCertificate,
        secret
      });
    } else if (secret.isNewOrganization && supportsRoleSelection) {
      setAuthState({
        type: "roleSelection",
        cert: selectedCertificate,
        secret
      });
    } else {
      onAuth(selectedCertificate, secret);
    }
  };
  const handleTwoFactorSubmit = async (password) => {
    if (authState.type !== "twoFactor")
      return;
    onAuth(authState.cert, authState.secret, password);
  };
  const handleRoleSelect = async (role) => {
    if (authState.type !== "roleSelection")
      return;
    onAuth(authState.cert, authState.secret, void 0, role);
  };
  return /* @__PURE__ */ jsx38("div", { className: "font-inter flex flex-col gap-2 pb-10 text-center leading-[normal] items-center", children: authState.type === "twoFactor" ? /* @__PURE__ */ jsx38(
    TwoFactorPasswordInput,
    {
      onSubmit: handleTwoFactorSubmit,
      loading,
      error: error && remainingCountOfPasswordAttempts !== null ? `\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C. \u041E\u0441\u0442\u0430\u043B\u043E\u0441\u044C \u043F\u043E\u043F\u044B\u0442\u043E\u043A: ${remainingCountOfPasswordAttempts}` : error
    }
  ) : authState.type === "roleSelection" ? /* @__PURE__ */ jsx38(RoleSelection, { onSelectRole: handleRoleSelect }) : /* @__PURE__ */ jsx38(DigitalSignature, { callback: handleSignatureSuccess }) });
};

// src/widgets/currencyList/ui/currencyList.tsx
import { Icon as Icon4 } from "@acme/assets";
import {
  ECurrencyTypeEnum as ECurrencyTypeEnum2
} from "@acme/domains";
import { ResultModal as ResultModal2, TextAreaModal, useModal as useModal4 } from "@acme/foundation";
import {
  Button as Button15,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeadCell,
  TableRow,
  TextInput as TextInput4
} from "flowbite-react";
import { useCallback as useCallback3, useEffect as useEffect7, useState as useState11 } from "react";

// src/widgets/currencyList/ui/currencyForm.tsx
import { Icon as Icon3 } from "@acme/assets";
import {
  currencyFormConfig
} from "@acme/domains";
import {
  Form as Form4,
  FormControls as FormControls4,
  ResultModal,
  Separator as Separator8,
  useFormModel as useFormModel4,
  useModal as useModal3
} from "@acme/foundation";
import { Button as Button14 } from "flowbite-react";
import { useNavigate as useNavigate3 } from "react-router-dom";
import { jsx as jsx39, jsxs as jsxs34 } from "react/jsx-runtime";
var CurrencyForm = (props) => {
  const { openModal, closeModal } = useModal3();
  const navigate = useNavigate3();
  const formConfig = currencyFormConfig(true, [
    { label: "\u0424\u0438\u0430\u0442\u043D\u0430\u044F", value: "10" },
    { label: "\u0426\u0438\u0444\u0440\u043E\u0432\u0430\u044F", value: "20" }
  ]);
  const form = useFormModel4({
    config: formConfig,
    ctx: props.defaultData || {}
  });
  const handleClose = () => {
    props.onClose();
  };
  const onSubmit = async (finalModel) => {
    try {
      const requestBody = finalModel.mode === "add" ? {
        code: finalModel.code,
        name: finalModel.name
      } : {
        type: finalModel.type,
        name: finalModel.name,
        id: props.defaultData?.id
      };
      await props.onSubmit({ requestBody }).then((res) => {
        closeModal();
        openModal({
          content: /* @__PURE__ */ jsx39(
            ResultModal,
            {
              title: res.isSuccess ? "\u0423\u0441\u043F\u0435\u0448\u043D\u043E" : "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0432\u0430\u043B\u044E\u0442\u0443 \u043D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C",
              description: res.isSuccess ? "\u0412\u0430\u043B\u044E\u0442\u0430 \u0431\u044B\u043B\u0430 \u0441\u043E\u0437\u0434\u0430\u043D\u0430" : "\u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C \u043F\u043E\u0437\u0434\u043D\u0435\u0435",
              type: res.isSuccess ? "success" : "error",
              onBack: () => {
                navigate("/rates/currencyList");
                closeModal();
              }
            }
          ),
          opaqueBackground: true
        });
      });
    } catch (error) {
      props.onError?.(
        error instanceof Error ? error.message : "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0438 \u0432\u0430\u043B\u044E\u0442\u044B"
      );
    }
  };
  return /* @__PURE__ */ jsxs34(
    Form4,
    {
      form,
      onSubmit,
      className: "flex flex-col",
      children: [
        /* @__PURE__ */ jsxs34("div", { className: "flex pb-5", children: [
          /* @__PURE__ */ jsx39("h3", { className: "text-gray-900 text-lg font-semibold", children: props.defaultData ? "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0432\u0430\u043B\u044E\u0442\u044B" : "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u043D\u043E\u0432\u0443\u044E \u0432\u0430\u043B\u044E\u0442\u0443" }),
          /* @__PURE__ */ jsx39(
            "button",
            {
              onClick: handleClose,
              className: "text-gray-400 hover:text-gray-600 ml-auto",
              children: /* @__PURE__ */ jsx39(Icon3, { size: 10.5, name: "x-outline" })
            }
          )
        ] }),
        /* @__PURE__ */ jsx39(Separator8, { className: "-mx-5" }),
        /* @__PURE__ */ jsx39(
          "div",
          {
            className: "flex flex-col py-5 gap-3",
            onKeyDown: (e) => e.key === "Enter" && e.preventDefault(),
            children: /* @__PURE__ */ jsx39(FormControls4, { form })
          }
        ),
        /* @__PURE__ */ jsx39(Separator8, { className: "-mx-5" }),
        /* @__PURE__ */ jsxs34("div", { className: "flex gap-4 pt-5", children: [
          /* @__PURE__ */ jsx39(Button14, { type: "submit", color: "primary", disabled: false, children: props.defaultData ? "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0432\u0430\u043B\u044E\u0442\u0443" : "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0432\u0430\u043B\u044E\u0442\u0443" }),
          /* @__PURE__ */ jsx39(Button14, { color: "gray", onClick: handleClose, children: "\u041E\u0442\u043C\u0435\u043D\u0430" })
        ] })
      ]
    }
  );
};

// src/widgets/currencyList/ui/currencyList.tsx
import { CurrencyService } from "@acme/api";
import { useNavigate as useNavigate4 } from "react-router-dom";
import { jsx as jsx40, jsxs as jsxs35 } from "react/jsx-runtime";
var CurrencyList = ({ loader, onRowClick }) => {
  const [data, setData] = useState11();
  const { openModal, closeModal, openConfirmModal } = useModal4();
  const navigate = useNavigate4();
  const [filter, setFilter] = useState11({});
  const loadData = useCallback3(async () => {
    const response = await loader({ ...filter });
    setData(response);
  }, [filter]);
  useEffect7(() => {
    loadData();
  }, [loadData]);
  const onCreateCurrencyClick = () => {
    openModal({
      content: /* @__PURE__ */ jsx40(
        CurrencyForm,
        {
          onClose: closeModal,
          onSubmit: CurrencyService.postApiV1CurrencyCreate
        }
      ),
      modalType: "custom"
    });
  };
  const onEditCurrencyClick = (rowData) => {
    openModal({
      content: /* @__PURE__ */ jsx40(
        CurrencyForm,
        {
          onClose: closeModal,
          onSubmit: CurrencyService.putApiV1CurrencyUpdate,
          defaultData: rowData
        }
      ),
      modalType: "custom"
    });
  };
  const onStatusSubmit = (rowData) => {
    CurrencyService.putApiV1CurrencySetStatus({
      requestBody: {
        id: rowData.id,
        type: rowData.type,
        isActive: !rowData.isActive
      }
    }).then(() => {
      openModal({
        content: /* @__PURE__ */ jsx40(
          ResultModal2,
          {
            title: "\u0423\u0441\u043F\u0435\u0448\u043D\u043E",
            description: rowData.isActive ? "\u0412\u0430\u043B\u044E\u0442\u0430 \u0431\u044B\u043B\u0430 \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u0430" : "\u0412\u0430\u043B\u044E\u0442\u0430 \u0431\u044B\u043B\u0430 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0430 \u0432 \u0441\u043F\u0438\u0441\u043E\u043A \u0432\u0430\u043B\u044E\u0442",
            type: "success",
            onBack: () => {
              closeModal();
              loadData();
            }
          }
        ),
        opaqueBackground: true
      });
    }).catch(() => {
      openModal({
        content: /* @__PURE__ */ jsx40(
          ResultModal2,
          {
            title: rowData.isActive ? "\u0417\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0432\u0430\u043B\u044E\u0442\u0443 \u043D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C" : "\u0420\u0430\u0437\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0432\u0430\u043B\u044E\u0442\u0443 \u043D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C",
            description: "\u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C \u043F\u043E\u0437\u0434\u043D\u0435\u0435",
            type: "error",
            onBack: () => {
              navigate("/rates/currencyList");
              closeModal();
            }
          }
        ),
        opaqueBackground: true
      });
    });
  };
  const onSetStatusClick = async (rowData) => {
    if (rowData.isActive) {
      openModal({
        content: /* @__PURE__ */ jsx40(
          TextAreaModal,
          {
            title: "\u0411\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u043A\u0430 \u0432\u0430\u043B\u044E\u0442\u044B",
            areaLabel: "\u041D\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u043F\u0440\u0438\u0447\u0438\u043D\u0443 \u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u043A\u0438 \u0432\u0430\u043B\u044E\u0442\u044B",
            approveButtonText: "\u0417\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u0442\u044C",
            onClose: closeModal,
            onApprove: () => {
              closeModal();
              onStatusSubmit(rowData);
            }
          }
        ),
        modalType: "custom"
      });
    } else {
      const confirmed = await openConfirmModal({
        title: "\u0412\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u0432\u0430\u043B\u044E\u0442\u0443?",
        content: "\u0412\u0430\u043B\u044E\u0442\u0430 \u0431\u0443\u0434\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430 \u0434\u043B\u044F \u0440\u0430\u0431\u043E\u0442\u044B \u0441 \u043D\u0435\u0439 \u043D\u0430 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0435",
        okBtn: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C",
        cancelBtn: "\u041E\u0442\u043C\u0435\u043D\u0430"
      });
      if (!confirmed)
        return;
      onStatusSubmit(rowData);
    }
  };
  return /* @__PURE__ */ jsxs35("div", { className: "bg-white rounded-lg shadow-md overflow-hidden", children: [
    /* @__PURE__ */ jsxs35("div", { className: "flex items-center gap-4 p-4", children: [
      /* @__PURE__ */ jsx40(Button15, { color: "primary", onClick: onCreateCurrencyClick, children: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u043D\u043E\u0432\u0443\u044E \u0432\u0430\u043B\u044E\u0442\u0443" }),
      /* @__PURE__ */ jsx40(
        TextInput4,
        {
          className: "ml-auto",
          icon: () => /* @__PURE__ */ jsx40(Icon4, { name: "search-outline" }),
          onChange: (e) => setFilter((prev) => ({ ...prev, search: e.target.value })),
          placeholder: "\u041D\u0430\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0435 \u0432\u0430\u043B\u044E\u0442\u044B"
        }
      )
    ] }),
    /* @__PURE__ */ jsx40("div", { className: "overflow-x-auto", children: /* @__PURE__ */ jsxs35(Table, { hoverable: true, children: [
      /* @__PURE__ */ jsx40(TableHead, { children: /* @__PURE__ */ jsxs35(TableRow, { children: [
        /* @__PURE__ */ jsx40(TableHeadCell, {}),
        /* @__PURE__ */ jsx40(TableHeadCell, {}),
        /* @__PURE__ */ jsx40(TableHeadCell, { children: "\u0421\u043E\u043A\u0440. \u043D\u0430\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0435 \u0432\u0430\u043B\u044E\u0442\u044B" }),
        /* @__PURE__ */ jsx40(TableHeadCell, { children: "\u041F\u043E\u043B\u043D\u043E\u0435 \u043D\u0430\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0435 \u0432\u0430\u043B\u044E\u0442\u044B" }),
        /* @__PURE__ */ jsx40(TableHeadCell, { children: "\u0422\u0438\u043F \u0432\u0430\u043B\u044E\u0442\u044B" })
      ] }) }),
      /* @__PURE__ */ jsx40(TableBody, { className: "divide-y", children: data?.items?.map((currency) => /* @__PURE__ */ jsxs35(
        TableRow,
        {
          onClick: () => onRowClick?.(currency.name || ""),
          className: "text-sm font-normal text-gray-900 dark:text-white",
          children: [
            /* @__PURE__ */ jsx40(TableCell, { className: "w-[60px] text-gray-500", children: /* @__PURE__ */ jsx40("button", { onClick: () => onEditCurrencyClick(currency), children: /* @__PURE__ */ jsx40(Icon4, { name: "edit-outline" }) }) }),
            /* @__PURE__ */ jsx40(TableCell, { className: "w-[60px] text-gray-500", children: /* @__PURE__ */ jsx40("button", { onClick: () => onSetStatusClick(currency), children: currency.isActive ? /* @__PURE__ */ jsx40(Icon4, { name: "unlock-outline" }) : /* @__PURE__ */ jsx40(Icon4, { name: "lock-outline", color: "#E02424" }) }) }),
            /* @__PURE__ */ jsx40(TableCell, { className: "whitespace-nowrap", children: currency.code }),
            /* @__PURE__ */ jsx40(TableCell, { className: "whitespace-nowrap", children: currency.name }),
            /* @__PURE__ */ jsx40(TableCell, { className: "whitespace-nowrap", children: currency.type === ECurrencyTypeEnum2.Fiat ? "\u0424\u0438\u0430\u0442\u043D\u0430\u044F" : "\u0426\u0438\u0444\u0440\u043E\u0432\u0430\u044F" })
          ]
        },
        currency.id
      )) })
    ] }) })
  ] });
};

// src/widgets/documents/ui/documents.tsx
import { Icon as Icon5 } from "@acme/assets";
import { formatDateTime as formatDateTime5 } from "@acme/foundation";
import { jsx as jsx41, jsxs as jsxs36 } from "react/jsx-runtime";
var COLUMNS = 3;
var Documents = ({
  documents,
  onDownload,
  downloadingId = null
}) => {
  const columns = Array.from(
    { length: COLUMNS },
    (_, colIdx) => documents.filter((_2, i) => i % COLUMNS === colIdx)
  );
  return /* @__PURE__ */ jsx41("div", { className: "overflow-auto", children: /* @__PURE__ */ jsx41("div", { className: "grid grid-cols-3 gap-4", children: columns.map((colDocs, colIdx) => /* @__PURE__ */ jsx41(
    "div",
    {
      className: colIdx < COLUMNS - 1 ? "border-r border-gray-200 pr-4" : "",
      children: colDocs.map((d, idx) => /* @__PURE__ */ jsxs36(
        "div",
        {
          className: "flex items-center gap-3 py-2",
          children: [
            /* @__PURE__ */ jsx41(
              Icon5,
              {
                name: "file-image",
                size: 24,
                className: "text-gray-400 shrink-0"
              }
            ),
            /* @__PURE__ */ jsxs36("div", { className: "min-w-0 flex-1", children: [
              /* @__PURE__ */ jsx41("div", { className: "text-gray-900 text-sm font-medium truncate", children: d.name }),
              d.documentTypeName && /* @__PURE__ */ jsx41("div", { className: "text-gray-600 text-xs truncate", children: d.documentTypeName }),
              /* @__PURE__ */ jsxs36("div", { className: "flex gap-2 text-gray-500 text-xs", children: [
                /* @__PURE__ */ jsx41("span", { children: "\u0417\u0430\u0433\u0440\u0443\u0436\u0435\u043D\u043E:" }),
                /* @__PURE__ */ jsx41("span", { className: "truncate", children: formatDateTime5(d.uploadDate) })
              ] })
            ] }),
            /* @__PURE__ */ jsx41(
              "button",
              {
                type: "button",
                onClick: () => onDownload(d),
                disabled: downloadingId === d.id,
                className: "p-1 text-brand-purple-900 hover:bg-gray-100 rounded disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-transparent",
                title: "\u0421\u043A\u0430\u0447\u0430\u0442\u044C",
                children: downloadingId === d.id ? /* @__PURE__ */ jsx41("span", { className: "inline-block w-4 h-4 border-2 border-brand-purple-900 border-t-transparent rounded-full animate-spin" }) : /* @__PURE__ */ jsx41(Icon5, { name: "download-outline", size: 16 })
              }
            )
          ]
        },
        d.id ?? `${colIdx}-${idx}`
      ))
    },
    colIdx
  )) }) });
};

// src/widgets/error/ui/errorPage.tsx
import { Image as Image7 } from "@acme/assets";
import { Button as Button16 } from "flowbite-react";
import { jsx as jsx42, jsxs as jsxs37 } from "react/jsx-runtime";
var errorImages = {
  400: "400-error-bad-request",
  401: "401-error-unauthorized",
  403: "403-error-forbidden",
  404: "404-error-with-a-landscape",
  500: "500-internal-server-error",
  rates: "profiling"
};
var errorConfig = {
  400: {
    defaultTitle: "\u0418\u0437\u0432\u0438\u043D\u0438\u0442\u0435, \u0447\u0442\u043E-\u0442\u043E \u043F\u043E\u0448\u043B\u043E \u043D\u0435 \u0442\u0430\u043A.",
    defaultDescription: "",
    defaultActionLabel: "\u041D\u0430 \u0433\u043B\u0430\u0432\u043D\u0443\u044E"
  },
  401: {
    defaultTitle: "\u0423 \u0432\u0430\u0441 \u043D\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u044D\u0442\u043E\u043C\u0443 \u0440\u0430\u0437\u0434\u0435\u043B\u0443",
    defaultDescription: "\u0415\u0441\u043B\u0438 \u0432\u044B \u0441\u0447\u0438\u0442\u0430\u0435\u0442\u0435, \u0447\u0442\u043E \u044D\u0442\u043E \u043E\u0448\u0438\u0431\u043A\u0430 \u2014 \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u0432 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0443",
    defaultActionLabel: ""
  },
  403: {
    defaultTitle: "\u0423 \u0432\u0430\u0441 \u043D\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u044D\u0442\u043E\u043C\u0443 \u0440\u0430\u0437\u0434\u0435\u043B\u0443",
    defaultDescription: "\u0415\u0441\u043B\u0438 \u0432\u044B \u0441\u0447\u0438\u0442\u0430\u0435\u0442\u0435, \u0447\u0442\u043E \u044D\u0442\u043E \u043E\u0448\u0438\u0431\u043A\u0430 \u2014 \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u0432 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0443",
    defaultActionLabel: ""
  },
  404: {
    defaultTitle: "\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u0430",
    defaultDescription: "\u0412\u043E\u0437\u043C\u043E\u0436\u043D\u043E, \u043E\u043D\u0430 \u0431\u044B\u043B\u0430 \u0443\u0434\u0430\u043B\u0435\u043D\u0430 \u0438\u043B\u0438 \u0432\u044B \u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043B\u0438 \u043E\u0448\u0438\u0431\u043A\u0443 \u0432 \u0430\u0434\u0440\u0435\u0441\u0435",
    defaultActionLabel: ""
  },
  500: {
    defaultTitle: "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043D\u0435\u043F\u0440\u0435\u0434\u0432\u0438\u0434\u0435\u043D\u043D\u0430\u044F \u043E\u0448\u0438\u0431\u043A\u0430",
    defaultDescription: "\u041C\u044B \u0443\u0436\u0435 \u0440\u0430\u0431\u043E\u0442\u0430\u0435\u043C \u043D\u0430\u0434 \u0435\u0451 \u0443\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u0438\u0435\u043C",
    defaultActionLabel: "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443"
  },
  rates: {
    defaultTitle: "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u043A\u0443\u0440\u0441\u044B \u0432\u0430\u043B\u044E\u0442",
    defaultDescription: "\u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443",
    defaultActionLabel: "\u041F\u0435\u0440\u0435\u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443"
  }
};
var ErrorPage = ({
  statusCode,
  title,
  description,
  actionLabel,
  onAction,
  className = ""
}) => {
  const config2 = errorConfig[statusCode];
  const imageName = errorImages[statusCode];
  const handleAction = () => {
    if (onAction) {
      onAction();
    } else if (statusCode === 500) {
      window.location.reload();
    }
  };
  return /* @__PURE__ */ jsx42(
    "div",
    {
      className: `flex flex-col items-center justify-center px-0 py-24 ${className}`,
      children: /* @__PURE__ */ jsxs37("div", { className: "bg-white flex flex-col gap-6 items-center justify-center p-6 rounded-lg shadow-md w-[448px]", children: [
        /* @__PURE__ */ jsx42("div", { className: "overflow-hidden relative shrink-0 w-40", children: /* @__PURE__ */ jsx42(
          Image7,
          {
            name: imageName,
            alt: `Error ${statusCode}`,
            className: "w-full h-full object-contain",
            width: "100%",
            height: "100%"
          }
        ) }),
        /* @__PURE__ */ jsx42("div", { className: "flex flex-col gap-1 items-center relative shrink-0 w-full", children: /* @__PURE__ */ jsxs37("div", { className: "flex flex-col gap-0 items-center relative shrink-0 w-full text-base text-center", children: [
          /* @__PURE__ */ jsx42("div", { className: "flex flex-col font-medium justify-center leading-normal relative shrink-0 text-gray-900 w-[348px]", children: /* @__PURE__ */ jsx42("p", { className: "leading-[1.5] whitespace-pre-wrap", children: title || config2.defaultTitle }) }),
          description || config2.defaultDescription ? /* @__PURE__ */ jsx42("p", { className: "font-normal leading-[1.5] relative shrink-0 text-gray-500 w-full whitespace-pre-wrap mt-1", children: description || config2.defaultDescription }) : null
        ] }) }),
        (onAction || statusCode === 400 || statusCode === 500 || statusCode === "rates") && /* @__PURE__ */ jsx42(
          Button16,
          {
            color: "purple",
            onClick: handleAction,
            className: "bg-purple-900 hover:bg-purple-800",
            children: actionLabel || config2.defaultActionLabel
          }
        )
      ] })
    }
  );
};

// src/widgets/error/ui/errorProvider.tsx
import { Fragment as Fragment13, jsx as jsx43 } from "react/jsx-runtime";
var ErrorProvider = ({ children }) => {
  return /* @__PURE__ */ jsx43(Fragment13, { children });
};

// src/widgets/exchangeRate/ui/exchangeRateTable.tsx
import { ExchanegeRateService as ExchanegeRateService3 } from "@acme/api";
import { Icon as Icon11 } from "@acme/assets";
import {
  EExchangeRateStatusEnum as EExchangeRateStatusEnum2
} from "@acme/domains";
import { Separator as Separator11, useModal as useModal8 } from "@acme/foundation";
import {
  Button as Button21,
  ButtonGroup,
  Spinner as Spinner2,
  Table as Table3,
  TableBody as TableBody3,
  TableCell as TableCell3,
  TableHead as TableHead3,
  TableHeadCell as TableHeadCell3,
  TableRow as TableRow3
} from "flowbite-react";
import { useCallback as useCallback6, useEffect as useEffect8, useState as useState15 } from "react";
import { HiX as HiX4 } from "react-icons/hi";

// src/widgets/exchangeRate/lib/formatDate.ts
var formatDate2 = (dateString) => {
  if (!dateString)
    return "\u2014";
  const date = new Date(dateString);
  const timeFormatter = new Intl.DateTimeFormat("ru-RU", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false
  });
  const dateFormatter = new Intl.DateTimeFormat("ru-RU", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric"
  });
  const time = timeFormatter.format(date);
  const dateStr = dateFormatter.format(date);
  return `${time}, ${dateStr}`;
};

// src/widgets/exchangeRate/ui/actionMenuButton.tsx
import { Icon as Icon9 } from "@acme/assets";
import { ResultModal as ResultModal4, useModal as useModal6 } from "@acme/foundation";
import {
  Button as Button20,
  Dropdown,
  DropdownDivider,
  DropdownItem
} from "flowbite-react";

// src/widgets/exchangeRate/ui/modal/deleteRateModal.tsx
import { Icon as Icon6 } from "@acme/assets";
import { Button as Button17 } from "flowbite-react";
import { HiX as HiX2 } from "react-icons/hi";
import { jsx as jsx44, jsxs as jsxs38 } from "react/jsx-runtime";
var DeleteRateModal = (props) => {
  return /* @__PURE__ */ jsxs38("div", { children: [
    /* @__PURE__ */ jsx44("div", { className: "flex justify-end", children: /* @__PURE__ */ jsx44(
      "button",
      {
        onClick: props.onClose,
        className: "text-gray-400 hover:text-gray-600",
        children: /* @__PURE__ */ jsx44(HiX2, { className: "h-3 w-3" })
      }
    ) }),
    /* @__PURE__ */ jsxs38("div", { className: "flex flex-col p-5 gap-4 items-center", children: [
      /* @__PURE__ */ jsx44(Icon6, { name: "exclamation", color: "#9CA3AF", className: "h-5 w-5" }),
      /* @__PURE__ */ jsx44("div", { className: "text-base font-normal text-gray-500", children: props.label })
    ] }),
    /* @__PURE__ */ jsxs38("div", { className: "flex gap-4 justify-center", children: [
      /* @__PURE__ */ jsx44(Button17, { color: "red", onClick: props.onApprove, children: "\u0414\u0430, \u0443\u0434\u0430\u043B\u0438\u0442\u044C" }),
      /* @__PURE__ */ jsx44(Button17, { color: "gray", onClick: props.onClose, children: "\u041D\u0435\u0442, \u043E\u0442\u043C\u0435\u043D\u0430" })
    ] })
  ] });
};

// src/widgets/exchangeRate/ui/modal/extendRateModal.tsx
import { Icon as Icon7 } from "@acme/assets";
import { Separator as Separator9 } from "@acme/foundation";
import { Button as Button18, Datepicker, TextInput as TextInput5 } from "flowbite-react";
import { useCallback as useCallback4, useState as useState12 } from "react";
import { HiX as HiX3 } from "react-icons/hi";
import { jsx as jsx45, jsxs as jsxs39 } from "react/jsx-runtime";
var ExtendRateModal = (props) => {
  const [selectedDateShow, setSelectedDateShow] = useState12("");
  const [selectedDate, setSelectedDate] = useState12(null);
  const [showPicker, setShowPicker] = useState12(false);
  const today = /* @__PURE__ */ new Date();
  const nextWeek = /* @__PURE__ */ new Date();
  nextWeek.setDate(today.getDate() + 6);
  const handleDateSelection = (date) => {
    if (date) {
      setSelectedDateShow(
        `${date?.getDate()}/${(date?.getMonth() + 1).toString().padStart(2, "0")}/${date.getFullYear()}`
      );
      setSelectedDate(date);
    }
    setShowPicker(false);
  };
  const handleApprove = useCallback4(() => {
    props.onApprove(selectedDate);
  }, [selectedDate]);
  return /* @__PURE__ */ jsxs39("div", { children: [
    /* @__PURE__ */ jsxs39("div", { className: "flex pb-5", children: [
      /* @__PURE__ */ jsx45("h3", { className: "text-lg font-semibold text-gray-900", children: "\u041F\u0440\u043E\u0434\u043B\u0438\u0442\u044C \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435 \u043A\u0443\u0440\u0441\u0430" }),
      /* @__PURE__ */ jsx45(
        "button",
        {
          onClick: props.onClose,
          className: "text-gray-400 hover:text-gray-600 ml-auto",
          children: /* @__PURE__ */ jsx45(HiX3, { className: "h-3 w-3" })
        }
      )
    ] }),
    /* @__PURE__ */ jsx45(Separator9, { className: "-mx-5" }),
    /* @__PURE__ */ jsxs39("div", { className: "flex flex-col p-5 gap-4 items-center", children: [
      /* @__PURE__ */ jsx45("div", { className: "text-gray-500 text-base font-normal", children: "\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0435 \u0432\u0440\u0435\u043C\u044F \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u043A\u0443\u0440\u0441\u0430: 1 \u043D\u0435\u0434\u0435\u043B\u044F" }),
      /* @__PURE__ */ jsxs39("div", { className: "relative w-full", children: [
        /* @__PURE__ */ jsx45(
          TextInput5,
          {
            icon: () => /* @__PURE__ */ jsx45(Icon7, { name: "calendar-month" }),
            className: "w-full before:",
            onFocus: () => setShowPicker(true),
            value: `\u041A\u0443\u0440\u0441 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u0435\u043D \u0434\u043E: ${selectedDateShow}`,
            readOnly: true
          }
        ),
        showPicker && /* @__PURE__ */ jsx45(
          Datepicker,
          {
            language: "ru",
            weekStart: 1,
            value: null,
            minDate: today,
            maxDate: nextWeek,
            onChange: handleDateSelection,
            className: "w-full absolute z-10",
            showClearButton: false,
            showTodayButton: false,
            inline: true
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ jsx45(Separator9, { className: "-mx-5" }),
    /* @__PURE__ */ jsxs39("div", { className: "flex pt-5 gap-4", children: [
      /* @__PURE__ */ jsx45(
        Button18,
        {
          color: "primary",
          disabled: !selectedDateShow,
          onClick: handleApprove,
          children: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C"
        }
      ),
      /* @__PURE__ */ jsx45(Button18, { color: "gray", onClick: props.onClose, children: "\u041E\u0442\u043C\u0435\u043D\u0430" })
    ] })
  ] });
};

// src/widgets/exchangeRate/ui/exchangeRateForm.tsx
import { useCallback as useCallback5, useMemo as useMemo6, useState as useState13 } from "react";
import { Button as Button19, createTheme as createTheme2, TextInput as TextInput6 } from "flowbite-react";
import {
  exchangeRateFormConfig,
  useCryptoCurrency as useCryptoCurrency2
} from "@acme/domains";
import {
  Form as Form5,
  FormControls as FormControls5,
  RangeDropdown,
  Separator as Separator10,
  Tabs as Tabs3,
  useFormModel as useFormModel5,
  useModal as useModal5,
  ResultModal as ResultModal3
} from "@acme/foundation";
import { Icon as Icon8 } from "@acme/assets";
import { useNavigate as useNavigate5 } from "react-router-dom";
import { renderFieldIfText as renderFieldIfText7 } from "@acme/foundation";
import { ExchangeRateTypeEnum } from "@acme/api";
import { jsx as jsx46, jsxs as jsxs40 } from "react/jsx-runtime";
var underlineTabsTheme = createTheme2({
  tabs: {
    base: "flex flex-col",
    tablist: {
      base: "flex gap-8 items-center bg-white",
      tabitem: {
        base: "flex items-center justify-center p-0 text-sm font-medium first:ml-0 focus:outline-none leading-[1.5]",
        variant: {
          default: {
            base: "flex items-center justify-center pb-2",
            active: {
              on: "border-b border-brand-purple-900 text-brand-purple-900 bg-white hover:bg-white leading-[1.5]",
              off: "text-gray-500 leading-[1.5]"
            }
          }
        }
      }
    },
    tabpanel: ""
  }
}).tabs;
var ExchangeRateForm = (props) => {
  const { currencies } = useCryptoCurrency2();
  const { openModal, closeModal } = useModal5();
  const navigate = useNavigate5();
  const currenciesOptions = useMemo6(() => {
    return currencies.map((i) => {
      return {
        label: i.code || "",
        value: String(i.id || "")
      };
    });
  }, [currencies]);
  const formConfig = exchangeRateFormConfig(
    true,
    currenciesOptions
  );
  const form = useFormModel5({
    config: formConfig,
    ctx: props.defaultData ? {
      ...props.defaultData,
      cryptoCurrency: props.defaultData?.cryptoCurrency?.id
    } : {}
  });
  const [volumeCourses, setVolumeCourses] = useState13([]);
  const [isSell, setIsSell] = useState13(false);
  const [currencyVolume, setCurrencyVolume] = useState13(
    props.defaultData ? {
      from: String(props.defaultData?.rangeMin) || "",
      to: String(props.defaultData?.rangeMax) || ""
    } : null
  );
  const [volumeCourse, setVolumeCourse] = useState13(
    String(props.defaultData?.price) || ""
  );
  const onSubmit = async (finalModel) => {
    try {
      const formData = props.adminMode ? {
        rateId: props.defaultData?.rateId,
        ranges: volumeCourses?.map((course) => {
          return {
            min: Number(course.currencyVolume?.from),
            max: Number(course.currencyVolume?.to),
            price: Number(course.volumeCourse)
          };
        })
      } : {
        type: isSell ? 200 : 100,
        // Рубль, Марат сказал захаркодить
        rateId: props.defaultData?.rateId,
        currencyId: 1,
        cryptoCurrency: Number(finalModel.cryptoCurrency),
        amount: Number(finalModel.amount),
        expireAt: new Date(finalModel.expireAt)?.toISOString(),
        ranges: volumeCourses?.map((course) => {
          return {
            min: Number(course.currencyVolume?.from),
            max: Number(course.currencyVolume?.to),
            price: Number(course.volumeCourse)
          };
        })
      };
      await props.onSubmit({ requestBody: formData }).then((res) => {
        closeModal();
        openModal({
          content: /* @__PURE__ */ jsx46(
            ResultModal3,
            {
              title: res.isSuccess ? "\u0423\u0441\u043F\u0435\u0448\u043D\u043E" : "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0432\u0430\u043B\u044E\u0442\u0443 \u043D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C",
              description: res.isSuccess ? "\u041A\u0443\u0440\u0441 \u0432\u0430\u043B\u044E\u0442\u044B \u0431\u044B\u043B \u0441\u043E\u0437\u0434\u0430\u043D" : "\u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C \u043F\u043E\u0437\u0434\u043D\u0435\u0435",
              type: res.isSuccess ? "success" : "error",
              onBack: () => {
                navigate("/rates");
                closeModal();
              }
            }
          ),
          opaqueBackground: true
        });
      });
    } catch (error) {
      console.log(error);
      props.onError?.(
        error instanceof Error ? error.message : "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u0438 \u0432\u0430\u043B\u044E\u0442\u044B"
      );
    }
  };
  const isSubmitDisabled = useMemo6(() => {
    return volumeCourses.length === 0;
  }, [volumeCourses, form.state.values]);
  const handleClose = () => {
    props.onClose();
  };
  const isAddVolumeBtnDisabled = Boolean(
    volumeCourses?.length >= 3 || !(currencyVolume && volumeCourse)
  );
  const onAddVolumeClick = useCallback5(() => {
    if (isAddVolumeBtnDisabled)
      return;
    setVolumeCourses((prev) => [...prev, { volumeCourse, currencyVolume }]);
  }, [isAddVolumeBtnDisabled, currencyVolume, volumeCourse]);
  const handleRemove = (indexToRemove) => {
    setVolumeCourses(
      (prev) => prev.filter((_, index) => index !== indexToRemove)
    );
  };
  const renderForm = () => {
    return /* @__PURE__ */ jsxs40("div", { className: "flex flex-col gap-6", children: [
      props.adminMode ? /* @__PURE__ */ jsxs40("div", { className: "flex flex-col gap-4", children: [
        /* @__PURE__ */ jsxs40("div", { className: "flex flex-col gap-3", children: [
          /* @__PURE__ */ jsx46("div", { className: "text-base font-medium text-gray-900", children: props.defaultData?.organization?.name }),
          /* @__PURE__ */ jsxs40("div", { className: "flex gap-2 py-0.5 px-2.5 rounded-full bg-green-100 items-center w-fit", children: [
            /* @__PURE__ */ jsx46("span", { className: "w-3 h-3 rounded-full bg-green-500" }),
            /* @__PURE__ */ jsx46("span", { className: "text-xs text-green-800", children: props.defaultData?.type === ExchangeRateTypeEnum.Buy ? "\u041F\u043E\u043A\u0443\u043F\u043A\u0430 \u0432\u0430\u043B\u044E\u0442\u044B" : "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0432\u0430\u043B\u044E\u0442\u044B" })
          ] })
        ] }),
        /* @__PURE__ */ jsxs40("div", { className: "grid grid-cols-3 gap-3", children: [
          renderFieldIfText7(
            "\u0412\u0430\u043B\u044E\u0442\u0430",
            props.defaultData?.cryptoCurrency?.name
          ),
          " ",
          renderFieldIfText7(
            "\u041E\u0431\u0449\u0438\u0439 \u043E\u0431\u044A\u0435\u043C \u0432\u0430\u043B\u044E\u0442\u044B",
            String(props.defaultData?.amount)
          ),
          renderFieldIfText7(
            "\u0412\u0440\u0435\u043C\u044F \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u043A\u0443\u0440\u0441\u0430",
            new Intl.DateTimeFormat("ru-RU", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric"
            }).format(new Date(props.defaultData?.expireAt)).replace(/\//g, ".")
          )
        ] }),
        /* @__PURE__ */ jsx46(Separator10, {})
      ] }) : /* @__PURE__ */ jsx46("div", { className: "grid grid-cols-3 gap-3", children: /* @__PURE__ */ jsx46(FormControls5, { form }) }),
      /* @__PURE__ */ jsxs40("div", { className: "flex flex-col gap-4", children: [
        /* @__PURE__ */ jsx46("div", { className: "text-gray-500 text-sm font-medium", children: "\u041C\u043E\u0436\u043D\u043E \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u043A\u0443\u0440\u0441 \u0434\u043B\u044F \u0442\u0440\u0435\u0445 \u043E\u0431\u044A\u0435\u043C\u043E\u0432 \u0432\u0430\u043B\u044E\u0442\u044B" }),
        /* @__PURE__ */ jsxs40("div", { className: "grid grid-cols-2 gap-3", children: [
          /* @__PURE__ */ jsx46(
            RangeDropdown,
            {
              label: "\u041E\u0431\u044A\u0451\u043C \u0434\u043B\u044F \u043A\u0443\u0440\u0441\u0430",
              placeholder: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043E\u0431\u044A\u0435\u043C",
              onChange: (val) => setCurrencyVolume(val),
              value: currencyVolume
            }
          ),
          /* @__PURE__ */ jsxs40("div", { className: "flex flex-col gap-2", children: [
            /* @__PURE__ */ jsx46("div", { className: "text-sm font-medium text-gray-900", children: "\u041A\u0443\u0440\u0441 \u0434\u043B\u044F \u043E\u0431\u044A\u0435\u043C\u0430" }),
            /* @__PURE__ */ jsx46(
              TextInput6,
              {
                id: "from-input",
                type: "number",
                placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u0443\u0440\u0441",
                value: volumeCourse,
                onChange: (e) => setVolumeCourse(e.target.value)
              }
            )
          ] })
        ] })
      ] }),
      /* @__PURE__ */ jsxs40("div", { className: "flex flex-col gap-6 leading-none text-base font-medium", children: [
        /* @__PURE__ */ jsx46(
          "div",
          {
            className: `w-fit ${isAddVolumeBtnDisabled ? "cursor-not-allowed text-brand-purple-500" : "cursor-pointer text-brand-purple-900"}`,
            onClick: onAddVolumeClick,
            children: "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u043A\u0443\u0440\u0441 \u0434\u043B\u044F \u043E\u0431\u044A\u0435\u043C\u0430"
          }
        ),
        Array.isArray(volumeCourses) && volumeCourses.length > 0 && /* @__PURE__ */ jsxs40("div", { className: "flex gap-2 text-gray-900", children: [
          "\u0414\u043E\u0431\u0430\u0432\u043B\u044F\u0435\u043C\u044B\u0435 \u043E\u0431\u044A\u0435\u043C\u044B",
          /* @__PURE__ */ jsx46("div", { className: "text-gray-500", children: `${volumeCourses?.length} \u0438\u0437 3` })
        ] }),
        volumeCourses?.map((course, index) => /* @__PURE__ */ jsxs40("div", { className: "flex gap-12", children: [
          /* @__PURE__ */ jsxs40("div", { className: "flex gap-2 text-gray-500", children: [
            "\u041E\u0431\u044A\u0435\u043C:",
            /* @__PURE__ */ jsx46("div", { className: "text-gray-900", children: `\u041E\u0442 ${course.currencyVolume?.from} \u0434\u043E ${course.currencyVolume?.to}` })
          ] }),
          /* @__PURE__ */ jsxs40("div", { className: "flex gap-2 text-gray-500", children: [
            "\u041A\u0443\u0440\u0441:",
            /* @__PURE__ */ jsx46("div", { className: "text-gray-900", children: course.volumeCourse })
          ] }),
          /* @__PURE__ */ jsx46(
            "div",
            {
              onClick: () => handleRemove(index),
              className: "text-red-600 hover:text-red-800 hover:underline cursor-pointer ml-auto",
              children: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C"
            }
          )
        ] }, index))
      ] })
    ] });
  };
  const tabItems = [
    {
      key: "buy",
      title: "\u041F\u043E\u043A\u0443\u043F\u043A\u0430 \u0432\u0430\u043B\u044E\u0442\u044B",
      content: renderForm()
    },
    {
      key: "sell",
      title: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430 \u0432\u0430\u043B\u044E\u0442\u044B",
      content: renderForm()
    }
  ];
  return /* @__PURE__ */ jsxs40(
    Form5,
    {
      form,
      onSubmit,
      className: "flex flex-col",
      children: [
        /* @__PURE__ */ jsxs40("div", { className: "flex pb-5", children: [
          /* @__PURE__ */ jsx46("h3", { className: "text-gray-900 text-lg font-semibold", children: props.adminMode ? "\u041A\u043E\u0440\u0440\u0435\u043A\u0442\u0438\u0440\u043E\u0432\u043A\u0430 \u043A\u0443\u0440\u0441\u0430" : "\u0414\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0432\u0430\u043B\u044E\u0442\u044B" }),
          /* @__PURE__ */ jsx46(
            "button",
            {
              onClick: handleClose,
              className: "text-gray-400 hover:text-gray-600 ml-auto",
              children: /* @__PURE__ */ jsx46(Icon8, { size: 10.5, name: "x-outline" })
            }
          )
        ] }),
        /* @__PURE__ */ jsx46(Separator10, { className: "-mx-5" }),
        /* @__PURE__ */ jsx46(
          "div",
          {
            className: "py-6",
            onKeyDown: (e) => e.key === "Enter" && e.preventDefault(),
            children: props.adminMode ? renderForm() : /* @__PURE__ */ jsx46(
              Tabs3,
              {
                items: tabItems,
                defaultActiveKey: "buy",
                onTabChange: (key) => setIsSell(key === "sell"),
                theme: underlineTabsTheme
              }
            )
          }
        ),
        /* @__PURE__ */ jsx46(Separator10, { className: "-mx-5" }),
        /* @__PURE__ */ jsxs40("div", { className: "flex gap-4 pt-5", children: [
          /* @__PURE__ */ jsx46(Button19, { type: "submit", color: "primary", disabled: isSubmitDisabled, children: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0432\u0430\u043B\u044E\u0442\u0443" }),
          /* @__PURE__ */ jsx46(Button19, { color: "gray", onClick: handleClose, children: "\u041E\u0442\u043C\u0435\u043D\u0430" })
        ] })
      ]
    }
  );
};

// src/widgets/exchangeRate/ui/actionMenuButton.tsx
import { ExchanegeRateService } from "@acme/api";
import { useNavigate as useNavigate6 } from "react-router-dom";
import { jsx as jsx47, jsxs as jsxs41 } from "react/jsx-runtime";
var timePeriods = [
  { value: "24h", label: "24 \u0447\u0430\u0441\u0430" },
  { value: "72h", label: "3 \u0434\u043D\u044F" },
  { value: "1w", label: "1 \u043D\u0435\u0434\u0435\u043B\u044F" }
];
var periodToMs = {
  "24h": 24 * 60 * 60 * 1e3,
  "72h": 72 * 60 * 60 * 1e3,
  "1w": 7 * 24 * 60 * 60 * 1e3
};
var addPeriodToDate = (date, period) => {
  const ms = periodToMs[period];
  return new Date(date.getTime() + ms).toISOString();
};
var parseDate = (dateString) => {
  const date = new Date(dateString);
  if (isNaN(date.getTime())) {
    throw new Error(`\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u0444\u043E\u0440\u043C\u0430\u0442 \u0434\u0430\u0442\u044B: ${dateString}`);
  }
  return date;
};
var ActionMenuButton = (props) => {
  const { openModal, openConfirmModal, closeModal } = useModal6();
  const navigate = useNavigate6();
  const onDeleteRate = () => {
    ExchanegeRateService.deleteApiV1ExchanegeRateRemove({
      requestBody: { rateId: props.rowData.rateId }
    }).then((res) => {
      closeModal();
      openModal({
        content: /* @__PURE__ */ jsx47(
          ResultModal4,
          {
            title: res.isSuccess ? "\u0423\u0441\u043F\u0435\u0448\u043D\u043E" : "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043A\u0443\u0440\u0441 \u043D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C",
            description: res.isSuccess ? "\u041A\u0443\u0440\u0441 \u0432\u0430\u043B\u044E\u0442\u044B \u0431\u044B\u043B \u0443\u0434\u0430\u043B\u0451\u043D" : "\u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C \u043F\u043E\u0437\u0434\u043D\u0435\u0435",
            type: res.isSuccess ? "success" : "error",
            onBack: () => {
              navigate("/rates");
              closeModal();
              props.reload?.();
            }
          }
        ),
        opaqueBackground: true
      });
    });
  };
  const handleDeleteClick = async () => {
    try {
      openModal({
        content: /* @__PURE__ */ jsx47(
          DeleteRateModal,
          {
            label: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043A\u0443\u0440\u0441 \u0432\u0430\u043B\u044E\u0442\u044B \u0438\u0437 \u0441\u043F\u0438\u0441\u043A\u0430?",
            onClose: () => {
              closeModal();
              props.reload?.();
            },
            onApprove: onDeleteRate
          }
        ),
        modalType: "custom"
      });
    } catch (error) {
      console.log(error);
    }
  };
  const handlePreferredPeriodClick = async (period) => {
    try {
      const confirmed = await openConfirmModal({
        title: "\u041F\u0440\u043E\u0434\u043B\u0438\u0442\u044C \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435 \u043A\u0443\u0440\u0441\u0430",
        content: "\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u0435 \u043A\u0443\u0440\u0441\u0430 \u0431\u0443\u0434\u0435\u0442 \u043F\u0440\u043E\u0434\u043B\u0435\u043D\u043E \u043D\u0430 \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u0435 \u0432\u0440\u0435\u043C\u044F",
        okBtn: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C",
        cancelBtn: "\u041E\u0442\u043C\u0435\u043D\u0430"
      });
      if (!confirmed)
        return;
      const expireAt = addPeriodToDate(
        parseDate(props.rowData.expireAt),
        period
      );
      ExchanegeRateService.putApiV1ExchanegeRateExtend({
        requestBody: { rateId: props.rowData.rateId, expireAt }
      }).then((res) => {
        closeModal();
        openModal({
          content: /* @__PURE__ */ jsx47(
            ResultModal4,
            {
              title: res.isSuccess ? "\u0423\u0441\u043F\u0435\u0448\u043D\u043E" : "\u041F\u0440\u043E\u0434\u043B\u0438\u0442\u044C \u043A\u0443\u0440\u0441 \u043D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C",
              description: res.isSuccess ? "\u041A\u0443\u0440\u0441 \u0432\u0430\u043B\u044E\u0442\u044B \u0431\u044B\u043B \u043F\u0440\u043E\u0434\u043B\u0435\u043D" : "\u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C \u043F\u043E\u0437\u0434\u043D\u0435\u0435",
              type: res.isSuccess ? "success" : "error",
              onBack: () => {
                navigate("/rates");
                closeModal();
                props.reload?.();
              }
            }
          ),
          opaqueBackground: true
        });
      });
    } catch (error) {
      console.log(error);
    }
  };
  const handleChangeRateClick = () => {
    openModal({
      content: /* @__PURE__ */ jsx47(
        ExchangeRateForm,
        {
          onClose: closeModal,
          defaultData: props.rowData,
          onSubmit: ExchanegeRateService.putApiV1ExchanegeRateUpdateProvider
        }
      ),
      size: "xl",
      modalType: "custom"
    });
  };
  const onApproveCustomPeriod = (expireAt) => {
    ExchanegeRateService.putApiV1ExchanegeRateExtend({
      requestBody: {
        rateId: props.rowData.rateId,
        expireAt: expireAt?.toISOString()
      }
    }).then((res) => {
      closeModal();
      openModal({
        content: /* @__PURE__ */ jsx47(
          ResultModal4,
          {
            title: res.isSuccess ? "\u0423\u0441\u043F\u0435\u0448\u043D\u043E" : "\u041F\u0440\u043E\u0434\u043B\u0438\u0442\u044C \u043A\u0443\u0440\u0441 \u043D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C",
            description: res.isSuccess ? "\u041A\u0443\u0440\u0441 \u0432\u0430\u043B\u044E\u0442\u044B \u0431\u044B\u043B \u043F\u0440\u043E\u0434\u043B\u0435\u043D" : "\u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C \u043F\u043E\u0437\u0434\u043D\u0435\u0435",
            type: res.isSuccess ? "success" : "error",
            onBack: () => {
              navigate("/rates");
              closeModal();
              props.reload?.();
            }
          }
        ),
        opaqueBackground: true
      });
    });
  };
  const handleCustomPreriodClick = () => {
    try {
      openModal({
        content: /* @__PURE__ */ jsx47(
          ExtendRateModal,
          {
            onApprove: onApproveCustomPeriod,
            onClose: () => {
              closeModal();
              props.reload?.();
            }
          }
        ),
        modalType: "custom"
      });
    } catch (error) {
      console.log(error);
    }
  };
  return /* @__PURE__ */ jsxs41(
    Dropdown,
    {
      label: "",
      dismissOnClick: false,
      placement: "right-start",
      renderTrigger: () => /* @__PURE__ */ jsx47(Button20, { size: "sm", color: "gray", className: "px-2 bg-transparent", children: /* @__PURE__ */ jsx47(Icon9, { name: "dots-horizontal-outline" }) }),
      children: [
        /* @__PURE__ */ jsx47(
          DropdownItem,
          {
            className: "text-sm font-medium text-gray-900",
            onClick: handleChangeRateClick,
            children: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043A\u0443\u0440\u0441"
          }
        ),
        /* @__PURE__ */ jsx47(DropdownItem, { className: "py-0 text-sm font-medium text-gray-900", children: /* @__PURE__ */ jsxs41(
          Dropdown,
          {
            label: "",
            dismissOnClick: false,
            placement: "right-start",
            renderTrigger: () => /* @__PURE__ */ jsxs41(
              Button20,
              {
                color: "gray",
                className: "px-0  bg-transparent hover:bg-transparent",
                children: [
                  /* @__PURE__ */ jsxs41("div", { className: "flex gap-1.5 items-center w-full", children: [
                    /* @__PURE__ */ jsx47("span", { children: "\u041F\u0440\u043E\u0434\u043B\u0438\u0442\u044C \u043A\u0443\u0440\u0441" }),
                    /* @__PURE__ */ jsxs41("div", { className: "flex gap-2 py-0.5 px-2.5 rounded-full bg-green-100 items-center", children: [
                      /* @__PURE__ */ jsx47("span", { className: "w-3 h-3 rounded-full bg-green-500" }),
                      /* @__PURE__ */ jsx47("span", { className: "text-xs text-green-800", children: "24 \u0447" })
                    ] })
                  ] }),
                  /* @__PURE__ */ jsx47(Icon9, { name: "chevron-right", color: "#111928", className: "ml-auto" })
                ]
              }
            ),
            children: [
              timePeriods.map((period, index) => /* @__PURE__ */ jsx47(
                DropdownItem,
                {
                  className: "text-sm font-medium text-gray-900",
                  onClick: () => handlePreferredPeriodClick(period.value),
                  children: period.label
                },
                index
              )),
              /* @__PURE__ */ jsx47(
                DropdownItem,
                {
                  className: "text-sm font-medium text-gray-900",
                  onClick: handleCustomPreriodClick,
                  children: "\u0417\u0430\u0434\u0430\u0442\u044C \u0432\u0440\u0435\u043C\u044F"
                }
              )
            ]
          }
        ) }),
        /* @__PURE__ */ jsx47(DropdownDivider, {}),
        /* @__PURE__ */ jsx47(
          DropdownItem,
          {
            onClick: handleDeleteClick,
            className: "text-red-600 hover:text-red-800 hover:bg-red-50",
            children: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0438\u0437 \u0441\u043F\u0438\u0441\u043A\u0430"
          }
        )
      ]
    }
  );
};

// src/widgets/exchangeRate/ui/filter.tsx
import { Icon as Icon10 } from "@acme/assets";
import {
  useCryptoCurrency as useCryptoCurrency3,
  useCurrency
} from "@acme/domains";
import { RangeDropdownFilter, CustomSelectDropdown } from "@acme/foundation";
import { TextInput as TextInput7 } from "flowbite-react";
import { useMemo as useMemo7, useState as useState14 } from "react";
import { Fragment as Fragment14, jsx as jsx48, jsxs as jsxs42 } from "react/jsx-runtime";
var defaultOption = { value: "\u0412\u0441\u0435", label: "\u0412\u0441\u0435" };
var Filter = (props) => {
  const { currencies } = useCurrency();
  const { currencies: cryptoCurrencies } = useCryptoCurrency3();
  const currenciesOptions = useMemo7(() => {
    return currencies.map((i) => {
      return {
        label: i.code || "",
        value: String(i.id || "")
      };
    });
  }, [currencies]);
  const cryptoCurrenciesOptions = useMemo7(() => {
    return cryptoCurrencies.map((i) => {
      return {
        label: i.code || "",
        value: String(i.id || "")
      };
    });
  }, [cryptoCurrencies]);
  const [values, setValues] = useState14({});
  const handleChange = (field, value) => {
    const newValues = { ...values, [field]: value };
    setValues(newValues);
    props.onChange?.(newValues);
  };
  const handleVolumeChange = (value) => {
    const { amountMin, amountMax, ...rest } = values;
    const newValues = typeof value === "string" ? rest : {
      ...rest,
      amountMin: Number(value.from),
      amountMax: Number(value.to)
    };
    setValues(newValues);
    props.onChange?.(newValues);
  };
  const renderFields = () => {
    switch (props.mode) {
      case "VOLUME_SEARCH" /* VOLUME_SEARCH */:
        return /* @__PURE__ */ jsxs42(Fragment14, { children: [
          /* @__PURE__ */ jsx48(
            RangeDropdownFilter,
            {
              label: "\u041E\u0431\u044A\u0451\u043C \u0434\u043B\u044F \u043A\u0443\u0440\u0441\u0430",
              onChange: handleVolumeChange
            }
          ),
          /* @__PURE__ */ jsx48(
            TextInput7,
            {
              className: "ml-auto",
              icon: () => /* @__PURE__ */ jsx48(Icon10, { name: "search-outline" }),
              onChange: (e) => handleChange("search", e.target.value),
              placeholder: "\u041D\u0430\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0435 \u043A\u043E\u043D\u0442\u0440\u0430\u0433\u0435\u043D\u0442\u0430"
            }
          )
        ] });
      case "CURRENCY_PAIR" /* CURRENCY_PAIR */:
        return /* @__PURE__ */ jsx48("div", { className: "flex items-center gap-4", children: /* @__PURE__ */ jsx48(
          CustomSelectDropdown,
          {
            label: "\u0412\u0430\u043B\u044E\u0442\u0430 \u043A\u043E\u0442\u0438\u0440\u043E\u0432\u043A\u0438",
            onChange: (val) => handleChange("cryptoCurrencies", val),
            defaultOption,
            options: cryptoCurrenciesOptions
          }
        ) });
      case "ALL_FIELDS" /* ALL_FIELDS */:
        return /* @__PURE__ */ jsxs42(Fragment14, { children: [
          /* @__PURE__ */ jsxs42("div", { className: "flex items-center gap-4", children: [
            /* @__PURE__ */ jsx48(
              CustomSelectDropdown,
              {
                label: "\u0412\u0430\u043B\u044E\u0442\u0430 \u043A\u043E\u0442\u0438\u0440\u043E\u0432\u043A\u0438",
                onChange: (val) => handleChange("cryptoCurrencies", val),
                defaultOption,
                options: cryptoCurrenciesOptions
              }
            ),
            /* @__PURE__ */ jsx48(
              RangeDropdownFilter,
              {
                label: "\u041E\u0431\u044A\u0451\u043C \u0434\u043B\u044F \u043A\u0443\u0440\u0441\u0430",
                onChange: handleVolumeChange
              }
            )
          ] }),
          /* @__PURE__ */ jsx48(
            TextInput7,
            {
              className: "ml-auto",
              icon: () => /* @__PURE__ */ jsx48(Icon10, { name: "search-outline" }),
              onChange: (e) => handleChange("search", e.target.value),
              placeholder: "\u041D\u0430\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0435 \u043A\u043E\u043D\u0442\u0440\u0430\u0433\u0435\u043D\u0442\u0430"
            }
          )
        ] });
    }
  };
  return /* @__PURE__ */ jsx48("div", { className: "flex items-center gap-4 py-4", children: renderFields() });
};

// src/widgets/exchangeRate/ui/noData/noData.tsx
import { Image as Image8 } from "@acme/assets";
import { jsx as jsx49, jsxs as jsxs43 } from "react/jsx-runtime";
var NoData = ({ title }) => {
  return /* @__PURE__ */ jsx49(
    "div",
    {
      className: "flex flex-col items-center justify-center px-0 py-24 bg-white h-full",
      children: /* @__PURE__ */ jsxs43("div", { className: "flex flex-col gap-6 items-center justify-center p-6 w-[448px] ", children: [
        /* @__PURE__ */ jsx49("div", { className: "overflow-hidden relative shrink-0 w-40", children: /* @__PURE__ */ jsx49(
          Image8,
          {
            name: "app-monetization",
            alt: `no currency rates`,
            className: "w-full h-full object-contain",
            width: "100%",
            height: "100%"
          }
        ) }),
        /* @__PURE__ */ jsx49("div", { className: "flex flex-col gap-1 items-center relative shrink-0 w-full", children: /* @__PURE__ */ jsx49("div", { className: "flex flex-col gap-0 items-center relative shrink-0 w-full text-base text-center", children: /* @__PURE__ */ jsx49("div", { className: "font-medium text-base leading-normal text-center align-middle text-gray-900 tracking-normal", children: title }) }) })
      ] })
    }
  );
};

// src/widgets/exchangeRate/ui/noData/noMyCourses.tsx
import { Image as Image9 } from "@acme/assets";
import { jsx as jsx50, jsxs as jsxs44 } from "react/jsx-runtime";

// src/widgets/exchangeRate/ui/rateHistoryTable.tsx
import {
  Badge,
  Spinner,
  Table as Table2,
  TableBody as TableBody2,
  TableCell as TableCell2,
  TableHead as TableHead2,
  TableHeadCell as TableHeadCell2,
  TableRow as TableRow2
} from "flowbite-react";
import { Link } from "react-router-dom";
import {
  EExchangeRateStatusEnum
} from "@acme/domains";
import { useModal as useModal7 } from "@acme/foundation";
import { ExchanegeRateService as ExchanegeRateService2, RoleEnum as RoleEnum2 } from "@acme/api";
import { jsx as jsx51, jsxs as jsxs45 } from "react/jsx-runtime";
var RateHistoryTable = (props) => {
  const { openModal, closeModal } = useModal7();
  const handleApproveClick = () => {
    openModal({
      content: /* @__PURE__ */ jsx51(
        ExchangeRateForm,
        {
          onClose: closeModal,
          onSubmit: ExchanegeRateService2.postApiV1ExchanegeRateCreate
        }
      ),
      size: "xl",
      modalType: "custom"
    });
  };
  if (props.loading) {
    return /* @__PURE__ */ jsx51("div", { className: "bg-white rounded-lg shadow-md p-6", children: /* @__PURE__ */ jsxs45("div", { className: "flex items-center justify-center py-8", children: [
      /* @__PURE__ */ jsx51(Spinner, { size: "lg" }),
      /* @__PURE__ */ jsx51("span", { className: "ml-3 text-gray-600", children: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u0438\u0441\u0442\u043E\u0440\u0438\u0438 \u043A\u0443\u0440\u0441\u0430..." })
    ] }) });
  }
  return /* @__PURE__ */ jsxs45(Table2, { hoverable: true, children: [
    /* @__PURE__ */ jsx51(TableHead2, { children: /* @__PURE__ */ jsxs45(TableRow2, { children: [
      /* @__PURE__ */ jsx51(TableHeadCell2, { children: "\u0412\u0440\u0435\u043C\u044F \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F" }),
      /* @__PURE__ */ jsx51(TableHeadCell2, { children: "\u041D\u043E\u0432\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435" }),
      /* @__PURE__ */ jsx51(TableHeadCell2, { children: "\u0421\u0442\u0430\u0440\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435" }),
      /* @__PURE__ */ jsx51(TableHeadCell2, { children: "\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u0435\u043D \u0434\u043E" }),
      /* @__PURE__ */ jsx51(TableHeadCell2, { children: "\u041A\u0435\u043C \u0431\u044B\u043B \u0438\u0437\u043C\u0435\u043D\u0435\u043D" })
    ] }) }),
    /* @__PURE__ */ jsx51(TableBody2, { className: "divide-y text-sm font-normal", children: props.data?.map((rate, index) => /* @__PURE__ */ jsxs45(TableRow2, { children: [
      /* @__PURE__ */ jsx51(TableCell2, { className: "whitespace-nowrap font-medium text-gray-900 dark:text-white", children: formatDate2(rate.updatedAt) }),
      /* @__PURE__ */ jsx51(TableCell2, { className: "whitespace-nowrap", children: /* @__PURE__ */ jsx51("div", { className: "flex gap-2.5", children: rate.newData?.status !== EExchangeRateStatusEnum.Blocked ? rate.newData?.ranges?.map((course, index2) => /* @__PURE__ */ jsxs45(
        "div",
        {
          className: `flex gap-2 ${rate.newData?.status === EExchangeRateStatusEnum.IsEditedByNotOwner ? "text-yellow-500" : "text-gray-500"}`,
          children: [
            `\u041A\u0443\u0440\u0441 ${index2 + 1}`,
            ":",
            /* @__PURE__ */ jsx51(
              "div",
              {
                className: rate.newData?.status === EExchangeRateStatusEnum.IsEditedByNotOwner ? "text-yellow-800" : "text-gray-900",
                children: course.price
              }
            )
          ]
        }
      )) : props.adminMode ? /* @__PURE__ */ jsx51("div", { className: "text-sm font-medium text-gray-500 gap-2", children: "\u041A\u0443\u0440\u0441 \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D. \u041E\u0436\u0438\u0434\u0430\u0435\u043C \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u043E\u0442 \u041F\u041B" }) : /* @__PURE__ */ jsxs45("div", { className: "flex text-sm font-medium text-gray-500 gap-2", children: [
        "\u041A\u0443\u0440\u0441 \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D, \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E:",
        /* @__PURE__ */ jsx51(
          "div",
          {
            className: "text-brand-purple-900 cursor-pointer",
            onClick: () => handleApproveClick(),
            children: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u043A\u0443\u0440\u0441\u0430"
          }
        )
      ] }) }) }),
      /* @__PURE__ */ jsx51(TableCell2, { className: "whitespace-nowrap", children: /* @__PURE__ */ jsx51("div", { className: "flex gap-2.5", children: rate.previousData?.ranges?.map((course, index2) => /* @__PURE__ */ jsxs45("div", { className: "flex gap-2 text-gray-500", children: [
        `\u041A\u0443\u0440\u0441 ${index2 + 1}`,
        ":",
        /* @__PURE__ */ jsx51("div", { className: "text-gray-900", children: course.price })
      ] })) }) }),
      /* @__PURE__ */ jsx51(TableCell2, { className: "text-gray-900", children: formatDate2(rate.newData?.expireAt) }),
      /* @__PURE__ */ jsxs45(TableCell2, { className: "text-primary-600 flex items-center gap-2", children: [
        /* @__PURE__ */ jsx51(Badge, { color: "purple", children: rate.initiatorUserOrganizationRole === RoleEnum2.Admin ? "\u0423\u041E" : "\u041F\u041B" }),
        /* @__PURE__ */ jsx51(Link, { to: `users/${rate.initiatorUserId}`, children: rate.initiatorUserName })
      ] })
    ] }, index)) })
  ] });
};

// src/widgets/exchangeRate/ui/exchangeRateTable.tsx
import { Fragment as Fragment15, jsx as jsx52, jsxs as jsxs46 } from "react/jsx-runtime";
var EExchangeTableState = /* @__PURE__ */ ((EExchangeTableState2) => {
  EExchangeTableState2[EExchangeTableState2["Buy"] = 1] = "Buy";
  EExchangeTableState2[EExchangeTableState2["Sell"] = 2] = "Sell";
  return EExchangeTableState2;
})(EExchangeTableState || {});
var ExchangeRateTable = ({
  loading,
  loader,
  onRowClick,
  filterMode,
  tableMode = 1 /* General */
}) => {
  const { openModal, closeModal } = useModal8();
  const [tableState, setTableState] = useState15(
    filterMode || 1 /* Buy */
  );
  const [data, setData] = useState15();
  const [filter, setFilter] = useState15({});
  const loadData = useCallback6(async () => {
    const response = await loader({
      ...filter,
      type: tableState === 1 /* Buy */ ? 100 : 200,
      organziationFilter: tableMode === 2 /* My */ ? 100 : 200
    });
    setData(response);
  }, [filter, tableState, tableMode]);
  useEffect8(() => {
    loadData();
  }, [filter, tableState]);
  const handleAddCurrencyClick = () => {
    openModal({
      content: /* @__PURE__ */ jsx52(
        ExchangeRateForm,
        {
          onClose: closeModal,
          onSubmit: ExchanegeRateService3.postApiV1ExchanegeRateCreate
        }
      ),
      size: "xl",
      modalType: "custom"
    });
  };
  const loadRateHistory = async (rateId) => {
    const res = await ExchanegeRateService3.getApiV1ExchanegeRateHistory({
      rateId
    });
    return res.data;
  };
  const handleApproveClick = (rowData) => {
    openModal({
      content: /* @__PURE__ */ jsx52(
        ExchangeRateForm,
        {
          onClose: closeModal,
          onSubmit: ExchanegeRateService3.postApiV1ExchanegeRateCreate,
          defaultData: rowData
        }
      ),
      size: "xl",
      modalType: "custom"
    });
  };
  const onRateStoryClick = async (rateId, currencyPair) => {
    const ratesHistory = await loadRateHistory(rateId);
    openModal({
      content: /* @__PURE__ */ jsxs46(Fragment15, { children: [
        /* @__PURE__ */ jsxs46("div", { className: "flex pb-5", children: [
          /* @__PURE__ */ jsx52("h3", { className: "text-gray-900 text-lg font-semibold", children: currencyPair }),
          /* @__PURE__ */ jsx52(
            "button",
            {
              onClick: closeModal,
              className: "text-gray-400 hover:text-gray-600 ml-auto",
              children: /* @__PURE__ */ jsx52(HiX4, { className: "h-5 w-5" })
            }
          )
        ] }),
        /* @__PURE__ */ jsx52(Separator11, { className: "-mx-5" }),
        /* @__PURE__ */ jsx52("div", { className: "overflow-auto max-h-[387px]", children: /* @__PURE__ */ jsx52(RateHistoryTable, { data: ratesHistory ?? [] }) })
      ] }),
      size: "6xl",
      modalType: "custom"
    });
  };
  if (loading) {
    return /* @__PURE__ */ jsx52("div", { className: "bg-white rounded-lg shadow-md p-6", children: /* @__PURE__ */ jsxs46("div", { className: "flex items-center justify-center py-8", children: [
      /* @__PURE__ */ jsx52(Spinner2, { size: "lg" }),
      /* @__PURE__ */ jsx52("span", { className: "ml-3 text-gray-600", children: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u043A\u0443\u0440\u0441\u043E\u0432 \u0432\u0430\u043B\u044E\u0442..." })
    ] }) });
  }
  return /* @__PURE__ */ jsxs46("div", { className: "bg-white rounded-lg shadow-md overflow-hidden", children: [
    /* @__PURE__ */ jsxs46("div", { className: "flex flex-col px-4", children: [
      !filterMode && /* @__PURE__ */ jsxs46("div", { className: "flex items-center gap-4 py-4", children: [
        /* @__PURE__ */ jsx52("p", { className: "text-base font-semibold text-gray-500", children: "\u041F\u043E\u043A\u0430\u0437\u044B\u0432\u0430\u0442\u044C:" }),
        /* @__PURE__ */ jsxs46(ButtonGroup, { children: [
          /* @__PURE__ */ jsx52(
            Button21,
            {
              color: "primary",
              outline: true,
              onClick: () => setTableState(1 /* Buy */),
              children: "\u041F\u043E\u043A\u0443\u043F\u043A\u0430"
            }
          ),
          /* @__PURE__ */ jsx52(
            Button21,
            {
              color: "primary",
              outline: true,
              onClick: () => setTableState(2 /* Sell */),
              children: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430"
            }
          )
        ] }),
        tableMode === 2 /* My */ && /* @__PURE__ */ jsxs46(
          Button21,
          {
            color: "primary",
            className: "ml-auto flex gap-2",
            onClick: handleAddCurrencyClick,
            children: [
              "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0432\u0430\u043B\u044E\u0442\u0443",
              /* @__PURE__ */ jsx52(Icon11, { name: "plus-outline", color: "#FFFFFF" })
            ]
          }
        )
      ] }),
      tableMode === 1 /* General */ && /* @__PURE__ */ jsx52(
        Filter,
        {
          mode: tableState === 1 /* Buy */ ? "ALL_FIELDS" /* ALL_FIELDS */ : "VOLUME_SEARCH" /* VOLUME_SEARCH */,
          onChange: setFilter
        }
      )
    ] }),
    data?.items?.length === 0 ? /* @__PURE__ */ jsx52(
      NoData,
      {
        title: Object.keys(filter).length === 0 ? "\u041A\u0443\u0440\u0441\u044B \u043F\u043E\u043A\u0430 \u043D\u0435 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u044B" : "\u041A\u0443\u0440\u0441\u044B \u043F\u043E \u0437\u0430\u0434\u0430\u043D\u043D\u044B\u043C \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u044B"
      }
    ) : /* @__PURE__ */ jsx52("div", { className: "overflow-x-auto", children: /* @__PURE__ */ jsxs46(Table3, { hoverable: true, children: [
      /* @__PURE__ */ jsx52(TableHead3, { children: /* @__PURE__ */ jsxs46(TableRow3, { children: [
        tableMode === 2 /* My */ ? /* @__PURE__ */ jsxs46(Fragment15, { children: [
          /* @__PURE__ */ jsx52(TableHeadCell3, {}),
          /* @__PURE__ */ jsx52(TableHeadCell3, {})
        ] }) : /* @__PURE__ */ jsx52(TableHeadCell3, { children: "\u041D\u0430\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0435 \u043A\u043E\u043D\u0442\u0440\u0430\u0433\u0435\u043D\u0442\u0430" }),
        /* @__PURE__ */ jsx52(TableHeadCell3, { children: "\u0412\u0430\u043B\u044E\u0442\u043D\u0430\u044F \u043F\u0430\u0440\u0430" }),
        /* @__PURE__ */ jsx52(TableHeadCell3, { children: "\u041E\u0431\u044A\u0435\u043C \u0432\u0430\u043B\u044E\u0442\u044B" }),
        /* @__PURE__ */ jsx52(TableHeadCell3, { children: "\u041E\u0431\u044A\u0435\u043C" }),
        /* @__PURE__ */ jsx52(TableHeadCell3, { children: "\u0414\u0438\u0430\u043F\u0430\u0437\u043E\u043D \u043E\u0431\u044A\u0435\u043C\u0430" }),
        /* @__PURE__ */ jsx52(TableHeadCell3, { children: "\u0412\u0440\u0435\u043C\u044F \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F" }),
        /* @__PURE__ */ jsx52(TableHeadCell3, { children: tableMode === 2 /* My */ ? "\u0412\u0440\u0435\u043C\u044F \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u0434\u043E" : "\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0443\u0441\u043F\u0435\u0448\u043D\u044B\u0445 \u0441\u0434\u0435\u043B\u043E\u043A" })
      ] }) }),
      /* @__PURE__ */ jsx52(TableBody3, { className: "divide-y", children: data?.items?.map((rate) => /* @__PURE__ */ jsxs46(
        TableRow3,
        {
          onClick: () => onRowClick?.(rate.rangeId || ""),
          className: `text-sm font-normal text-gray-900 dark:text-white ${rate.status === EExchangeRateStatusEnum2.Blocked && "bg-red-50 border-red-100 hover:bg-red-100"} 
                  ${rate.status === EExchangeRateStatusEnum2.IsEditedByNotOwner && "bg-yellow-50 border-yellow-100 hover:bg-yellow-100"}`,
          children: [
            tableMode === 2 /* My */ ? /* @__PURE__ */ jsxs46(Fragment15, { children: [
              /* @__PURE__ */ jsx52(TableCell3, { className: "w-[60px] text-gray-500", children: /* @__PURE__ */ jsx52(
                "button",
                {
                  onClick: () => onRateStoryClick(
                    rate.rateId,
                    `${rate.cryptoCurrency?.code} > ${rate.currency?.code}`
                  ),
                  children: /* @__PURE__ */ jsx52(Icon11, { name: "clock-outline" })
                }
              ) }),
              /* @__PURE__ */ jsx52(TableCell3, { className: "w-[60px] flex px-0 flex-wrap justify-center text-gray-500", children: rate.status === EExchangeRateStatusEnum2.Blocked ? /* @__PURE__ */ jsx52(
                Button21,
                {
                  size: "sm",
                  color: "gray",
                  className: "px-2 bg-transparent text-gray-500",
                  onClick: () => handleApproveClick(rate),
                  children: /* @__PURE__ */ jsx52(Icon11, { name: "edit-outline" })
                }
              ) : /* @__PURE__ */ jsx52(ActionMenuButton, { rowData: rate, reload: loadData }) })
            ] }) : /* @__PURE__ */ jsx52(TableCell3, { className: "whitespace-nowrap", children: rate.organization?.name }),
            /* @__PURE__ */ jsx52(TableCell3, { className: "whitespace-nowrap", children: `${rate.cryptoCurrency?.code} > ${rate.currency?.code}` }),
            /* @__PURE__ */ jsx52(TableCell3, { className: "whitespace-nowrap", children: `${rate.amount} ${rate.cryptoCurrency?.code}` }),
            /* @__PURE__ */ jsx52(TableCell3, { className: "whitespace-nowrap", children: `${rate.price} ${rate.currency?.code}` }),
            /* @__PURE__ */ jsx52(TableCell3, { className: "whitespace-nowrap", children: `\u041E\u0442 ${rate.rangeMin} \u0434\u043E ${rate.rangeMax}` }),
            /* @__PURE__ */ jsx52(TableCell3, { className: " whitespace-nowrap", children: formatDate2(rate.updatedAt) }),
            /* @__PURE__ */ jsx52(TableCell3, { className: "whitespace-nowrap", children: tableMode === 2 /* My */ ? formatDate2(rate.expireAt) : rate.dealsCount })
          ]
        },
        rate.rangeId
      )) })
    ] }) })
  ] });
};

// src/widgets/exchangeRate/ui/recommendedExchangeRates.tsx
import {
  Spinner as Spinner3,
  Table as Table4,
  TableBody as TableBody4,
  TableCell as TableCell4,
  TableHead as TableHead4,
  TableHeadCell as TableHeadCell4,
  TableRow as TableRow4
} from "flowbite-react";
import { useEffect as useEffect9, useState as useState16 } from "react";
import { jsx as jsx53, jsxs as jsxs47 } from "react/jsx-runtime";
var RecommendedExchangeRates = ({
  loading,
  loader
}) => {
  const [data, setData] = useState16();
  const [filter, setFilter] = useState16({});
  useEffect9(() => {
    const loadItems = async () => {
      const response = await loader({
        ...filter
      });
      setData(response);
    };
    loadItems();
  }, [filter]);
  if (loading) {
    return /* @__PURE__ */ jsx53("div", { className: "bg-white rounded-lg shadow-md p-6", children: /* @__PURE__ */ jsxs47("div", { className: "flex items-center justify-center py-8", children: [
      /* @__PURE__ */ jsx53(Spinner3, { size: "lg" }),
      /* @__PURE__ */ jsx53("span", { className: "ml-3 text-gray-600", children: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u043A\u0443\u0440\u0441\u043E\u0432 \u0432\u0430\u043B\u044E\u0442..." })
    ] }) });
  }
  return /* @__PURE__ */ jsxs47("div", { className: "bg-white rounded-lg shadow-md overflow-hidden", children: [
    /* @__PURE__ */ jsx53("div", { className: "flex flex-col px-4 gap-2", children: /* @__PURE__ */ jsx53(Filter, { mode: "CURRENCY_PAIR" /* CURRENCY_PAIR */, onChange: setFilter }) }),
    data?.items?.length === 0 ? /* @__PURE__ */ jsx53(
      NoData,
      {
        title: Object.keys(filter).length === 0 ? "\u041A\u0443\u0440\u0441\u044B \u043F\u043E\u043A\u0430 \u043D\u0435 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u044B" : "\u041A\u0443\u0440\u0441\u044B \u043F\u043E \u0437\u0430\u0434\u0430\u043D\u043D\u044B\u043C \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u044B"
      }
    ) : /* @__PURE__ */ jsx53("div", { className: "overflow-x-auto", children: /* @__PURE__ */ jsxs47(Table4, { hoverable: true, children: [
      /* @__PURE__ */ jsx53(TableHead4, { children: /* @__PURE__ */ jsxs47(TableRow4, { children: [
        /* @__PURE__ */ jsx53(TableHeadCell4, { children: "\u0412\u0430\u043B\u044E\u0442\u043D\u0430\u044F \u043F\u0430\u0440\u0430" }),
        /* @__PURE__ */ jsx53(TableHeadCell4, { children: "\u041F\u043E\u043A\u0443\u043F\u043A\u0430" }),
        /* @__PURE__ */ jsx53(TableHeadCell4, { children: "\u041F\u0440\u043E\u0434\u0430\u0436\u0430" }),
        /* @__PURE__ */ jsx53(TableHeadCell4, { children: "\u0412\u0440\u0435\u043C\u044F \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F" })
      ] }) }),
      /* @__PURE__ */ jsx53(TableBody4, { className: "divide-y", children: data?.items?.map((rate) => /* @__PURE__ */ jsxs47(
        TableRow4,
        {
          className: "text-sm font-normal text-gray-900 dark:text-white",
          children: [
            /* @__PURE__ */ jsx53(TableCell4, { className: "whitespace-nowrap", children: `${rate.cryptoCurrency?.code} > ${rate.currency?.code}` }),
            /* @__PURE__ */ jsx53(TableCell4, { className: "whitespace-nowrap", children: rate.buyPrice }),
            /* @__PURE__ */ jsx53(TableCell4, { className: "truncate", children: rate.sellPrice }),
            /* @__PURE__ */ jsx53(TableCell4, { className: "truncate", children: formatDate2(rate.updateAt) })
          ]
        },
        rate.id
      )) })
    ] }) })
  ] });
};

// src/widgets/exchangeRate/ui/adminRateTable.tsx
import { ExchanegeRateService as ExchanegeRateService5 } from "@acme/api";
import { Icon as Icon13 } from "@acme/assets";
import { Separator as Separator12, useModal as useModal10 } from "@acme/foundation";
import {
  Button as Button23,
  Spinner as Spinner4,
  Table as Table5,
  TableBody as TableBody5,
  TableCell as TableCell5,
  TableHead as TableHead5,
  TableHeadCell as TableHeadCell5,
  TableRow as TableRow5
} from "flowbite-react";
import { useEffect as useEffect10, useState as useState17 } from "react";
import { HiX as HiX5 } from "react-icons/hi";
import { useNavigate as useNavigate8 } from "react-router-dom";

// src/widgets/exchangeRate/ui/adminActionMenu.tsx
import { ExchanegeRateService as ExchanegeRateService4 } from "@acme/api";
import { Icon as Icon12 } from "@acme/assets";
import { ResultModal as ResultModal5, TextAreaModal as TextAreaModal2, useModal as useModal9 } from "@acme/foundation";
import { Button as Button22, Dropdown as Dropdown2, DropdownItem as DropdownItem2 } from "flowbite-react";
import { useNavigate as useNavigate7 } from "react-router-dom";
import { jsx as jsx54, jsxs as jsxs48 } from "react/jsx-runtime";
var AdminActionMenu = (props) => {
  const { openModal, closeModal } = useModal9();
  const navigate = useNavigate7();
  const onBlockRate = (comment) => {
    ExchanegeRateService4.putApiV1ExchanegeRateBlock({
      requestBody: {
        rateId: props.rowData.rateId,
        comment
      }
    }).then(() => {
      openModal({
        content: /* @__PURE__ */ jsx54(
          ResultModal5,
          {
            title: "\u0423\u0441\u043F\u0435\u0448\u043D\u043E",
            description: "\u041A\u0443\u0440\u0441 \u0432\u0430\u043B\u044E\u0442\u044B \u0431\u044B\u043B \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D",
            type: "success",
            onBack: () => {
              closeModal();
            }
          }
        ),
        opaqueBackground: true
      });
    }).catch(() => {
      openModal({
        content: /* @__PURE__ */ jsx54(
          ResultModal5,
          {
            title: "\u0417\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043A\u0443\u0440\u0441 \u043D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C",
            description: "\u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C \u043F\u043E\u0437\u0434\u043D\u0435\u0435",
            type: "error",
            onBack: () => {
              navigate("/rates");
              closeModal();
            }
          }
        ),
        opaqueBackground: true
      });
    });
  };
  const handleBlockRateClick = () => {
    openModal({
      content: /* @__PURE__ */ jsx54(
        TextAreaModal2,
        {
          title: "\u0411\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u043A\u0430 \u043A\u0443\u0440\u0441\u0430",
          areaLabel: "\u0417\u0430\u043F\u0440\u043E\u0441\u0438\u0442\u044C \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E\u0435 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435",
          approveButtonText: "\u0417\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u0442\u044C",
          onClose: closeModal,
          onApprove: (value) => {
            closeModal();
            onBlockRate(value);
          }
        }
      ),
      modalType: "custom"
    });
  };
  const handleCorrectRateClick = () => {
    openModal({
      content: /* @__PURE__ */ jsx54(
        ExchangeRateForm,
        {
          onClose: closeModal,
          onSubmit: ExchanegeRateService4.putApiV1ExchanegeRateUpdateAdmin,
          defaultData: props.rowData,
          adminMode: true
        }
      ),
      size: "xl",
      modalType: "custom"
    });
  };
  return /* @__PURE__ */ jsxs48(
    Dropdown2,
    {
      label: "",
      dismissOnClick: false,
      placement: "right-start",
      renderTrigger: () => /* @__PURE__ */ jsx54(
        Button22,
        {
          size: "sm",
          color: "gray",
          className: "px-2 py-1 bg-transparent hover:bg-transparent",
          children: /* @__PURE__ */ jsx54(Icon12, { name: "dots-horizontal-outline" })
        }
      ),
      children: [
        /* @__PURE__ */ jsx54(
          DropdownItem2,
          {
            className: "text-sm font-medium text-gray-900 py-2 px-3 min-w-[200px]",
            onClick: handleCorrectRateClick,
            children: "\u0421\u043A\u043E\u0440\u0440\u0435\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043A\u0443\u0440\u0441"
          }
        ),
        /* @__PURE__ */ jsx54(
          DropdownItem2,
          {
            className: "text-sm font-medium text-gray-900 py-2 px-3",
            onClick: handleBlockRateClick,
            children: "\u0417\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043A\u0443\u0440\u0441"
          }
        )
      ]
    }
  );
};

// src/widgets/exchangeRate/ui/adminRateTable.tsx
import { Fragment as Fragment16, jsx as jsx55, jsxs as jsxs49 } from "react/jsx-runtime";
var AdminRateTable = ({
  loading,
  loader,
  onRowClick,
  filterMode
}) => {
  const { openModal, closeModal } = useModal10();
  const [tableState, setTableState] = useState17(
    filterMode || 1 /* Buy */
  );
  const [data, setData] = useState17();
  const [filter, setFilter] = useState17({});
  const navigate = useNavigate8();
  useEffect10(() => {
    const loadItems = async () => {
      const response = await loader({
        ...filter,
        type: tableState === 1 /* Buy */ ? 100 : 200
      });
      setData(response);
    };
    loadItems();
  }, [filter, tableState]);
  const loadRateHistory = async (rateId) => {
    const res = await ExchanegeRateService5.getApiV1ExchanegeRateHistory({
      rateId
    });
    return res.data;
  };
  const onRateStoryClick = async (rateId, currencyPair) => {
    const ratesHistory = await loadRateHistory(rateId);
    openModal({
      content: /* @__PURE__ */ jsxs49(Fragment16, { children: [
        /* @__PURE__ */ jsxs49("div", { className: "flex pb-5", children: [
          /* @__PURE__ */ jsx55("h3", { className: "text-gray-900 text-lg font-semibold", children: currencyPair }),
          /* @__PURE__ */ jsx55(
            "button",
            {
              onClick: closeModal,
              className: "text-gray-400 hover:text-gray-600 ml-auto",
              children: /* @__PURE__ */ jsx55(HiX5, { className: "h-5 w-5" })
            }
          )
        ] }),
        /* @__PURE__ */ jsx55(Separator12, { className: "-mx-5" }),
        /* @__PURE__ */ jsx55("div", { className: "overflow-auto max-h-[387px] ", children: /* @__PURE__ */ jsx55(RateHistoryTable, { data: ratesHistory ?? [], adminMode: true }) })
      ] }),
      size: "6xl",
      modalType: "custom"
    });
  };
  if (loading) {
    return /* @__PURE__ */ jsx55("div", { className: "bg-white rounded-lg shadow-md p-6", children: /* @__PURE__ */ jsxs49("div", { className: "flex items-center justify-center py-8", children: [
      /* @__PURE__ */ jsx55(Spinner4, { size: "lg" }),
      /* @__PURE__ */ jsx55("span", { className: "ml-3 text-gray-600", children: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u043A\u0443\u0440\u0441\u043E\u0432 \u0432\u0430\u043B\u044E\u0442..." })
    ] }) });
  }
  return /* @__PURE__ */ jsxs49("div", { className: "bg-white rounded-lg shadow-md overflow-hidden", children: [
    /* @__PURE__ */ jsxs49("div", { className: "flex flex-col px-4", children: [
      /* @__PURE__ */ jsx55("div", { className: "flex items-center gap-4 border-b border-gray-200 py-4", children: /* @__PURE__ */ jsx55(
        Button23,
        {
          color: "primary",
          outline: true,
          onClick: () => navigate("/rates/currencyList"),
          children: "\u0421\u043F\u0440\u0430\u0432\u043E\u0447\u043D\u0438\u043A \u0432\u0430\u043B\u044E\u0442"
        }
      ) }),
      /* @__PURE__ */ jsx55(Filter, { mode: "ALL_FIELDS" /* ALL_FIELDS */, onChange: setFilter })
    ] }),
    data?.items?.length === 0 ? /* @__PURE__ */ jsx55(
      NoData,
      {
        title: Object.keys(filter).length === 0 ? "\u041A\u0443\u0440\u0441\u044B \u043F\u043E\u043A\u0430 \u043D\u0435 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u044B" : "\u041A\u0443\u0440\u0441\u044B \u043F\u043E \u0437\u0430\u0434\u0430\u043D\u043D\u044B\u043C \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u044B"
      }
    ) : /* @__PURE__ */ jsx55("div", { className: "overflow-x-auto", children: /* @__PURE__ */ jsxs49(Table5, { hoverable: true, children: [
      /* @__PURE__ */ jsx55(TableHead5, { children: /* @__PURE__ */ jsxs49(TableRow5, { children: [
        /* @__PURE__ */ jsx55(TableHeadCell5, {}),
        /* @__PURE__ */ jsx55(TableHeadCell5, {}),
        /* @__PURE__ */ jsx55(TableHeadCell5, { children: "\u041D\u0430\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0435 \u043A\u043E\u043D\u0442\u0440\u0430\u0433\u0435\u043D\u0442\u0430" }),
        /* @__PURE__ */ jsx55(TableHeadCell5, { children: "\u0412\u0430\u043B\u044E\u0442\u043D\u0430\u044F \u043F\u0430\u0440\u0430" }),
        /* @__PURE__ */ jsx55(TableHeadCell5, { children: "\u041E\u0431\u044A\u0435\u043C \u0432\u0430\u043B\u044E\u0442\u044B" }),
        /* @__PURE__ */ jsx55(TableHeadCell5, { children: "\u041E\u0431\u044A\u0435\u043C" }),
        /* @__PURE__ */ jsx55(TableHeadCell5, { children: "\u0414\u0438\u0430\u043F\u0430\u0437\u043E\u043D \u043E\u0431\u044A\u0435\u043C\u0430" }),
        /* @__PURE__ */ jsx55(TableHeadCell5, { children: "\u0412\u0440\u0435\u043C\u044F \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F" }),
        /* @__PURE__ */ jsx55(TableHeadCell5, { children: "\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0443\u0441\u043F\u0435\u0448\u043D\u044B\u0445 \u0441\u0434\u0435\u043B\u043E\u043A" })
      ] }) }),
      /* @__PURE__ */ jsx55(TableBody5, { className: "divide-y", children: data?.items?.map((rate) => /* @__PURE__ */ jsxs49(
        TableRow5,
        {
          onClick: () => onRowClick?.(rate.rangeId || ""),
          className: "text-sm font-normal text-gray-900 dark:text-white",
          children: [
            /* @__PURE__ */ jsxs49(Fragment16, { children: [
              /* @__PURE__ */ jsx55(TableCell5, { className: "w-[60px] text-gray-500", children: /* @__PURE__ */ jsx55(
                "button",
                {
                  onClick: () => onRateStoryClick(
                    rate.rateId,
                    `${rate.cryptoCurrency?.code} > ${rate.currency?.code}`
                  ),
                  children: /* @__PURE__ */ jsx55(Icon13, { name: "clock-outline" })
                }
              ) }),
              /* @__PURE__ */ jsx55(TableCell5, { className: "w-[60px] flex px-0 flex-wrap justify-center text-gray-500 hover:text-gray-900", children: /* @__PURE__ */ jsx55(AdminActionMenu, { rowData: rate }) })
            ] }),
            /* @__PURE__ */ jsx55(TableCell5, { className: "whitespace-nowrap cursor-pointer hover:underline", children: rate.organization?.name }),
            /* @__PURE__ */ jsx55(TableCell5, { className: "whitespace-nowrap", children: `${rate.cryptoCurrency?.code} > ${rate.currency?.code}` }),
            /* @__PURE__ */ jsx55(TableCell5, { className: "whitespace-nowrap", children: `${rate.amount} ${rate.cryptoCurrency?.code}` }),
            /* @__PURE__ */ jsx55(TableCell5, { className: "whitespace-nowrap", children: `${rate.price} ${rate.currency?.code}` }),
            /* @__PURE__ */ jsx55(TableCell5, { className: "whitespace-nowrap", children: `\u041E\u0442 ${rate.rangeMin} \u0434\u043E ${rate.rangeMax}` }),
            /* @__PURE__ */ jsx55(TableCell5, { className: " whitespace-nowrap", children: formatDate2(rate.updatedAt) }),
            /* @__PURE__ */ jsx55(TableCell5, { className: "whitespace-nowrap", children: rate.dealsCount })
          ]
        },
        rate.rangeId
      )) })
    ] }) })
  ] });
};

// src/widgets/faq/ui/faqAccordion.tsx
import {
  Accordion,
  AccordionContent,
  AccordionPanel,
  AccordionTitle,
  Button as Button24
} from "flowbite-react";
import { jsx as jsx56, jsxs as jsxs50 } from "react/jsx-runtime";
var FaqAccordion = ({
  faqs,
  onViewAll
}) => {
  return /* @__PURE__ */ jsxs50("div", { className: "bg-white border border-gray-200 rounded-lg p-6", children: [
    /* @__PURE__ */ jsxs50("div", { className: "flex items-start justify-between mb-6", children: [
      /* @__PURE__ */ jsx56("h2", { className: "text-xl font-semibold text-gray-900", children: "\u0427\u0430\u0441\u0442\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B" }),
      onViewAll && /* @__PURE__ */ jsx56(Button24, { color: "alternative", onClick: onViewAll, children: "\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0432\u0441\u0435" })
    ] }),
    faqs.length === 0 ? /* @__PURE__ */ jsx56("div", { className: "text-center py-12 text-gray-500", children: "\u041D\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0445 \u0432\u043E\u043F\u0440\u043E\u0441\u043E\u0432" }) : /* @__PURE__ */ jsx56(Accordion, { collapseAll: true, children: faqs.map((faq, index) => /* @__PURE__ */ jsxs50(AccordionPanel, { children: [
      /* @__PURE__ */ jsx56(AccordionTitle, { className: "text-base font-medium text-gray-900 hover:bg-gray-100 focus:ring-0", children: faq.question || "\u0412\u043E\u043F\u0440\u043E\u0441" }),
      /* @__PURE__ */ jsx56(AccordionContent, { className: "bg-white border-x border-gray-200", children: /* @__PURE__ */ jsx56("p", { className: "text-base text-gray-500 leading-6", children: faq.answer || "\u041E\u0442\u0432\u0435\u0442 \u043E\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u0435\u0442" }) })
    ] }, faq.id || index)) })
  ] });
};

// src/widgets/organizations/organizationsTable.tsx
import {
  Badge as Badge2,
  Button as Button25,
  Spinner as Spinner5,
  Table as Table6,
  TableBody as TableBody6,
  TableCell as TableCell6,
  TableHead as TableHead6,
  TableHeadCell as TableHeadCell6,
  TableRow as TableRow6
} from "flowbite-react";
import { jsx as jsx57, jsxs as jsxs51 } from "react/jsx-runtime";
var OrganizationsTable = ({
  organizations,
  loading = false,
  onRowClick,
  onApprove,
  onReject
}) => {
  const formatDate4 = (dateString) => {
    if (!dateString)
      return "-";
    return new Date(dateString).toLocaleDateString("ru-RU", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    });
  };
  const getStatusBadge = (status) => {
    const statusMap = {
      0: { color: "warning", label: "\u041E\u0436\u0438\u0434\u0430\u0435\u0442 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F" },
      1: { color: "info", label: "\u041E\u0436\u0438\u0434\u0430\u0435\u0442 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0439" },
      10: { color: "success", label: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0430" },
      [-1]: { color: "failure", label: "\u0417\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u0430" }
    };
    const statusInfo = statusMap[status] || {
      color: "gray",
      label: "\u041D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u043E"
    };
    return /* @__PURE__ */ jsx57(Badge2, { color: statusInfo.color, children: statusInfo.label });
  };
  if (loading) {
    return /* @__PURE__ */ jsx57("div", { className: "bg-white rounded-lg shadow-md p-6", children: /* @__PURE__ */ jsxs51("div", { className: "flex items-center justify-center py-8", children: [
      /* @__PURE__ */ jsx57(Spinner5, { size: "lg" }),
      /* @__PURE__ */ jsx57("span", { className: "ml-3 text-gray-600", children: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0439..." })
    ] }) });
  }
  return /* @__PURE__ */ jsx57("div", { className: "bg-white rounded-lg shadow-md overflow-hidden", children: /* @__PURE__ */ jsx57("div", { className: "overflow-x-auto", children: /* @__PURE__ */ jsxs51(Table6, { hoverable: true, children: [
    /* @__PURE__ */ jsx57(TableHead6, { children: /* @__PURE__ */ jsxs51(TableRow6, { children: [
      /* @__PURE__ */ jsx57(TableHeadCell6, { children: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435" }),
      /* @__PURE__ */ jsx57(TableHeadCell6, { children: "\u0418\u041D\u041D" }),
      /* @__PURE__ */ jsx57(TableHeadCell6, { children: "\u041E\u0413\u0420\u041D" }),
      /* @__PURE__ */ jsx57(TableHeadCell6, { children: "\u0421\u0442\u0430\u0442\u0443\u0441" }),
      /* @__PURE__ */ jsx57(TableHeadCell6, { children: "\u0414\u0430\u0442\u0430 \u043F\u0435\u0440\u0435\u0445\u043E\u0434\u0430" }),
      /* @__PURE__ */ jsx57(TableHeadCell6, { children: "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u043F\u0435\u0440\u0435\u0445\u043E\u0434\u0430" }),
      /* @__PURE__ */ jsx57(TableHeadCell6, { children: /* @__PURE__ */ jsx57("span", { className: "sr-only", children: "\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u044F" }) })
    ] }) }),
    /* @__PURE__ */ jsx57(TableBody6, { className: "divide-y", children: organizations.length === 0 ? /* @__PURE__ */ jsx57(TableRow6, { children: /* @__PURE__ */ jsx57(
      TableCell6,
      {
        colSpan: 7,
        className: "text-center py-12 text-gray-500",
        children: "\u041D\u0435\u0442 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0439 \u0434\u043B\u044F \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F"
      }
    ) }) : organizations.map((organization) => /* @__PURE__ */ jsxs51(
      TableRow6,
      {
        className: `bg-white dark:border-gray-700 dark:bg-gray-800 ${onRowClick ? "cursor-pointer" : ""}`,
        onClick: () => onRowClick?.(organization.id || ""),
        children: [
          /* @__PURE__ */ jsx57(TableCell6, { className: "whitespace-nowrap font-medium text-gray-900 dark:text-white", children: organization.name || "-" }),
          /* @__PURE__ */ jsx57(TableCell6, { className: "whitespace-nowrap text-gray-500", children: organization.inn || "-" }),
          /* @__PURE__ */ jsx57(TableCell6, { className: "whitespace-nowrap text-gray-500", children: organization.orgn || "-" }),
          /* @__PURE__ */ jsx57(TableCell6, { children: getStatusBadge(organization.status) }),
          /* @__PURE__ */ jsx57(TableCell6, { className: "whitespace-nowrap text-gray-500", children: formatDate4(organization.transitionAt) }),
          /* @__PURE__ */ jsx57(TableCell6, { className: "text-gray-500 max-w-xs truncate", children: organization.transitionDescription || "-" }),
          /* @__PURE__ */ jsx57(TableCell6, { className: "whitespace-nowrap", children: /* @__PURE__ */ jsxs51("div", { className: "flex space-x-2", children: [
            /* @__PURE__ */ jsx57(
              Button25,
              {
                color: "primary",
                onClick: (e) => {
                  e.stopPropagation();
                  onApprove?.(organization.id || "");
                },
                children: "\u041E\u0434\u043E\u0431\u0440\u0438\u0442\u044C"
              }
            ),
            /* @__PURE__ */ jsx57(
              Button25,
              {
                color: "alternative",
                onClick: (e) => {
                  e.stopPropagation();
                  onReject?.(organization.id || "");
                },
                children: "\u041E\u0442\u043A\u043B\u043E\u043D\u0438\u0442\u044C"
              }
            )
          ] }) })
        ]
      },
      organization.id
    )) })
  ] }) }) });
};

// src/widgets/sidebar/index.tsx
import { RoleEnum as RoleEnum3 } from "@acme/api";
import { Button as Button26 } from "flowbite-react";

// src/widgets/sidebar/ui/helpSection.tsx
import { Icon as Icon14 } from "@acme/assets";
import { Link as Link2 } from "react-router-dom";
import { jsx as jsx58, jsxs as jsxs52 } from "react/jsx-runtime";
var HelpSection = ({
  helpLinkPath: help,
  children
}) => {
  return /* @__PURE__ */ jsxs52("div", { className: "flex w-full flex-col rounded-2xl border border-gray-200 p-4 gap-6 mt-4 font-inter font-medium leading-6", children: [
    /* @__PURE__ */ jsxs52(
      Link2,
      {
        className: "flex items-center justify-between gap-3 text-gray-700 hover:text-brand-primary-default transition-colors",
        to: help,
        children: [
          /* @__PURE__ */ jsx58("span", { className: "flex-grow", children: "\u0426\u0435\u043D\u0442\u0440 \u043F\u043E\u043C\u043E\u0449\u0438" }),
          /* @__PURE__ */ jsx58(Icon14, { name: "question-mark-outline", size: 20, alt: "Help" })
        ]
      }
    ),
    children
  ] });
};

// src/widgets/sidebar/ui/navigation.tsx
import { Icon as Icon15 } from "@acme/assets";
import { Link as Link3 } from "react-router-dom";
import { jsx as jsx59, jsxs as jsxs53 } from "react/jsx-runtime";
var Navigation = ({
  items,
  className,
  currentPath
}) => {
  return /* @__PURE__ */ jsx59(
    "nav",
    {
      className: `font-inter flex w-full flex-col   font-medium leading-[normal] ${className}`,
      children: items.map((item, index) => {
        const isActive = currentPath === item.path;
        return /* @__PURE__ */ jsxs53(
          Link3,
          {
            to: item.disabled ? "#" : item.path,
            className: `flex items-center gap-3 px-3 py-3 rounded-lg transition-colors ${item.disabled ? "!cursor-default opacity-50 text-text-secondary" : `cursor-pointer hover:text-brand-primary-default ${isActive ? "  text-brand-primary-default bg-purple-50" : "text-gray-700 "}`}`,
            onClick: (e) => {
              if (item.disabled) {
                e.preventDefault();
              }
            },
            children: [
              /* @__PURE__ */ jsx59(
                Icon15,
                {
                  name: item.iconName,
                  size: 20,
                  className: `h-5 w-5 ${item.disabled ? "text-gray-400" : "text-current"}`,
                  alt: item.label
                }
              ),
              /* @__PURE__ */ jsx59("span", { className: "flex-grow text-base", children: item.label })
            ]
          },
          index
        );
      })
    }
  );
};

// src/widgets/sidebar/ui/notifications.tsx
import { NotificationService } from "@acme/api";
import { Icon as Icon16 } from "@acme/assets";
import { PortalDropdown, usePortalDropdown } from "@acme/foundation";
import { Badge as Badge3 } from "flowbite-react";
import { useCallback as useCallback7, useEffect as useEffect11, useState as useState18 } from "react";
import { Link as Link4 } from "react-router-dom";
import { jsx as jsx60, jsxs as jsxs54 } from "react/jsx-runtime";
var DropdownLink = ({
  to,
  children
}) => {
  const { close } = usePortalDropdown();
  return /* @__PURE__ */ jsx60(
    Link4,
    {
      to,
      onClick: close,
      className: "flex items-center justify-center gap-2 text-sm text-gray-700 hover:text-brand-primary-default",
      children
    }
  );
};
function formatNotificationDate(dateString) {
  if (!dateString)
    return "";
  const date = new Date(dateString);
  return `${date.toLocaleDateString("ru-RU", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric"
  })}, ${date.toLocaleTimeString("ru-RU", {
    hour: "2-digit",
    minute: "2-digit"
  })}`;
}
var NotificationsControl = ({
  notificationsLinkPath
}) => {
  const [items, setItems] = useState18([]);
  const [unreadCount, setUnreadCount] = useState18(0);
  const [loading, setLoading] = useState18(false);
  const loadUnreadCount = useCallback7(async () => {
    try {
      const res = await NotificationService.getApiV1NotificationNotificationUnreadCount();
      if (res?.data != null)
        setUnreadCount(res.data);
    } catch {
      setUnreadCount(0);
    }
  }, []);
  const loadList = useCallback7(async () => {
    setLoading(true);
    try {
      const [listRes, countRes] = await Promise.all([
        NotificationService.getApiV1NotificationNotification({
          isRead: false,
          pageNumber: 1,
          pageSize: 5
        }),
        NotificationService.getApiV1NotificationNotificationUnreadCount()
      ]);
      setItems(listRes?.data?.items ?? []);
      if (countRes?.data != null)
        setUnreadCount(countRes.data);
    } catch {
      setItems([]);
    } finally {
      setLoading(false);
    }
  }, []);
  useEffect11(() => {
    loadUnreadCount();
  }, [loadUnreadCount]);
  const handleOpenChange = useCallback7(
    (open) => {
      if (open)
        loadList();
    },
    [loadList]
  );
  return /* @__PURE__ */ jsx60(
    PortalDropdown,
    {
      placement: "bottom-end",
      dismissOnClick: false,
      onOpenChange: handleOpenChange,
      trigger: /* @__PURE__ */ jsxs54("div", { className: "relative cursor-pointer p-2", children: [
        /* @__PURE__ */ jsx60(Icon16, { name: "bell-outline", size: 24, alt: "\u0423\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F" }),
        unreadCount > 0 && /* @__PURE__ */ jsx60(
          Badge3,
          {
            color: "green",
            size: "xs",
            className: "absolute -top-1 -right-1 w-5 h-5 flex items-center justify-center rounded-full",
            children: unreadCount
          }
        )
      ] }),
      children: /* @__PURE__ */ jsxs54("div", { className: "flex flex-col w-[400px] max-h-[500px] overflow-y-auto bg-white", children: [
        /* @__PURE__ */ jsx60("div", { className: "px-4 py-3 bg-gray-50", children: /* @__PURE__ */ jsx60("h3", { className: "font-semibold text-base text-gray-900 text-center", children: "\u0423\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F" }) }),
        /* @__PURE__ */ jsx60("div", { className: "flex flex-col", children: loading ? /* @__PURE__ */ jsx60("div", { className: "px-4 py-8 text-center text-gray-500 text-sm", children: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430\u2026" }) : items.length > 0 ? items.map((n) => /* @__PURE__ */ jsx60(
          "div",
          {
            className: `px-4 py-3 hover:bg-gray-100 cursor-pointer border-b border-gray-200 `,
            children: /* @__PURE__ */ jsxs54("div", { className: "flex flex-col gap-1", children: [
              n.applicationCode && /* @__PURE__ */ jsx60("div", { className: "text-sm text-gray-700 leading-4", children: /* @__PURE__ */ jsx60(
                Link4,
                {
                  to: `/application/${n.applicationId}`,
                  className: "text-sm hover:underline",
                  onClick: (e) => e.stopPropagation(),
                  children: n.applicationCode ? `\u0417\u0430\u044F\u0432\u043A\u0430: ${n.applicationCode}` : n.subject || n.description
                }
              ) }),
              n.description && n.subject !== n.description && /* @__PURE__ */ jsx60("p", { className: "text-sm text-gray-700", children: n.description }),
              /* @__PURE__ */ jsx60("span", { className: "text-xs text-blue-600", children: formatNotificationDate(n.createdAt) })
            ] })
          },
          n.id ?? ""
        )) : /* @__PURE__ */ jsx60("div", { className: "px-4 py-8 text-center text-gray-500 text-sm", children: "\u0412\u0441\u0435 \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u044B" }) }),
        /* @__PURE__ */ jsx60("div", { className: "px-4 py-3 bg-gray-50", children: /* @__PURE__ */ jsxs54(DropdownLink, { to: notificationsLinkPath, children: [
          /* @__PURE__ */ jsx60(Icon16, { name: "eye", size: 20, alt: "\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0432\u0441\u0435" }),
          /* @__PURE__ */ jsx60("span", { children: "\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0432\u0441\u0435" })
        ] }) })
      ] })
    }
  );
};

// src/widgets/sidebar/ui/options.tsx
import { Icon as Icon17 } from "@acme/assets";
import { jsx as jsx61 } from "react/jsx-runtime";
var OptionsControl = ({
  profileLinkPath,
  onNavigate
}) => {
  const handleClick = () => {
    if (onNavigate) {
      onNavigate(profileLinkPath);
    } else {
      window.location.href = profileLinkPath;
    }
  };
  return /* @__PURE__ */ jsx61("div", { onClick: handleClick, className: "p-2 cursor-pointer", children: /* @__PURE__ */ jsx61(Icon17, { name: "cog-outline", size: 24 }) });
};

// src/widgets/sidebar/ui/organizationInfo.tsx
import { Icon as Icon18 } from "@acme/assets";
import { Skeleton } from "@acme/foundation";
import { Fragment as Fragment17, jsx as jsx62, jsxs as jsxs55 } from "react/jsx-runtime";
var OrganizationInfo = ({
  children,
  user,
  organization,
  isLoading
}) => {
  return /* @__PURE__ */ jsxs55("div", { className: "font-inter flex w-full flex-col bg-gray-100 rounded-lg p-4", children: [
    /* @__PURE__ */ jsxs55("div", { className: "flex w-full items-center gap-3", children: [
      /* @__PURE__ */ jsx62(Icon18, { name: "factory", size: 24, className: "text-green-900" }),
      /* @__PURE__ */ jsx62("div", { className: "flex flex-col flex-grow gap-1", children: isLoading ? /* @__PURE__ */ jsxs55(Fragment17, { children: [
        /* @__PURE__ */ jsx62(Skeleton, { className: "h-5 w-40" }),
        /* @__PURE__ */ jsx62(Skeleton, { className: "h-4 w-32" })
      ] }) : /* @__PURE__ */ jsxs55(Fragment17, { children: [
        /* @__PURE__ */ jsx62("div", { className: "font-semibold text-base leading-5", children: organization?.name }),
        /* @__PURE__ */ jsxs55("div", { className: "text-text-secondary text-sm leading-5", children: [
          "\u0418\u041D\u041D: ",
          organization?.inn
        ] })
      ] }) })
    ] }),
    /* @__PURE__ */ jsx62("div", { className: "ml-[36px] mr-0 border-b border-gray-300 my-4" }),
    /* @__PURE__ */ jsxs55("div", { className: "flex w-full items-center gap-3 ", children: [
      /* @__PURE__ */ jsx62(Icon18, { name: "user-circle-outline", size: 24, className: "text-green-900" }),
      /* @__PURE__ */ jsx62("div", { className: "flex flex-col flex-grow", children: isLoading ? /* @__PURE__ */ jsx62(Skeleton, { className: "h-5 w-32" }) : /* @__PURE__ */ jsx62("div", { className: "font-medium text-base leading-6", children: user?.person?.name }) })
    ] }),
    children
  ] });
};

// src/widgets/sidebar/ui/userSession.tsx
import { Icon as Icon19 } from "@acme/assets";
import { Link as Link5 } from "react-router-dom";
import { jsx as jsx63, jsxs as jsxs56 } from "react/jsx-runtime";
var UserSession = ({ authLinkPath, onLogout }) => {
  return /* @__PURE__ */ jsxs56(
    Link5,
    {
      to: authLinkPath,
      className: "flex w-full items-center justify-between gap-3 rounded-lg px-3 py-3 font-inter font-medium leading-6 text-red-600 hover:bg-red-50 transition-colors mt-4",
      onClick: () => {
        onLogout();
      },
      children: [
        /* @__PURE__ */ jsx63("span", { children: "\u0412\u044B\u0439\u0442\u0438" }),
        /* @__PURE__ */ jsx63(Icon19, { name: "arrow-right-to-bracket", size: 20, color: "#E02424" })
      ]
    }
  );
};

// src/widgets/sidebar/index.tsx
import { jsx as jsx64, jsxs as jsxs57 } from "react/jsx-runtime";
var Sidebar = ({
  className,
  onCreateApplication,
  navigationItems,
  disabled = false,
  organization,
  user,
  isLoading,
  onLogout,
  children,
  currentPath,
  onNavigate
}) => {
  return /* @__PURE__ */ jsxs57(
    "div",
    {
      className: `bg-white drop-shadow-md w-80 flex flex-col p-4  ${className}`,
      children: [
        /* @__PURE__ */ jsxs57("div", { className: "flex w-full items-center justify-between mb-4", children: [
          /* @__PURE__ */ jsx64(OptionsControl, { profileLinkPath: "/profile", onNavigate }),
          /* @__PURE__ */ jsx64(NotificationsControl, { notificationsLinkPath: "/notifications" })
        ] }),
        /* @__PURE__ */ jsx64(
          OrganizationInfo,
          {
            user,
            organization,
            isLoading,
            children: organization?.role?.id === RoleEnum3.Client && /* @__PURE__ */ jsx64(
              Button26,
              {
                color: "primary",
                onClick: onCreateApplication,
                disabled,
                className: `mt-6 justify-center text-base leading-5 font-medium`,
                children: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0437\u0430\u044F\u0432\u043A\u0443"
              }
            )
          }
        ),
        /* @__PURE__ */ jsx64(
          Navigation,
          {
            className: "flex-grow mb-4 mt-4",
            items: navigationItems,
            currentPath
          }
        ),
        children,
        /* @__PURE__ */ jsx64(UserSession, { authLinkPath: "/auth", onLogout })
      ]
    }
  );
};

// src/widgets/supportChatModal/ui/supportChatModal.tsx
import { useEffect as useEffect15, useRef as useRef6, useState as useState21 } from "react";
import { createPortal } from "react-dom";

// src/features/chatWindow/lib/useChatModel.ts
import { useUnit as useUnit5 } from "effector-react";
import { useEffect as useEffect12, useMemo as useMemo8, useRef as useRef2 } from "react";

// src/features/chatWindow/model/chatModel.ts
import { createEffect as createEffect4, createEvent as createEvent4, createStore as createStore4, sample as sample4 } from "effector";

// src/features/chatWindow/model/types.ts
var initialChatState = {
  messages: [],
  isLoading: false,
  isLoadingMore: false,
  hasMoreMessages: true,
  currentPage: 1,
  totalPages: null,
  totalCount: null,
  hasNewMessages: false,
  error: null
};

// src/features/chatWindow/model/chatModel.ts
var mergeMessagesUnique = (incoming, existing) => {
  const existingIds = /* @__PURE__ */ new Set();
  for (const msg of existing) {
    if (msg.id)
      existingIds.add(msg.id);
  }
  const result = [];
  for (const msg of incoming) {
    if (!msg.id) {
      result.push(msg);
      continue;
    }
    if (!existingIds.has(msg.id)) {
      existingIds.add(msg.id);
      result.push(msg);
    }
  }
  return [...result, ...existing];
};
var isSystemMessage = (response) => {
  return response.text?.startsWith("@@") || response.text?.includes("connected") && response.text.includes("disconnected") || false;
};
var createChatModel = (chatId) => {
  const setApi = createEvent4();
  const loadMessages = createEvent4();
  const loadMoreMessages = createEvent4();
  const addMessage = createEvent4();
  const setMessages = createEvent4();
  const resetChat = createEvent4();
  const setPage = createEvent4();
  const markNewMessagesSeen = createEvent4();
  const sendMessage = createEvent4();
  const loadMessagesFx = createEffect4(
    async ({
      loader,
      page,
      pageSize
    }) => {
      const response = await loader({ pageNumber: page, pageSize });
      if (!response.isSuccess || !response.data || !response.data.items) {
        throw new Error(response.errorText || "Load chat history error");
      }
      const messageList = response.data.items || [];
      const sortedList = messageList.sort(
        (a, b) => new Date((a.sentAt || a.readAt) ?? "").getTime() - new Date((b.sentAt || b.readAt) ?? "").getTime()
      );
      return {
        messages: sortedList,
        totalPages: response.data.totalPages ?? null,
        totalCount: response.data.totalCount ?? null,
        page
      };
    }
  );
  const sendMessageFx = createEffect4(
    async ({
      sender,
      req
    }) => {
      return await sender(req);
    }
  );
  const $api = createStore4(null).on(setApi, (_, api) => api);
  const hasApi = (source) => source.api !== null;
  const $chat = createStore4(initialChatState).on(loadMessages, (state) => ({
    ...state,
    isLoading: true,
    isLoadingMore: false,
    currentPage: 1,
    hasMoreMessages: true,
    totalPages: null,
    totalCount: null,
    error: null
  })).on(loadMoreMessages, (state) => ({
    ...state,
    isLoadingMore: true,
    error: null
  })).on(loadMessagesFx.doneData, (state, { messages, totalPages, totalCount, page }) => ({
    ...state,
    messages: page === 1 ? messages : mergeMessagesUnique(messages, state.messages),
    totalPages,
    totalCount,
    hasMoreMessages: totalPages === null ? state.hasMoreMessages : page < totalPages,
    isLoading: false,
    isLoadingMore: false,
    error: null
  })).on(loadMessagesFx.failData, (state, error) => ({
    ...state,
    isLoading: false,
    isLoadingMore: false,
    error: error.message
  })).on(sendMessageFx.failData, (state, error) => ({
    ...state,
    error: error.message
  })).on(addMessage, (state, message) => {
    if (isSystemMessage(message)) {
      return state;
    }
    return {
      ...state,
      messages: [...state.messages, message],
      hasNewMessages: true
    };
  }).on(setMessages, (state, messages) => ({
    ...state,
    messages
  })).on(setPage, (state, page) => ({
    ...state,
    currentPage: page
  })).on(markNewMessagesSeen, (state) => ({
    ...state,
    hasNewMessages: false
  })).reset(resetChat);
  const $messages = $chat.map((state) => state.messages);
  const $isLoading = $chat.map((state) => state.isLoading);
  const $isLoadingMore = $chat.map((state) => state.isLoadingMore);
  const $hasMoreMessages = $chat.map((state) => state.hasMoreMessages);
  const $currentPage = $chat.map((state) => state.currentPage);
  const $hasNewMessages = $chat.map((state) => state.hasNewMessages);
  const $error = $chat.map((state) => state.error);
  const $companionLabelText = $api.map(
    (api) => api?.companionLabelText ?? "\u0421\u043E\u0431\u0435\u0441\u0435\u0434\u043D\u0438\u043A"
  );
  const $getAttachmentReq = $api.map((api) => api?.getAttachmentReq ?? null);
  sample4({
    clock: loadMessages,
    source: { state: $chat, api: $api },
    filter: hasApi,
    fn: ({ state, api }) => ({
      loader: api.loadChatHistory,
      page: 1,
      pageSize: 10
    }),
    target: loadMessagesFx
  });
  sample4({
    clock: loadMoreMessages,
    source: { state: $chat, api: $api },
    filter: ({ state, api }) => api !== null && state.hasMoreMessages && (state.totalPages === null || state.currentPage < state.totalPages),
    fn: ({ state, api }) => ({
      loader: api.loadChatHistory,
      page: state.currentPage + 1,
      pageSize: 10
    }),
    target: loadMessagesFx
  });
  sample4({
    clock: sendMessage,
    source: $api,
    filter: (api) => api !== null,
    fn: (api, req) => ({
      sender: api.sendMessage,
      req
    }),
    target: sendMessageFx
  });
  sample4({
    clock: loadMessagesFx.doneData,
    fn: ({ page }) => page,
    target: setPage
  });
  sample4({
    clock: $lastMessage,
    filter: (message) => message !== null && getChatIdFromMessage(message) === chatId,
    fn: (message) => message,
    target: addMessage
  });
  return {
    // Events
    setApi,
    loadMessages,
    loadMoreMessages,
    addMessage,
    setMessages,
    resetChat,
    setPage,
    markNewMessagesSeen,
    sendMessage,
    // Stores
    $api,
    $chat,
    $messages,
    $isLoading,
    $isLoadingMore,
    $hasMoreMessages,
    $currentPage,
    $hasNewMessages,
    $error,
    $companionLabelText,
    $getAttachmentReq,
    // Effects
    loadMessagesFx,
    sendMessageFx
  };
};

// src/features/chatWindow/lib/useChatModel.ts
var chatModels = /* @__PURE__ */ new Map();
var getChatModel = (chatId) => {
  if (!chatModels.has(chatId)) {
    chatModels.set(chatId, createChatModel(chatId));
  }
  return chatModels.get(chatId);
};
var useChatModel = (chatId) => {
  const modelRef = useRef2(null);
  const model = useMemo8(() => {
    if (!modelRef.current || modelRef.current !== getChatModel(chatId)) {
      modelRef.current = getChatModel(chatId);
    }
    return modelRef.current;
  }, [chatId]);
  const {
    messages,
    isLoading,
    isLoadingMore,
    hasMoreMessages,
    currentPage,
    hasNewMessages,
    error
  } = useUnit5({
    messages: model.$messages,
    isLoading: model.$isLoading,
    isLoadingMore: model.$isLoadingMore,
    hasMoreMessages: model.$hasMoreMessages,
    currentPage: model.$currentPage,
    hasNewMessages: model.$hasNewMessages,
    error: model.$error
  });
  useEffect12(() => {
    return () => {
      model.resetChat();
    };
  }, [chatId]);
  return {
    model,
    messages,
    isLoading,
    isLoadingMore,
    hasMoreMessages,
    currentPage,
    hasNewMessages,
    error,
    loadMessages: model.loadMessages,
    loadMoreMessages: model.loadMoreMessages,
    sendMessage: model.sendMessage,
    setApi: model.setApi,
    addMessage: model.addMessage,
    setMessages: model.setMessages,
    resetChat: model.resetChat,
    setPage: model.setPage,
    markNewMessagesSeen: model.markNewMessagesSeen
  };
};
var clearChatModel = (chatId) => {
  const model = chatModels.get(chatId);
  if (model) {
    model.resetChat();
    chatModels.delete(chatId);
  }
};
var clearAllChatModels = () => {
  chatModels.forEach((model) => model.resetChat());
  chatModels.clear();
};

// src/features/chatWindow/index.tsx
import { useCallback as useCallback11, useEffect as useEffect14, useRef as useRef5 } from "react";

// src/features/chatWindow/lib/chatwindowcontext.tsx
import { createContext, useContext } from "react";
var ChatWindowModelContext = createContext(null);
var ChatWindowModelProvider = ChatWindowModelContext.Provider;
var useChatWindowModel = () => {
  const model = useContext(ChatWindowModelContext);
  if (!model) {
    throw new Error("ChatWindowModelProvider is missing");
  }
  return model;
};

// src/features/chatWindow/lib/useChatScroll.ts
import { useCallback as useCallback8, useEffect as useEffect13, useRef as useRef3, useState as useState19 } from "react";
var useChatScroll = ({
  loadMore,
  enabled = true,
  messages,
  hasMoreMessages,
  isLoadingMore
}) => {
  const scrollContainerRef = useRef3(null);
  const isLoadingRef = useRef3(false);
  const [showScrollButton, setShowScrollButton] = useState19(false);
  const [newMessagesCount, setNewMessagesCount] = useState19(0);
  const [hasNewMessages, setHasNewMessages] = useState19(false);
  const isAtBottomRef = useRef3(true);
  const tickingRef = useRef3(false);
  const targetScrollTopRef = useRef3(null);
  const lastSeenMessageIdRef = useRef3(null);
  useEffect13(() => {
    isLoadingRef.current = isLoadingMore;
  }, [isLoadingMore]);
  const checkIsAtBottom = useCallback8(() => {
    const container = scrollContainerRef.current;
    if (!container)
      return true;
    const { scrollTop, scrollHeight, clientHeight } = container;
    const distanceFromBottom = scrollHeight - scrollTop - clientHeight;
    return Math.abs(distanceFromBottom) < 50;
  }, []);
  const checkShouldShowScrollButton = useCallback8(() => {
    const container = scrollContainerRef.current;
    if (!container)
      return false;
    const { scrollTop, scrollHeight, clientHeight } = container;
    const distanceFromBottom = scrollHeight - scrollTop - clientHeight;
    return distanceFromBottom >= 800;
  }, []);
  const handleLoadMore = useCallback8(async () => {
    if (isLoadingRef.current || !hasMoreMessages)
      return;
    isLoadingRef.current = true;
    const container = scrollContainerRef.current;
    if (!container)
      return;
    const currentScrollTop = container.scrollTop;
    const currentScrollHeight = container.scrollHeight;
    loadMore();
    requestAnimationFrame(() => {
      if (container) {
        const newScrollHeight = container.scrollHeight;
        const heightDifference = newScrollHeight - currentScrollHeight;
        targetScrollTopRef.current = currentScrollTop;
        container.scrollTop = currentScrollTop + heightDifference;
      }
    });
  }, [loadMore, hasMoreMessages]);
  const handleScroll = useCallback8(async () => {
    if (isLoadingRef.current)
      return;
    const container = scrollContainerRef.current;
    if (!container)
      return;
    const scrollTop = container.scrollTop;
    const loadThreshold = 100;
    if (targetScrollTopRef.current !== null && Math.abs(scrollTop - targetScrollTopRef.current) < 10) {
      targetScrollTopRef.current = null;
      return;
    }
    if (scrollTop <= loadThreshold && hasMoreMessages && !isLoadingRef.current) {
      handleLoadMore();
    }
    const isAtBottom = checkIsAtBottom();
    isAtBottomRef.current = isAtBottom;
    setShowScrollButton(checkShouldShowScrollButton());
    if (isAtBottom) {
      setHasNewMessages(false);
      setNewMessagesCount(0);
      if (messages.length > 0) {
        lastSeenMessageIdRef.current = messages[messages.length - 1].id;
      }
    }
  }, [
    handleLoadMore,
    hasMoreMessages,
    checkIsAtBottom,
    checkShouldShowScrollButton,
    messages
  ]);
  const throttledScroll = useCallback8(() => {
    return () => {
      if (!tickingRef.current) {
        requestAnimationFrame(() => {
          handleScroll();
          tickingRef.current = false;
        });
        tickingRef.current = true;
      }
    };
  }, [handleScroll])();
  useEffect13(() => {
    const container = scrollContainerRef.current;
    if (!container || !enabled)
      return;
    container.addEventListener("scroll", throttledScroll, { passive: true });
    return () => {
      container.removeEventListener("scroll", throttledScroll);
    };
  }, [enabled, throttledScroll]);
  useEffect13(() => {
    if (!enabled)
      return;
    if (messages.length === 0) {
      lastSeenMessageIdRef.current = null;
      return;
    }
    if (lastSeenMessageIdRef.current === null && messages.length > 0) {
      lastSeenMessageIdRef.current = messages[messages.length - 1].id;
      return;
    }
    if (lastSeenMessageIdRef.current && !isAtBottomRef.current) {
      const lastSeenIndex = messages.findIndex(
        (msg) => msg.id === lastSeenMessageIdRef.current
      );
      if (lastSeenIndex >= 0) {
        const newMessagesAfterLastSeen = messages.slice(lastSeenIndex + 1);
        if (newMessagesAfterLastSeen.length > 0) {
          setHasNewMessages(true);
          setNewMessagesCount(newMessagesAfterLastSeen.length);
        }
      } else {
        setHasNewMessages(true);
        setNewMessagesCount(messages.length);
      }
    }
  }, [messages, enabled]);
  useEffect13(() => {
    if (!enabled) {
      setShowScrollButton(false);
      setHasNewMessages(false);
      setNewMessagesCount(0);
    }
  }, [enabled]);
  return {
    scrollContainerRef,
    isLoadingMore,
    showScrollButton,
    hasNewMessages,
    newMessagesCount
  };
};

// src/features/chatWindow/ui/chatMessageList.tsx
import { formatRelativeDayLabel } from "@acme/foundation";
import { useUnit as useUnit7 } from "effector-react";

// src/features/chatWindow/ui/message/index.tsx
import { downloadFile } from "@acme/foundation";
import { useUnit as useUnit6 } from "effector-react";
import { useCallback as useCallback9 } from "react";

// src/features/chatWindow/ui/message/files.tsx
import { FileAttachmentList } from "@acme/foundation";
import { jsx as jsx65 } from "react/jsx-runtime";
var MessageFiles = ({
  attachments,
  onDownload
}) => {
  return /* @__PURE__ */ jsx65(FileAttachmentList, { attachments, onDownload });
};

// src/features/chatWindow/ui/message/text.tsx
import { jsx as jsx66 } from "react/jsx-runtime";
var MessageText = ({ text }) => {
  return /* @__PURE__ */ jsx66("div", { className: "text-sm whitespace-pre-wrap break-words font-normal", children: text });
};

// src/features/chatWindow/ui/message/bubble.tsx
import { jsx as jsx67, jsxs as jsxs58 } from "react/jsx-runtime";
var MessageBubble = ({
  variant,
  isUser,
  text,
  attachments,
  onDownload
}) => {
  return /* @__PURE__ */ jsxs58(
    "div",
    {
      className: `${variant === "ticket" ? "bg-white" : "bg-gray-100 border border-gray-200 rounded-2xl p-4"} text-gray-900 ${isUser ? "rounded-tr-none" : "rounded-tl-none"}`,
      children: [
        /* @__PURE__ */ jsx67(MessageText, { text }),
        /* @__PURE__ */ jsx67(MessageFiles, { attachments, onDownload })
      ]
    }
  );
};

// src/features/chatWindow/ui/message/header.tsx
import { Fragment as Fragment18, jsx as jsx68, jsxs as jsxs59 } from "react/jsx-runtime";
var MessageHeader = ({
  senderName,
  sentAt,
  isUser,
  variant
}) => {
  const formattedTicketDateTime = sentAt ? new Intl.DateTimeFormat("ru-RU", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  }).format(new Date(sentAt)) : null;
  return /* @__PURE__ */ jsx68(
    "div",
    {
      className: `flex items-center gap-1.5 text-gray-500 ${!isUser || variant === "ticket" ? "justify-start" : "justify-end"}`,
      children: variant === "ticket" ? /* @__PURE__ */ jsxs59(Fragment18, { children: [
        formattedTicketDateTime ? /* @__PURE__ */ jsxs59("span", { className: "text-sm font-normal ", children: [
          formattedTicketDateTime,
          ",",
          " "
        ] }) : null,
        /* @__PURE__ */ jsx68("span", { className: "text-sm font-normal", children: senderName })
      ] }) : /* @__PURE__ */ jsxs59(Fragment18, { children: [
        /* @__PURE__ */ jsx68("span", { className: "text-sm font-semibold ", children: senderName }),
        /* @__PURE__ */ jsx68("span", { className: "text-sm font-normal ", children: sentAt ? new Date(sentAt)?.toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit"
        }) : null })
      ] })
    }
  );
};

// src/features/chatWindow/ui/message/index.tsx
import { jsx as jsx69, jsxs as jsxs60 } from "react/jsx-runtime";
var MessageItem = (props) => {
  const model = useChatWindowModel();
  const { companionLabelText, getAttachmentReq } = useUnit6({
    companionLabelText: model.$companionLabelText,
    getAttachmentReq: model.$getAttachmentReq
  });
  const isUser = !props.message.isAnswer;
  const senderName = isUser ? "\u0412\u044B" : companionLabelText;
  const variant = props.variant ?? "default";
  const handleDownload = useCallback9(
    async (id, fileName) => {
      if (!getAttachmentReq)
        return;
      try {
        const response = await getAttachmentReq({ id });
        downloadFile({ data: response, fileName });
      } catch (error) {
        console.error("Download failed:", error);
      }
    },
    [getAttachmentReq]
  );
  return /* @__PURE__ */ jsx69(
    "div",
    {
      className: `flex ${!isUser || variant === "ticket" ? "justify-start" : "justify-end"}`,
      children: /* @__PURE__ */ jsxs60("div", { className: `flex flex-col max-w-[85%] gap-1`, children: [
        /* @__PURE__ */ jsx69(
          MessageHeader,
          {
            variant,
            senderName,
            sentAt: props.message.sentAt,
            isUser
          }
        ),
        /* @__PURE__ */ jsx69(
          MessageBubble,
          {
            variant,
            isUser,
            text: props.message.text,
            attachments: props.message.attachments,
            onDownload: (id, fileName) => handleDownload(id, fileName)
          }
        )
      ] })
    }
  );
};

// src/features/chatWindow/ui/chatMessageList.tsx
import { Fragment as Fragment19, jsx as jsx70, jsxs as jsxs61 } from "react/jsx-runtime";
var ChatMessageList = (props) => {
  const variant = props.variant ?? "default";
  const model = useChatWindowModel();
  const { messages, isLoadingMore, hasMoreMessages, isLoading } = useUnit7({
    messages: model.$messages,
    isLoadingMore: model.$isLoadingMore,
    hasMoreMessages: model.$hasMoreMessages,
    isLoading: model.$isLoading
  });
  const groupedMessages = variant === "ticket" ? null : messages?.reduce(
    (groups, message, index) => {
      const date = formatRelativeDayLabel({
        date: new Date(message.sentAt)
      });
      if (!groups[date]) {
        groups[date] = [];
      }
      groups[date].push({ message, originalIndex: index });
      return groups;
    },
    {}
  );
  const containerClassName = variant === "ticket" ? "flex-1 overflow-y-auto -mx-6 px-6 py-2" : "flex-1 overflow-y-auto px-4 py-2 bg-gray-50 border-t border-gray-200";
  return /* @__PURE__ */ jsxs61(
    "div",
    {
      ref: props.scrollContainerRef,
      className: containerClassName,
      "data-chat-scroll-container": true,
      children: [
        isLoadingMore && /* @__PURE__ */ jsxs61("div", { className: "flex justify-center items-center py-4", children: [
          /* @__PURE__ */ jsx70("div", { className: "animate-spin rounded-full h-6 w-6 border-b-2 border-blue-500" }),
          /* @__PURE__ */ jsx70("span", { className: "ml-2 text-sm text-gray-500", children: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u0438\u0441\u0442\u043E\u0440\u0438\u0438..." })
        ] }),
        variant !== "ticket" && !hasMoreMessages && messages.length > 0 && /* @__PURE__ */ jsx70("div", { className: "text-center text-xs text-gray-500 py-4", children: "\u041D\u0430\u0447\u0430\u043B\u043E \u0438\u0441\u0442\u043E\u0440\u0438\u0438 \u043F\u0435\u0440\u0435\u043F\u0438\u0441\u043A\u0438" }),
        variant === "ticket" ? /* @__PURE__ */ jsx70(Fragment19, { children: messages.map((message, index) => /* @__PURE__ */ jsxs61("div", { children: [
          /* @__PURE__ */ jsx70(MessageItem, { message, variant }),
          index < messages.length - 1 && /* @__PURE__ */ jsx70("div", { className: "border-b border-gray-200 my-4 px-6 -mx-6" })
        ] }, message.id || index)) }) : /* @__PURE__ */ jsx70(Fragment19, { children: groupedMessages && Object.entries(groupedMessages).map(([date, messages2]) => /* @__PURE__ */ jsxs61("div", { className: "flex flex-col gap-4", children: [
          /* @__PURE__ */ jsx70("div", { className: "text-center text-xs text-gray-500 my-4", children: /* @__PURE__ */ jsx70("span", { className: "bg-white px-3 py-1 rounded-full border shadow-sm", children: date }) }),
          messages2.map(({ message, originalIndex }) => /* @__PURE__ */ jsx70(
            MessageItem,
            {
              message,
              variant
            },
            `${date}-${originalIndex}`
          ))
        ] }, date)) }),
        /* @__PURE__ */ jsx70("div", { ref: props.messagesEndRef, "data-chat-end": true }),
        isLoading && messages.length === 0 && /* @__PURE__ */ jsx70("div", { className: "flex justify-center items-center h-20", children: /* @__PURE__ */ jsx70("div", { className: "animate-spin rounded-full h-8 w-8 border-b-2 border-gray-500" }) })
      ]
    }
  );
};

// src/features/chatWindow/ui/messageInput.tsx
import { Icon as Icon20 } from "@acme/assets";
import { useUnit as useUnit8 } from "effector-react";
import { useCallback as useCallback10, useRef as useRef4, useState as useState20 } from "react";
import { Fragment as Fragment20, jsx as jsx71, jsxs as jsxs62 } from "react/jsx-runtime";
var MessageInput = ({
  disabled = false
}) => {
  const model = useChatWindowModel();
  const isConnected = useUnit8($isConnected);
  const isSending = useUnit8(model.sendMessageFx.pending);
  const [inputText, setInputText] = useState20("");
  const [selectedFiles, setSelectedFiles] = useState20([]);
  const fileInputRef = useRef4(null);
  const inputRef = useRef4(null);
  const handleFileSelect = useCallback10(
    (event) => {
      const files = Array.from(event.target.files || []);
      setSelectedFiles((prev) => [...prev, ...files]);
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    },
    []
  );
  const removeFile = useCallback10((index) => {
    setSelectedFiles((prev) => prev.filter((_, i) => i !== index));
  }, []);
  const handleSendMessage = async () => {
    if (!inputText.trim() && selectedFiles.length === 0 || !isConnected || isSending) {
      return;
    }
    try {
      const messageRequest = {
        formData: {
          text: inputText.trim(),
          files: selectedFiles.length > 0 ? selectedFiles : void 0
        }
      };
      model.sendMessage(messageRequest);
      setInputText("");
      setSelectedFiles([]);
      if (inputRef.current) {
        inputRef.current.style.height = "auto";
      }
    } catch (error) {
      console.error("Failed to send message:", error);
    }
  };
  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };
  const openFilePicker = () => {
    fileInputRef.current?.click();
  };
  const isSendDisabled = disabled || !isConnected || isSending || !inputText.trim() && selectedFiles.length === 0;
  return /* @__PURE__ */ jsxs62(Fragment20, { children: [
    selectedFiles.length > 0 && /* @__PURE__ */ jsx71("div", { className: "px-4 pb-3 border-b border-gray-100", children: /* @__PURE__ */ jsx71("div", { className: "flex flex-wrap gap-2", children: selectedFiles.map((file, index) => /* @__PURE__ */ jsxs62(
      "div",
      {
        className: "flex items-center bg-gray-50 rounded-lg px-3 py-2 text-sm",
        children: [
          /* @__PURE__ */ jsx71("span", { className: "font-medium truncate max-w-[120px]", children: file.name }),
          /* @__PURE__ */ jsx71(
            "button",
            {
              onClick: () => removeFile(index),
              className: "ml-2 text-gray-700 hover:text-gray-900 text-xs",
              type: "button",
              children: "\u2715"
            }
          )
        ]
      },
      index
    )) }) }),
    /* @__PURE__ */ jsxs62("div", { className: "flex gap-3 items-center", children: [
      /* @__PURE__ */ jsx71(
        "button",
        {
          type: "button",
          onClick: openFilePicker,
          disabled: !isConnected || disabled,
          className: " text-gray-500 hover:text-gray-700 transition-colors disabled:opacity-50 flex-shrink-0",
          title: "\u041F\u0440\u0438\u043A\u0440\u0435\u043F\u0438\u0442\u044C \u0444\u0430\u0439\u043B",
          children: /* @__PURE__ */ jsx71(Icon20, { name: "plus-outline", className: "text-primary-500" })
        }
      ),
      /* @__PURE__ */ jsx71(
        "input",
        {
          ref: fileInputRef,
          type: "file",
          multiple: true,
          onChange: handleFileSelect,
          className: "hidden",
          accept: "*/*",
          disabled: !isConnected || disabled
        }
      ),
      /* @__PURE__ */ jsx71(
        "input",
        {
          ref: inputRef,
          type: "text",
          value: inputText,
          onChange: (e) => setInputText(e.target.value),
          onKeyDown: handleKeyPress,
          placeholder: isConnected ? "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435..." : "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435...",
          disabled: !isConnected,
          className: "flex-1 border border-gray-300 text-gray-900 rounded-lg px-4 py-3 text-sm focus:border-brand-purple-900"
        }
      ),
      /* @__PURE__ */ jsx71(
        "button",
        {
          className: `rounded-full flex w-7 h-7 justify-center items-center transition-colors ${isSendDisabled ? "bg-gray-200 text-gray-400 cursor-not-allowed" : "bg-brand-purple-900 text-white cursor-pointer hover:bg-brand-purple-800"}`,
          disabled: isSendDisabled,
          onClick: handleSendMessage,
          children: /* @__PURE__ */ jsx71(Icon20, { name: "arrow-up-outline" })
        }
      )
    ] })
  ] });
};

// src/features/chatWindow/ui/scrollToBottomBtn.tsx
import { jsx as jsx72, jsxs as jsxs63 } from "react/jsx-runtime";
var ScrollToBottomBtn = ({
  onClick,
  hasNewMessages,
  newMessagesCount
}) => {
  return /* @__PURE__ */ jsx72(
    "button",
    {
      onClick,
      className: "bg-brand-purple-900 hover:bg-brand-purple-500 text-white rounded-full p-3 shadow-lg transition-all duration-200 transform hover:scale-105 z-10 flex items-center justify-center",
      title: hasNewMessages ? "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043A \u043D\u043E\u0432\u044B\u043C \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F\u043C" : "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u0432\u043D\u0438\u0437",
      children: /* @__PURE__ */ jsxs63("div", { className: "relative", children: [
        /* @__PURE__ */ jsx72(
          "svg",
          {
            className: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24",
            children: /* @__PURE__ */ jsx72(
              "path",
              {
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 2,
                d: "M19 14l-7 7m0 0l-7-7m7 7V3"
              }
            )
          }
        ),
        hasNewMessages && newMessagesCount > 0 && /* @__PURE__ */ jsx72("span", { className: "absolute -bottom-4 -left-4 bg-gray-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center animate-pulse", children: newMessagesCount > 9 ? "9+" : newMessagesCount })
      ] })
    }
  );
};

// src/features/chatWindow/index.tsx
import { jsx as jsx73, jsxs as jsxs64 } from "react/jsx-runtime";
var ChatWindow = (props) => {
  const messagesEndRef = useRef5(null);
  const hasAutoScrolledRef = useRef5(false);
  const chatId = props.ticketId ? createChatId({ type: "ticket", ticketId: props.ticketId }) : createChatId({ type: "personal" });
  const {
    model,
    messages,
    isLoadingMore,
    hasMoreMessages,
    loadMessages,
    loadMoreMessages,
    setApi,
    error
  } = useChatModel(chatId);
  const {
    scrollContainerRef,
    showScrollButton,
    hasNewMessages,
    newMessagesCount
  } = useChatScroll({
    loadMore: () => loadMoreMessages(),
    enabled: true,
    messages,
    hasMoreMessages,
    isLoadingMore
  });
  useEffect14(() => {
    setApi(props.api);
  }, [setApi, props.api]);
  const scrollToBottom = useCallback11(
    (behavior = "auto") => {
      const container = scrollContainerRef.current;
      if (container) {
        container.scrollTop = container.scrollHeight;
      }
      messagesEndRef.current?.scrollIntoView({
        behavior,
        block: "end"
      });
    },
    [scrollContainerRef]
  );
  useEffect14(() => {
    loadMessages();
    const timeout = setTimeout(() => scrollToBottom("auto"), 200);
    return () => clearTimeout(timeout);
  }, [chatId, loadMessages, scrollToBottom]);
  useEffect14(() => {
    if (!props.autoScrollToBottomOnMount)
      return;
    if (hasAutoScrolledRef.current)
      return;
    if (messages.length === 0)
      return;
    hasAutoScrolledRef.current = true;
    requestAnimationFrame(() => {
      scrollToBottom("auto");
      requestAnimationFrame(() => scrollToBottom("auto"));
    });
  }, [messages.length, props.autoScrollToBottomOnMount, scrollToBottom]);
  useEffect14(() => {
    hasAutoScrolledRef.current = false;
  }, [chatId]);
  return /* @__PURE__ */ jsx73(ChatWindowModelProvider, { value: model, children: /* @__PURE__ */ jsxs64(
    "div",
    {
      className: `flex flex-col rounded-lg bg-white ${props.className || ""}`,
      children: [
        /* @__PURE__ */ jsx73(
          ChatMessageList,
          {
            variant: props.messageListVariant,
            scrollContainerRef,
            messagesEndRef
          }
        ),
        /* @__PURE__ */ jsxs64(
          "div",
          {
            className: ` bg-white relative  border-t-gray-200 border-t ${props.messageListVariant === "ticket" ? "-mx-6 px-4 pt-6 mt-6" : " p-3"}`,
            children: [
              error && /* @__PURE__ */ jsx73("div", { className: "mb-2 text-sm text-red-600", role: "alert", children: error }),
              showScrollButton && /* @__PURE__ */ jsx73("div", { className: "absolute -top-12 right-4 z-10", children: /* @__PURE__ */ jsx73(
                ScrollToBottomBtn,
                {
                  onClick: () => scrollToBottom("smooth"),
                  hasNewMessages,
                  newMessagesCount
                }
              ) }),
              /* @__PURE__ */ jsx73(MessageInput, {})
            ]
          }
        )
      ]
    }
  ) });
};

// src/widgets/supportChatModal/ui/chatToggle/chatToggle.tsx
import { Icon as Icon21 } from "@acme/assets";
import { Fragment as Fragment21, jsx as jsx74, jsxs as jsxs65 } from "react/jsx-runtime";
var ChatToggle = ({ onClick, hasNewMessages }) => {
  return /* @__PURE__ */ jsxs65(
    "button",
    {
      onClick,
      className: "chat-toggle flex items-center justify-between gap-3 text-gray-700 hover:text-brand-primary-default transition-colors text-left",
      children: [
        /* @__PURE__ */ jsx74("span", { className: "flex-grow", children: "\u0427\u0430\u0442 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438" }),
        /* @__PURE__ */ jsxs65("div", { className: "relative", children: [
          /* @__PURE__ */ jsx74(Icon21, { name: "message-dots-outline" }),
          hasNewMessages && /* @__PURE__ */ jsxs65(Fragment21, { children: [
            /* @__PURE__ */ jsx74("div", { className: "absolute -top-1 -right-2 w-3 h-3 bg-brand-purple-900 rounded-full animate-ping" }),
            /* @__PURE__ */ jsx74("div", { className: "absolute -top-1 -right-2 w-3 h-3 bg-brand-purple-900 rounded-full" })
          ] })
        ] })
      ]
    }
  );
};

// src/widgets/supportChatModal/ui/supportChatModal.tsx
import { Fragment as Fragment22, jsx as jsx75, jsxs as jsxs66 } from "react/jsx-runtime";
var SupportChatModal = (props) => {
  const chatWindowRef = useRef6(null);
  const [isOpen, setIsOpen] = useState21(false);
  const toggleChat = () => setIsOpen((prev) => !prev);
  const closeChat = () => setIsOpen(false);
  useEffect15(() => {
    const handleClickOutside = (event) => {
      if (chatWindowRef.current && !chatWindowRef.current.contains(event.target) && !event.target.closest(".chat-toggle")) {
        closeChat();
      }
    };
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);
  return /* @__PURE__ */ jsxs66(Fragment22, { children: [
    /* @__PURE__ */ jsx75(ChatToggle, { onClick: toggleChat, hasNewMessages: false }),
    isOpen && createPortal(
      /* @__PURE__ */ jsx75(
        "div",
        {
          ref: chatWindowRef,
          className: "fixed left-64 bottom-4 w-[375px] h-[800px] z-50",
          children: /* @__PURE__ */ jsxs66("div", { className: "flex flex-col rounded-lg border bg-white h-full", children: [
            /* @__PURE__ */ jsxs66("div", { className: "bg-white p-4 flex justify-between items-center border-b border-gray-200", children: [
              /* @__PURE__ */ jsx75("div", { className: "flex items-center font-semibold text-lg leading-relaxed tracking-normal text-gray-900", children: "\u0427\u0430\u0442 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438" }),
              /* @__PURE__ */ jsx75(
                "button",
                {
                  onClick: closeChat,
                  className: "text-gray-400 hover:text-black text-xl w-3 h-3 flex items-center justify-center",
                  children: "\xD7"
                }
              )
            ] }),
            /* @__PURE__ */ jsx75(
              ChatWindow,
              {
                className: "flex-1 min-h-0",
                autoScrollToBottomOnMount: true,
                api: {
                  companionLabelText: props.companionLabelText,
                  loadChatHistory: props.loadChatHistory,
                  sendMessage: props.sendMessage,
                  getAttachmentReq: props.getAttachmentReq
                }
              }
            )
          ] })
        }
      ),
      document.body
    )
  ] });
};

// src/widgets/tickets/ui/createTicketForm.tsx
import {
  DropdownSelect as DropdownSelect2,
  FileUpload as FileUpload2,
  Textarea as Textarea5
} from "@acme/foundation";
import { Button as Button27, Label as Label5, TextInput as TextInput8 } from "flowbite-react";
import { useState as useState22 } from "react";
import { jsx as jsx76, jsxs as jsxs67 } from "react/jsx-runtime";
var CreateTicketForm = ({
  categories,
  applications = [],
  createTicket,
  onSuccess
}) => {
  const [categoryId, setCategoryId] = useState22("");
  const [applicationId, setApplicationId] = useState22("");
  const [subject, setSubject] = useState22("");
  const [message, setMessage] = useState22("");
  const [files, setFiles] = useState22([]);
  const [loading, setLoading] = useState22(false);
  const [error, setError] = useState22(null);
  const isApplicationRequired = categoryId === "10";
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!message || !subject || !categoryId) {
      setError("\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0437\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u0435 \u0432\u0441\u0435 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u043F\u043E\u043B\u044F");
      return;
    }
    if (isApplicationRequired && !applicationId) {
      setError("\u0414\u043B\u044F \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u0439 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u0438 \u043D\u0443\u0436\u043D\u043E \u0443\u043A\u0430\u0437\u0430\u0442\u044C \u043D\u043E\u043C\u0435\u0440 \u0437\u0430\u044F\u0432\u043A\u0438");
      return;
    }
    try {
      setLoading(true);
      setError(null);
      const ticket = await createTicket({
        categoryId: parseInt(categoryId),
        subject,
        message,
        applicationId: applicationId || void 0,
        files: files.length > 0 ? files : void 0
      });
      onSuccess?.(ticket);
    } catch (err) {
      setError("\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0438 \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u044F. \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u043E\u0437\u0436\u0435.");
      console.error("\u041E\u0448\u0438\u0431\u043A\u0430 \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u044F \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u044F:", err);
    } finally {
      setLoading(false);
    }
  };
  return /* @__PURE__ */ jsxs67("form", { onSubmit: handleSubmit, className: "flex flex-col shadow-md", children: [
    /* @__PURE__ */ jsxs67("div", { className: "bg-white border border-gray-200 border-b-0 rounded-t-lg p-6", children: [
      /* @__PURE__ */ jsx76("h2", { className: "text-xl font-semibold text-gray-900 mb-6", children: "\u041E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u0435 \u0432 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0443" }),
      /* @__PURE__ */ jsxs67("div", { className: "grid grid-cols-2 gap-6 mb-6", children: [
        /* @__PURE__ */ jsxs67("div", { className: "flex flex-col gap-2", children: [
          /* @__PURE__ */ jsx76(
            Label5,
            {
              htmlFor: "category",
              className: "text-sm font-medium text-gray-600",
              children: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u044F"
            }
          ),
          /* @__PURE__ */ jsx76(
            DropdownSelect2,
            {
              options: categories,
              value: categoryId,
              onChange: (next) => {
                setCategoryId(next);
                setError(null);
              },
              placeholder: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044E \u043E\u0448\u0438\u0431\u043A\u0438"
            }
          )
        ] }),
        /* @__PURE__ */ jsxs67("div", { className: "flex flex-col gap-2", children: [
          /* @__PURE__ */ jsxs67(
            Label5,
            {
              htmlFor: "application",
              className: "text-sm font-medium text-gray-600",
              children: [
                "\u041D\u043E\u043C\u0435\u0440 \u0437\u0430\u044F\u0432\u043A\u0438 ",
                isApplicationRequired ? "" : "(\u043D\u0435\u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E)"
              ]
            }
          ),
          /* @__PURE__ */ jsx76(
            DropdownSelect2,
            {
              clearable: true,
              options: applications,
              value: applicationId,
              onChange: (next) => {
                setApplicationId(next);
                setError(null);
              },
              placeholder: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043D\u043E\u043C\u0435\u0440"
            }
          )
        ] }),
        /* @__PURE__ */ jsx76(FileUpload2, { onFileSelect: setFiles, maxSize: 10, disabled: loading }),
        /* @__PURE__ */ jsxs67("div", { className: "flex flex-col gap-6", children: [
          /* @__PURE__ */ jsxs67("div", { className: "flex flex-col gap-2", children: [
            /* @__PURE__ */ jsx76(
              Label5,
              {
                htmlFor: "subject",
                className: "text-sm font-medium text-gray-600",
                children: "\u0422\u0435\u043C\u0430"
              }
            ),
            /* @__PURE__ */ jsx76(
              TextInput8,
              {
                id: "subject",
                placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0442\u0435\u043C\u0443 \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u044F",
                value: subject,
                onChange: (e) => setSubject(e.target.value),
                disabled: loading,
                required: true,
                className: "bg-gray-50 border-gray-300"
              }
            )
          ] }),
          /* @__PURE__ */ jsxs67("div", { className: "flex flex-col gap-2", children: [
            /* @__PURE__ */ jsx76(
              Label5,
              {
                htmlFor: "message",
                className: "text-sm font-medium text-gray-600",
                children: "\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435"
              }
            ),
            /* @__PURE__ */ jsx76(
              Textarea5,
              {
                placeholder: "\u041D\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u0437\u0434\u0435\u0441\u044C \u0432\u0430\u0448\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435",
                value: message,
                onChange: setMessage,
                rows: 8,
                required: true,
                disabled: loading
              }
            )
          ] })
        ] })
      ] }),
      error && /* @__PURE__ */ jsx76("div", { className: "mt-4 text-sm text-red-600 bg-red-50 p-3 rounded-lg", children: error })
    ] }),
    /* @__PURE__ */ jsx76("div", { className: "bg-white border border-gray-200 rounded-b-lg p-6 flex justify-end", children: /* @__PURE__ */ jsx76(
      Button27,
      {
        color: "primary",
        type: "submit",
        disabled: loading || !message || isApplicationRequired && !applicationId,
        className: "px-6 py-2",
        children: loading ? "\u041E\u0442\u043F\u0440\u0430\u0432\u043A\u0430..." : "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u0435"
      }
    ) })
  ] });
};

// src/widgets/tickets/ui/ticketsFilters.tsx
import { Icon as Icon22 } from "@acme/assets";
import { FilterDropdown, Input } from "@acme/foundation";
import { useMemo as useMemo9 } from "react";
import { jsx as jsx77, jsxs as jsxs68 } from "react/jsx-runtime";
var getTicketsDateRange = (period) => {
  if (period === "all")
    return {};
  const now = /* @__PURE__ */ new Date();
  const days = period === "7d" ? 7 : 30;
  const from = new Date(now.getTime() - days * 24 * 60 * 60 * 1e3);
  return {
    dateFrom: from.toISOString(),
    dateTo: now.toISOString()
  };
};
var getTicketsApiParams = (value) => {
  const { dateFrom, dateTo } = getTicketsDateRange(value.period);
  return {
    statusId: value.statusId,
    categoryId: value.categoryId,
    dateFrom,
    dateTo
  };
};
var TicketsFilters = (props) => {
  const statusOptions = useMemo9(
    () => [
      { value: void 0, label: "\u0412\u0441\u0435" },
      { value: 10, label: "\u041E\u0436\u0438\u0434\u0430\u0435\u0442 \u043E\u0442\u0432\u0435\u0442\u0430" },
      { value: 20, label: "\u0412 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0435" },
      { value: 30, label: "\u0417\u0430\u043A\u0440\u044B\u0442\u043E" }
    ],
    []
  );
  const categoryOptions = useMemo9(
    () => [
      { value: void 0, label: "\u0412\u0441\u0435" },
      { value: 10, label: "\u0417\u0430\u044F\u0432\u043A\u0430" },
      { value: 20, label: "\u0414\u043E\u0433\u043E\u0432\u043E\u0440" },
      { value: 30, label: "\u0422\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u043E\u0448\u0438\u0431\u043A\u0430" },
      { value: 40, label: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B" },
      { value: 50, label: "\u0414\u0440\u0443\u0433\u043E\u0435" }
    ],
    []
  );
  const periodOptions = useMemo9(
    () => [
      { value: "all", label: "\u0412\u0441\u0435 \u0432\u0440\u0435\u043C\u044F" },
      { value: "7d", label: "7 \u0434\u043D\u0435\u0439" },
      { value: "30d", label: "30 \u0434\u043D\u0435\u0439" }
    ],
    []
  );
  return /* @__PURE__ */ jsxs68(
    "div",
    {
      className: `flex flex-wrap justify-between items-center gap-3 ${props.className || ""}`,
      children: [
        /* @__PURE__ */ jsxs68("div", { className: "flex items-center gap-3", children: [
          /* @__PURE__ */ jsx77(
            FilterDropdown,
            {
              title: "\u0421\u0442\u0430\u0442\u0443\u0441",
              value: props.value.statusId,
              options: statusOptions,
              onChange: (statusId) => props.onChange({ ...props.value, statusId })
            }
          ),
          /* @__PURE__ */ jsx77(
            FilterDropdown,
            {
              title: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F",
              value: props.value.categoryId,
              options: categoryOptions,
              onChange: (categoryId) => props.onChange({ ...props.value, categoryId })
            }
          ),
          /* @__PURE__ */ jsx77(
            FilterDropdown,
            {
              title: "\u041F\u0435\u0440\u0438\u043E\u0434",
              value: props.value.period,
              options: periodOptions,
              onChange: (period) => props.onChange({
                ...props.value,
                period: period ?? "all"
              })
            }
          )
        ] }),
        /* @__PURE__ */ jsx77("div", { children: /* @__PURE__ */ jsx77(
          Input,
          {
            value: props.value.search,
            onChange: (search) => props.onChange({ ...props.value, search }),
            placeholder: props.searchPlaceholder ?? "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u044E\u2026",
            leftIcon: /* @__PURE__ */ jsx77(Icon22, { name: "search-outline", size: 16 }),
            className: "w-full sm:w-80"
          }
        ) })
      ]
    }
  );
};

// src/widgets/tickets/ui/ticketsTable.tsx
import { Image as Image10 } from "@acme/assets";
import { TicketStatusBadge } from "@acme/domains";
import {
  Table as Table7,
  TableBody as TableBody7,
  TableCell as TableCell7,
  TableHead as TableHead7,
  TableHeadCell as TableHeadCell7,
  TableRow as TableRow7
} from "flowbite-react";
import { jsx as jsx78, jsxs as jsxs69 } from "react/jsx-runtime";
var formatDate3 = (dateString) => {
  if (!dateString)
    return "\u2014";
  const date = new Date(dateString);
  return new Intl.DateTimeFormat("ru-RU", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  }).format(date);
};
var TicketsTable = ({
  tickets,
  onRowClick
}) => {
  return /* @__PURE__ */ jsx78("div", { className: "bg-white border border-gray-200 rounded-lg p-6", children: tickets.length === 0 ? /* @__PURE__ */ jsxs69("div", { className: "flex flex-col items-center justify-center py-16 px-6", children: [
    /* @__PURE__ */ jsx78("div", { className: "w-40 h-40 mb-6", children: /* @__PURE__ */ jsx78(
      Image10,
      {
        name: "mailbox",
        width: "100%",
        height: "100%",
        alt: "Mailbox",
        className: "object-contain"
      }
    ) }),
    /* @__PURE__ */ jsx78("p", { className: "text-base text-gray-500 text-center", children: "\u041D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E" })
  ] }) : /* @__PURE__ */ jsx78("div", { className: "overflow-x-auto", children: /* @__PURE__ */ jsxs69(Table7, { children: [
    /* @__PURE__ */ jsx78(TableHead7, { className: "bg-gray-50", children: /* @__PURE__ */ jsxs69(TableRow7, { children: [
      /* @__PURE__ */ jsx78(TableHeadCell7, { className: "py-4 px-4 text-xs font-semibold text-gray-500 uppercase", children: "ID" }),
      /* @__PURE__ */ jsx78(TableHeadCell7, { className: "py-4 px-4 text-xs font-semibold text-gray-500 uppercase", children: "\u041D\u043E\u043C\u0435\u0440 \u0437\u0430\u044F\u0432\u043A\u0438" }),
      /* @__PURE__ */ jsx78(TableHeadCell7, { className: "py-4 px-4 text-xs font-semibold text-gray-500 uppercase", children: "\u041E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u043E" }),
      /* @__PURE__ */ jsx78(TableHeadCell7, { className: "py-4 px-4 text-xs font-semibold text-gray-500 uppercase", children: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F" }),
      /* @__PURE__ */ jsx78(TableHeadCell7, { className: "py-4 px-4 text-xs font-semibold text-gray-500 uppercase", children: "\u0422\u0435\u043C\u0430" }),
      /* @__PURE__ */ jsx78(TableHeadCell7, { className: "py-4 px-4 text-xs font-semibold text-gray-500 uppercase", children: "\u0421\u0442\u0430\u0442\u0443\u0441" })
    ] }) }),
    /* @__PURE__ */ jsx78(TableBody7, { className: "divide-y divide-gray-200", children: tickets.map((ticket) => {
      return /* @__PURE__ */ jsxs69(
        TableRow7,
        {
          className: "bg-white hover:bg-gray-50 cursor-pointer",
          onClick: () => ticket.id && onRowClick?.(ticket.id),
          children: [
            /* @__PURE__ */ jsxs69(TableCell7, { className: "py-4 px-4 text-sm text-gray-900 whitespace-nowrap", children: [
              "#",
              ticket.number || "\u2014"
            ] }),
            /* @__PURE__ */ jsx78(TableCell7, { className: "py-4 px-4 text-sm text-gray-900 whitespace-nowrap", children: ticket.applicationCode || "\u2014" }),
            /* @__PURE__ */ jsx78(TableCell7, { className: "py-4 px-4 text-sm text-gray-900 whitespace-nowrap", children: formatDate3(ticket.updateAt) }),
            /* @__PURE__ */ jsx78(TableCell7, { className: "py-4 px-4 text-sm text-gray-900", children: ticket.categoryId?.name || "\u2014" }),
            /* @__PURE__ */ jsx78(TableCell7, { className: "py-4 px-4 text-sm text-gray-900", children: ticket.subject || "\u2014" }),
            /* @__PURE__ */ jsx78(TableCell7, { className: "py-4 px-4", children: /* @__PURE__ */ jsx78(
              TicketStatusBadge,
              {
                statusId: ticket.status?.id,
                size: "sm"
              }
            ) })
          ]
        },
        ticket.id
      );
    }) })
  ] }) }) });
};

// src/widgets/users/usersTable.tsx
import {
  Badge as Badge4,
  Button as Button28,
  Spinner as Spinner6,
  Table as Table8,
  TableBody as TableBody8,
  TableCell as TableCell8,
  TableHead as TableHead8,
  TableHeadCell as TableHeadCell8,
  TableRow as TableRow8
} from "flowbite-react";
import { jsx as jsx79, jsxs as jsxs70 } from "react/jsx-runtime";
var UsersTable = ({
  users,
  loading = false,
  onRowClick,
  onApprove,
  onReject
}) => {
  const formatDate4 = (dateString) => {
    if (!dateString)
      return "-";
    return new Date(dateString).toLocaleDateString("ru-RU", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    });
  };
  const getStatusBadge = (status) => {
    const statusMap = {
      0: { color: "warning", label: "\u041E\u0436\u0438\u0434\u0430\u0435\u0442 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F" },
      1: { color: "info", label: "\u041E\u0436\u0438\u0434\u0430\u0435\u0442 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0439" },
      10: { color: "success", label: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D" },
      [-1]: { color: "failure", label: "\u0417\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D" }
    };
    const statusInfo = statusMap[status] || {
      color: "gray",
      label: "\u041D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u043E"
    };
    return /* @__PURE__ */ jsx79(Badge4, { color: statusInfo.color, children: statusInfo.label });
  };
  if (loading) {
    return /* @__PURE__ */ jsx79("div", { className: "bg-white rounded-lg shadow-md p-6", children: /* @__PURE__ */ jsxs70("div", { className: "flex items-center justify-center py-8", children: [
      /* @__PURE__ */ jsx79(Spinner6, { size: "lg" }),
      /* @__PURE__ */ jsx79("span", { className: "ml-3 text-gray-600", children: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439..." })
    ] }) });
  }
  return /* @__PURE__ */ jsx79("div", { className: "bg-white rounded-lg shadow-md overflow-hidden", children: /* @__PURE__ */ jsx79("div", { className: "overflow-x-auto", children: /* @__PURE__ */ jsxs70(Table8, { hoverable: true, children: [
    /* @__PURE__ */ jsx79(TableHead8, { children: /* @__PURE__ */ jsxs70(TableRow8, { children: [
      /* @__PURE__ */ jsx79(TableHeadCell8, { children: "\u0418\u043C\u044F" }),
      /* @__PURE__ */ jsx79(TableHeadCell8, { children: "\u041E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F" }),
      /* @__PURE__ */ jsx79(TableHeadCell8, { children: "\u0421\u0442\u0430\u0442\u0443\u0441" }),
      /* @__PURE__ */ jsx79(TableHeadCell8, { children: "\u0414\u0430\u0442\u0430 \u043F\u0435\u0440\u0435\u0445\u043E\u0434\u0430" }),
      /* @__PURE__ */ jsx79(TableHeadCell8, { children: "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u043F\u0435\u0440\u0435\u0445\u043E\u0434\u0430" }),
      /* @__PURE__ */ jsx79(TableHeadCell8, { children: /* @__PURE__ */ jsx79("span", { children: "\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u044F" }) })
    ] }) }),
    /* @__PURE__ */ jsx79(TableBody8, { className: "divide-y", children: users.length === 0 ? /* @__PURE__ */ jsx79(TableRow8, { children: /* @__PURE__ */ jsx79(
      TableCell8,
      {
        colSpan: 6,
        className: "text-center py-12 text-gray-500",
        children: "\u041D\u0435\u0442 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439 \u0434\u043B\u044F \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F"
      }
    ) }) : users.map((user) => /* @__PURE__ */ jsxs70(
      TableRow8,
      {
        className: `bg-white dark:border-gray-700 dark:bg-gray-800 ${onRowClick ? "cursor-pointer" : ""}`,
        onClick: () => onRowClick?.(user.id || ""),
        children: [
          /* @__PURE__ */ jsx79(TableCell8, { className: "whitespace-nowrap font-medium text-gray-900 dark:text-white", children: user.name || "-" }),
          /* @__PURE__ */ jsx79(TableCell8, { className: "whitespace-nowrap text-gray-500", children: user.organizationName || "-" }),
          /* @__PURE__ */ jsx79(TableCell8, { children: getStatusBadge(user.status) }),
          /* @__PURE__ */ jsx79(TableCell8, { className: "whitespace-nowrap text-gray-500", children: formatDate4(user.transitionAt) }),
          /* @__PURE__ */ jsx79(TableCell8, { className: "text-gray-500 max-w-xs truncate", children: user.transitionDescription || "-" }),
          /* @__PURE__ */ jsx79(TableCell8, { className: "whitespace-nowrap", children: /* @__PURE__ */ jsxs70("div", { className: "flex gap-2", children: [
            /* @__PURE__ */ jsx79(
              Button28,
              {
                color: "primary",
                onClick: (e) => {
                  e.stopPropagation();
                  onApprove?.(user.id || "");
                },
                children: "\u041E\u0434\u043E\u0431\u0440\u0438\u0442\u044C"
              }
            ),
            /* @__PURE__ */ jsx79(
              Button28,
              {
                color: "secondary",
                onClick: (e) => {
                  e.stopPropagation();
                  onReject?.(user.id || "");
                },
                children: "\u041E\u0442\u043A\u043B\u043E\u043D\u0438\u0442\u044C"
              }
            )
          ] }) })
        ]
      },
      user.id
    )) })
  ] }) }) });
};

// src/features/applicationlist/model/createApplicationListModel.ts
import { createEffect as createEffect5, createEvent as createEvent5, createStore as createStore5, sample as sample5 } from "effector";
function createApplicationListModel(config2) {
  const { fetch, defaultPageSize = 20 } = config2;
  const listOpened = createEvent5();
  const epochChanged = createEvent5();
  const pageChanged = createEvent5();
  const pageSizeChanged = createEvent5();
  const loadFx = createEffect5(
    async (params) => {
      const res = await fetch(params);
      const sorted = res.items?.sort((a, b) => {
        const aVal = a.createdAt ?? "";
        const bVal = b.createdAt ?? "";
        return new Date(bVal).getTime() - new Date(aVal).getTime();
      }) ?? [];
      return { ...res, items: sorted };
    }
  );
  const $epochId = createStore5(null).on(
    epochChanged,
    (_, v) => v
  );
  const $pageNumber = createStore5(1).on(loadFx.doneData, (_, d) => d.pageNumber).on(pageChanged, (_, v) => v).on(listOpened, () => 1).on(epochChanged, () => 1).on(pageSizeChanged, () => 1);
  const $pageSize = createStore5(defaultPageSize).on(loadFx.doneData, (_, d) => d.pageSize).on(pageSizeChanged, (_, v) => v).on(listOpened, () => defaultPageSize);
  const $items = createStore5([]).on(loadFx.doneData, (_, d) => d.items).on(loadFx.failData, () => []);
  const $totalCount = createStore5(0).on(loadFx.doneData, (_, d) => d.totalCount).on(loadFx.failData, () => 0);
  const $isLoading = loadFx.pending;
  sample5({
    clock: listOpened,
    source: { epochId: $epochId, pageNumber: $pageNumber, pageSize: $pageSize },
    fn: (s) => ({
      epochId: s.epochId ?? void 0,
      pageNumber: s.pageNumber,
      pageSize: s.pageSize
    }),
    target: loadFx
  });
  sample5({
    clock: epochChanged,
    fn: (epochId) => ({
      epochId: epochId ?? void 0,
      pageNumber: 1,
      pageSize: defaultPageSize
    }),
    target: loadFx
  });
  sample5({
    clock: pageChanged,
    source: { epochId: $epochId, pageSize: $pageSize },
    fn: (s, pageNumber) => ({
      epochId: s.epochId ?? void 0,
      pageNumber,
      pageSize: s.pageSize
    }),
    target: loadFx
  });
  sample5({
    clock: pageSizeChanged,
    source: { epochId: $epochId, pageNumber: $pageNumber },
    fn: (s, pageSize) => ({
      epochId: s.epochId ?? void 0,
      pageNumber: 1,
      pageSize
    }),
    target: loadFx
  });
  return {
    $items,
    $totalCount,
    $pageNumber,
    $pageSize,
    $isLoading,
    $epochId,
    listOpened,
    epochChanged,
    pageChanged,
    pageSizeChanged
  };
}

// src/features/organizationlForm/index.tsx
import { organizationFormConfig } from "@acme/domains";
import {
  FormControls as FormControls6,
  useFormModel as useFormModel6
} from "@acme/foundation";
import { Card as Card2 } from "flowbite-react";
import { useMemo as useMemo10 } from "react";
import { jsx as jsx80, jsxs as jsxs71 } from "react/jsx-runtime";
var OrganizationGeneralForm = ({
  defaultData,
  isEdit,
  formRef,
  onDataChange,
  headerExtra,
  headerActions
}) => {
  const formConfig = useMemo10(() => {
    const config2 = organizationFormConfig();
    config2.controls.forEach(
      (control) => {
        if (!control.rules)
          control.rules = [];
        control.rules.push({
          when: () => !isEdit,
          set: { disabled: true }
        });
      }
    );
    return config2;
  }, [isEdit]);
  const form = useFormModel6({
    config: formConfig,
    ctx: defaultData || {}
  });
  if (formRef) {
    formRef.current = {
      submit: async () => {
        let formData = null;
        await form.submit(async (finalModel) => {
          formData = finalModel;
          onDataChange?.(finalModel);
        });
        return formData;
      }
    };
  }
  return /* @__PURE__ */ jsxs71(Card2, { children: [
    /* @__PURE__ */ jsxs71("div", { className: "mb-6 flex items-start justify-between gap-6", children: [
      /* @__PURE__ */ jsxs71("div", { className: "flex items-center gap-3", children: [
        /* @__PURE__ */ jsx80("h2", { className: "text-xl font-semibold", children: "\u041E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F" }),
        headerExtra
      ] }),
      headerActions
    ] }),
    /* @__PURE__ */ jsx80("div", { className: "flex flex-col gap-6", children: /* @__PURE__ */ jsx80("div", { className: "grid grid-cols-3 gap-6", children: /* @__PURE__ */ jsx80(FormControls6, { form }) }) })
  ] });
};

// src/features/pdfViewer/hooks/usePdfFile.ts
import { ActionService } from "@acme/api";
import { useCertificates as useCertificates2, useUser as useUser2 } from "@acme/domains";
import { useState as useState23 } from "react";

// src/features/sign/index.ts
import {
  createDetachedSignature,
  createHash
} from "crypto-pro";
var getDetachedSignature = async (secret, cert) => {
  const hash = await createHash(secret);
  const sign = await createDetachedSignature(cert.thumbprint, hash);
  return sign;
};

// src/features/pdfViewer/hooks/usePdfFile.ts
var usePdfFile = (props) => {
  const { validCurrentCertificate } = useCertificates2();
  const { user } = useUser2();
  const [blob, setBlob] = useState23(null);
  const [isDocumentLoading, setIsDocumentLoading] = useState23(false);
  const [arrayBuffer, setArrayBuffer] = useState23(null);
  const [isLoading, setIsLoading] = useState23(false);
  const [error, setError] = useState23(null);
  const [errorLoadFile, setErrorLoadFile] = useState23(null);
  const loadPdfFile = async () => {
    setIsLoading(true);
    setErrorLoadFile(null);
    if (blob) {
      try {
        console.log("loadPdfFile");
      } catch (error2) {
        console.error("Error loading PDF:", error2);
        setErrorLoadFile("\u041E\u0448\u0438\u0431\u043A\u0430 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438 PDF \u0444\u0430\u0439\u043B\u0430");
      } finally {
        setIsLoading(false);
      }
    }
  };
  const getDocument = async (actionId) => {
    if (actionId && !isDocumentLoading && !blob) {
      setIsDocumentLoading(true);
      try {
        const pdfBlob = await ActionService.getApiV1ActionDocument({
          id: actionId
        });
        if (pdfBlob) {
          try {
            const buffer = await pdfBlob.arrayBuffer();
            setArrayBuffer(buffer);
          } catch (error2) {
            console.error("Error loading PDF:", error2);
            setError("\u041E\u0448\u0438\u0431\u043A\u0430 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438 PDF \u0444\u0430\u0439\u043B\u0430");
          } finally {
            setIsDocumentLoading(false);
          }
          setBlob(pdfBlob);
        }
        setIsDocumentLoading(false);
      } catch (error2) {
        console.log(error2);
      } finally {
        setIsDocumentLoading(false);
      }
    }
  };
  const handleSignAction = async (actionId) => {
    if (actionId && arrayBuffer && user) {
      const certificate = validCurrentCertificate(user);
      if (certificate) {
        const detachedSignatureBase64t = await getDetachedSignature(
          arrayBuffer,
          certificate
        );
        const res = await ActionService.postApiV1ActionSign({
          id: actionId,
          requestBody: {
            detachedSignatureBase64t
          }
        });
        if (res.isSuccess) {
          props?.onSuccessSign?.();
        }
      }
    }
  };
  return {
    blob,
    arrayBuffer,
    isLoading,
    error,
    errorLoadFile,
    loadPdfFile,
    getDocument,
    isDocumentLoading,
    handleSignAction
  };
};

// src/features/pdfViewer/pdfViewer.tsx
import { Button as Button29 } from "flowbite-react";
import { useEffect as useEffect16, useRef as useRef7, useState as useState24 } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";
import { jsx as jsx81, jsxs as jsxs72 } from "react/jsx-runtime";
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
var PdfViewer = ({
  file,
  className = ""
}) => {
  const [numPages, setNumPages] = useState24(0);
  const [pageNumber, setPageNumber] = useState24(1);
  const [scale, setScale] = useState24(1);
  const [containerWidth, setContainerWidth] = useState24(
    void 0
  );
  const containerRef = useRef7(null);
  useEffect16(() => {
    const updateWidth = () => {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.offsetWidth);
      }
    };
    updateWidth();
    const resizeObserver = new window.ResizeObserver(updateWidth);
    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }
    return () => {
      resizeObserver.disconnect();
    };
  }, []);
  const onDocumentLoadSuccess = ({ numPages: numPages2 }) => {
    setNumPages(numPages2);
    setPageNumber(1);
  };
  const changePage = (offset) => {
    setPageNumber((prevPageNumber) => prevPageNumber + offset);
  };
  const previousPage = () => {
    changePage(-1);
  };
  const nextPage = () => {
    changePage(1);
  };
  const zoomIn = () => {
    setScale((prevScale) => Math.min(prevScale + 0.2, 3));
  };
  const zoomOut = () => {
    setScale((prevScale) => Math.max(prevScale - 0.2, 0.5));
  };
  return /* @__PURE__ */ jsxs72("div", { className: `flex flex-col ${className}`, children: [
    /* @__PURE__ */ jsxs72("div", { className: "flex items-center justify-between mb-4 p-4 bg-gray-50 rounded-lg", children: [
      /* @__PURE__ */ jsxs72("div", { className: "flex items-center gap-4", children: [
        /* @__PURE__ */ jsx81(
          Button29,
          {
            color: "secondary",
            onClick: previousPage,
            disabled: pageNumber <= 1,
            children: "\u041F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0430\u044F"
          }
        ),
        /* @__PURE__ */ jsxs72("span", { className: "text-sm", children: [
          "\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430 ",
          pageNumber,
          " \u0438\u0437 ",
          numPages
        ] }),
        /* @__PURE__ */ jsx81(
          Button29,
          {
            color: "secondary",
            onClick: nextPage,
            disabled: pageNumber >= numPages,
            children: "\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0430\u044F"
          }
        )
      ] }),
      /* @__PURE__ */ jsxs72("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ jsx81(
          "button",
          {
            onClick: zoomOut,
            className: "px-3 py-1 bg-gray-500 text-white rounded hover:bg-gray-600",
            children: "-"
          }
        ),
        /* @__PURE__ */ jsxs72("span", { className: "text-sm min-w-[60px] text-center", children: [
          Math.round(scale * 100),
          "%"
        ] }),
        /* @__PURE__ */ jsx81(
          "button",
          {
            onClick: zoomIn,
            className: "px-3 py-1 bg-gray-500 text-white rounded hover:bg-gray-600",
            children: "+"
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ jsx81(
      "div",
      {
        ref: containerRef,
        className: "flex w-full justify-center border border-gray-200 rounded-lg overflow-auto",
        children: /* @__PURE__ */ jsx81(
          Document,
          {
            file,
            onLoadSuccess: onDocumentLoadSuccess,
            onLoadError: (error) => {
              console.error("Error loading PDF:", error);
            },
            loading: /* @__PURE__ */ jsxs72("div", { className: "flex items-center justify-center p-8", children: [
              /* @__PURE__ */ jsx81("div", { className: "animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500" }),
              /* @__PURE__ */ jsx81("span", { className: "ml-2", children: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 PDF..." })
            ] }),
            error: /* @__PURE__ */ jsx81("div", { className: "flex items-center justify-center p-8 text-red-500", children: "\u041E\u0448\u0438\u0431\u043A\u0430 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438 PDF \u0444\u0430\u0439\u043B\u0430" }),
            children: /* @__PURE__ */ jsx81(
              Page,
              {
                pageNumber,
                width: containerWidth ? containerWidth * scale : void 0,
                loading: /* @__PURE__ */ jsxs72("div", { className: "flex items-center justify-center p-8", children: [
                  /* @__PURE__ */ jsx81("div", { className: "animate-spin rounded-full h-6 w-6 border-b-2 border-blue-500" }),
                  /* @__PURE__ */ jsx81("span", { className: "ml-2", children: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B..." })
                ] })
              }
            )
          }
        )
      }
    )
  ] });
};

// src/features/ticketslist/model/createTicketsListModel.ts
import {
  combine,
  createEffect as createEffect6,
  createEvent as createEvent6,
  createStore as createStore6,
  sample as sample6
} from "effector";
function createTicketsListModel(config2) {
  const {
    fetch,
    getApiParams,
    getSearchHaystack,
    defaultPageSize = 20,
    initialFilters = {
      search: "",
      statusId: void 0,
      categoryId: void 0,
      period: "all"
    }
  } = config2;
  const listOpened = createEvent6();
  const filtersChanged = createEvent6();
  const pageChanged = createEvent6();
  const loadFx = createEffect6(
    async (params) => {
      return fetch(params);
    }
  );
  const $filters = createStore6(initialFilters).on(
    filtersChanged,
    (_, v) => v
  );
  const $apiParams = $filters.map(getApiParams);
  const $pageNumber = createStore6(1).on(pageChanged, (_, v) => v).on(listOpened, () => 1).on(filtersChanged, () => 1);
  const $pageSize = createStore6(defaultPageSize).on(listOpened, () => defaultPageSize);
  const $items = createStore6([]).on(loadFx.doneData, (_, d) => d.items).on(loadFx.failData, () => []);
  const $totalCount = createStore6(0).on(loadFx.doneData, (_, d) => d.totalCount).on(loadFx.failData, () => 0);
  const $error = createStore6(null).on(loadFx.doneData, () => null).on(loadFx.failData, () => "\u041E\u0448\u0438\u0431\u043A\u0430 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438 \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u0439. \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443.").on(listOpened, () => null).on(filtersChanged, () => null).on(pageChanged, () => null);
  const $isLoading = loadFx.pending;
  const $filteredItems = combine($items, $filters, (items, filters) => {
    const q = filters.search.trim().toLowerCase();
    if (!q)
      return items;
    return items.filter(
      (item) => getSearchHaystack(item).toLowerCase().includes(q)
    );
  });
  sample6({
    clock: listOpened,
    source: { apiParams: $apiParams, pageNumber: $pageNumber, pageSize: $pageSize },
    fn: ({ apiParams, pageNumber, pageSize }) => ({
      ...apiParams,
      pageNumber,
      pageSize
    }),
    target: loadFx
  });
  sample6({
    clock: filtersChanged,
    source: $pageSize,
    fn: (pageSize, filters) => ({
      ...getApiParams(filters),
      pageNumber: 1,
      pageSize
    }),
    target: loadFx
  });
  sample6({
    clock: pageChanged,
    source: { apiParams: $apiParams, pageSize: $pageSize },
    fn: ({ apiParams, pageSize }, pageNumber) => ({
      ...apiParams,
      pageNumber,
      pageSize
    }),
    target: loadFx
  });
  return {
    $items,
    $filteredItems,
    $totalCount,
    $pageNumber,
    $pageSize,
    $isLoading,
    $error,
    $filters,
    listOpened,
    filtersChanged,
    pageChanged
  };
}

// src/features/userForm/lib/userProfileService.ts
var createUserProfileService = (updateProfile) => {
  return {
    updateProfile
  };
};

// src/features/userForm/index.tsx
import {
  personalInfoFormConfig
} from "@acme/domains";
import {
  FormControls as FormControls7,
  useFormModel as useFormModel7
} from "@acme/foundation";
import { forwardRef, useMemo as useMemo11 } from "react";
import { jsx as jsx82 } from "react/jsx-runtime";
var UserGeneralForm = forwardRef(
  ({ onError, defaultData, errorsForm, isEdit, formRef, updateProfile }, _ref) => {
    const formConfig = useMemo11(() => {
      const config2 = personalInfoFormConfig(
        true
      );
      config2.controls.forEach(
        (control) => {
          if (!control.rules)
            control.rules = [];
          control.rules.push({
            when: () => !isEdit,
            set: { disabled: true }
          });
        }
      );
      return config2;
    }, [isEdit]);
    const form = useFormModel7({
      config: formConfig,
      ctx: defaultData || {}
    });
    if (formRef) {
      formRef.current = {
        submit: async () => {
          return form.submit(async (finalModel) => {
            try {
              const formData = {
                name: finalModel.person.name,
                email: finalModel.person.email,
                phoneNumber: finalModel.person.phoneNumber,
                inn: finalModel.person.inn,
                title: finalModel.person.title,
                passport: {
                  seriesNumber: finalModel.person.passport.seriesNumber,
                  dateIssue: finalModel.person.passport.dateIssue,
                  issued: finalModel.person.passport.issued
                }
              };
              await updateProfile(formData);
            } catch (error) {
              onError?.(
                error instanceof Error ? error.message : "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0438"
              );
              throw error;
            }
          });
        }
      };
    }
    return /* @__PURE__ */ jsx82("div", { className: "grid grid-cols-3 gap-6", children: /* @__PURE__ */ jsx82(FormControls7, { form }) });
  }
);
export {
  ActionResultScreen,
  AdminRateTable,
  AgentContractMainInfo,
  AgentRequisites,
  ApiErrorHandlerProvider,
  ApplicationActions,
  ApplicationActivity,
  ApplicationBaseInfo,
  ApplicationCard,
  ApplicationComments,
  ApplicationCompletedBanner,
  ApplicationCounterpartyOfferForm,
  ApplicationEpoch,
  ApplicationFormAgentInfo,
  ApplicationHistory,
  ApplicationListTable,
  ApplicationMainInfo,
  ApplicationParticipants,
  ApplicationSendOfferForm,
  ApplicationTitle,
  AuthPageLayout,
  AuthProvider,
  ChatWindow,
  Commission,
  ContractInfo,
  CreateTicketForm,
  CurrencyList,
  DEFAULT_ERROR_ROUTES,
  DigitalSignature,
  DigitalSignatureLogin,
  Documents,
  EExchangeTableState,
  ErrorPage,
  ErrorProvider,
  Esia,
  ExchangeRateTable,
  FaqAccordion,
  HelpSection,
  MessageHubProvider,
  OrganizationGeneralForm,
  OrganizationsTable,
  PdfViewer,
  ProvideWalletsModal,
  RecommendedExchangeRates,
  RejectModal,
  ReworkModal,
  RoleSelection,
  Sidebar,
  SupportChatModal as SupportChat,
  TicketsFilters,
  TicketsTable,
  TransactionIdModal,
  TransferFiatModal,
  TwoFactorPasswordInput,
  UploadDocumentModal,
  UserGeneralForm,
  UsersTable,
  clearAllChatModels,
  clearChatModel,
  createApplicationListModel,
  createChatModel,
  createTicketsListModel,
  createUserProfileService,
  findAction,
  formatDate2 as formatDate,
  getTicketsApiParams,
  getTicketsDateRange,
  initialCounterpartyOfferCtx,
  initialCtx2 as initialCtx,
  isShow,
  useChatModel,
  usePdfFile
};
//# sourceMappingURL=index.js.map